// ═══════════════════════════════════════════════════════════════════════════════
// CrickitMatch — App.jsx  (single-file React app, mirrors CricKit deployment pattern)
// ArcGain LLC · v4.81
//
// DEPLOY INSTRUCTIONS (same as CricKit):
//   1. Copy this file to src/App.jsx in your crickithub-app repo
//   2. Set REACT_APP_API_URL in Amplify env vars → your existing API Gateway URL
//   3. git add . && git commit -m "update" && git push  → Amplify auto-deploys
//
// LAMBDA: Paste the route block from lambda_additions.mjs into your EXISTING
//         CricKit Lambda handler. No new Lambda needed.
// ═══════════════════════════════════════════════════════════════════════════════

import { useState, useEffect, useRef, useCallback } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Chart } from "chart.js/auto";
const LOGO_IMG="data:image/jpeg;base64,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";


// ─── API base — set REACT_APP_API_URL in Amplify environment variables ────────
const API = process.env.REACT_APP_API_URL || "";

// ─── Hardcoded demo credentials (same pattern as CricKit) ────────────────────
// In production these are validated by Lambda against DynamoDB.
// Use "Forgot password?" to set real passwords after first login.
const DEMO_USERS = [
  { email:"superadmin@crickithub.com", password:"CrickitHub1969!", role:"SUPERADMIN", name:"Super Admin",        orgId:"ORG#SYSTEM"   },
  { email:"coach@lahub.com",           password:"coach123",         role:"COACH",      name:"Coach Ravi Kumar",   orgId:"ORG#LAHUB001" },
  { email:"manager@lahub.com",         password:"manager123",       role:"MANAGER",    name:"Manager Priya Shah", orgId:"ORG#LAHUB001" },
  { email:"player@lahub.com",          password:"player123",        role:"PLAYER",     name:"Arjun Sharma",       orgId:"ORG#LAHUB001" },
];

// ─── Role / quota constants ───────────────────────────────────────────────────
const ROLES = {
  BATTING:    { label:"Batting",      u13:[20,30], u15:[25,35] },
  BATTING_AR: { label:"Batting AR",   u13:[10,20], u15:[15,25] },
  BOWLING_AR: { label:"Bowling AR",   u13:[5,15],  u15:[10,20] },
  BOWLING:    { label:"Bowling",      u13:[0,10],  u15:[0,10]  },
  WK:         { label:"Wicketkeeper", u13:[20,30], u15:[25,35] },
};
const BOWL_QUOTA = {
  BOWLING:    { label:"Bowling Only", u13:[3,5], u15:[4,6] },
  BOWLING_AR: { label:"Bowling AR",   u13:[2,4], u15:[3,4] },
  BATTING_AR: { label:"Batting AR",   u13:[1,2], u15:[1,2] },
  BATTING:    { label:"Batting",      u13:[0,1], u15:[0,1] },
  WK:         { label:"Wicketkeeper", u13:[0,1], u15:[0,1] },
};

// ─── Nav tabs per role ────────────────────────────────────────────────────────
const NAV = {
  SUPERADMIN: [{id:"admin",     label:"SuperAdmin",        icon:"🏛"}],
  COACH:      [{id:"schedule",  label:"Schedule",          icon:"📅"},
               {id:"squad",     label:"Squad",             icon:"👥"},
               {id:"hubrules",  label:"Hub Rules",         icon:"📋"},
               {id:"batting",   label:"Batting",           icon:"🏏"},
               {id:"bowling",   label:"Bowling",           icon:"⚪"},
               {id:"fielding",  label:"Fielding",          icon:"🧤"},
               {id:"notes",     label:"Notes",             icon:"📝"},
               {id:"report",    label:"Report",            icon:"📊"},
               {id:"season",    label:"Analytics",         icon:"📈"}],
  MANAGER:    [{id:"schedule",  label:"Schedule",          icon:"📅"},
               {id:"squad",     label:"Squad",             icon:"👥"},
               {id:"logistics", label:"Logistics",         icon:"🚌"},
               {id:"notes",     label:"Notes",             icon:"📝"}],
  PLAYER:     [{id:"portal",    label:"My Stats",          icon:"🏏"},
               {id:"schedule",  label:"Schedule",          icon:"📅"},
               {id:"notes",     label:"Notes",             icon:"📝"}],
};

// ─── Shared style tokens ──────────────────────────────────────────────────────
const G = "#1A7A4A";
const cs = {
  card:     {background:"#fff",border:"0.5px solid rgba(0,0,0,0.09)",borderRadius:12,padding:"14px 16px",marginBottom:12,boxShadow:"0 1px 4px rgba(0,0,0,0.04)"},
  cardFeat: {background:"#fff",border:`1.5px solid ${G}`,borderRadius:12,padding:"14px 16px",marginBottom:12,boxShadow:`0 2px 12px rgba(26,122,74,0.10)`},
  cardBlue: {background:"#fff",border:"1.5px solid #185FA5",borderRadius:12,padding:"14px 16px",marginBottom:12,boxShadow:`0 2px 12px rgba(24,95,165,0.08)`},
  input:    {width:"100%",padding:"8px 10px",border:"0.5px solid rgba(0,0,0,0.18)",borderRadius:8,fontSize:13,fontFamily:"inherit",background:"#fff",color:"#1a1a1a"},
  select:   {padding:"7px 10px",border:"0.5px solid rgba(0,0,0,0.18)",borderRadius:8,fontSize:13,fontFamily:"inherit",background:"#fff",color:"#1a1a1a",cursor:"pointer"},
  textarea: {width:"100%",padding:"9px 10px",border:"0.5px solid rgba(0,0,0,0.18)",borderRadius:8,fontSize:13,fontFamily:"inherit",background:"#fff",color:"#1a1a1a",resize:"vertical",minHeight:76},
  label:    {fontSize:12,color:"#6b7280",display:"block",marginBottom:4},
  muted:    {fontSize:12,color:"#6b7280"},
  row:      {display:"flex",alignItems:"center",gap:8},
  rowWrap:  {display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"},
  divider:  {height:"0.5px",background:"rgba(0,0,0,0.08)",margin:"10px 0"},
  btnP:     {padding:"8px 18px",background:G,color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"},
  btnS:     {padding:"8px 16px",background:"transparent",color:G,border:`1px solid ${G}`,borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"},
  btnD:     {padding:"8px 16px",background:"#A32D2D",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"},
  btnG:     {padding:"6px 12px",background:"transparent",color:"#6b7280",border:"0.5px solid rgba(0,0,0,0.18)",borderRadius:6,fontSize:12,cursor:"pointer",fontFamily:"inherit"},
  badge:    (c)=>({display:"inline-block",fontSize:11,padding:"2px 8px",borderRadius:6,fontWeight:500,...(c==="green"?{background:"#e6f4ec",color:G}:c==="amber"?{background:"#faeeda",color:"#854F0B"}:c==="red"?{background:"#fcebeb",color:"#A32D2D"}:c==="blue"?{background:"#e6f1fb",color:"#185FA5"}:{background:"#f1efe8",color:"#5F5E5A"})}),
  alert:    (c)=>({background:c==="green"?"#e6f4ec":c==="amber"?"#faeeda":"#fcebeb",color:c==="green"?G:c==="amber"?"#854F0B":"#A32D2D",border:`0.5px solid ${c==="green"?"#9FE1CB":c==="amber"?"#FAC775":"#F09595"}`,borderRadius:8,padding:"8px 12px",fontSize:12,marginBottom:8}),
  qBar:     (p,c)=>({height:"100%",width:`${p}%`,borderRadius:4,background:c==="green"?G:c==="amber"?"#EF9F27":"#E24B4A",transition:"width .3s"}),
};

// ─── Tiny helpers ─────────────────────────────────────────────────────────────
const Badge = ({color,children})=><span style={cs.badge(color)}>{children}</span>;
const Divider = ()=><div style={cs.divider}/>;
const Muted = ({children})=><span style={cs.muted}>{children}</span>;
function AlertBox({type="red",msg,onClose}){
  if(!msg) return null;
  return <div style={cs.alert(type)}>{msg}{onClose&&<button onClick={onClose} style={{float:"right",background:"none",border:"none",cursor:"pointer",fontSize:14,color:"inherit"}}>×</button>}</div>;
}
function SectionHdr({title,sub}){
  return <div style={{marginBottom:14}}><div style={{fontSize:18,fontWeight:500,color:"#1a1a1a"}}>{title}</div>{sub&&<div style={{fontSize:13,color:"#6b7280",marginTop:2}}>{sub}</div>}</div>;
}
function isLegal(o){return o!=="Wd"&&o!=="Nb";}

// ═══════════════════════════════════════════════════════════════════════════════
// LOGIN  (with Forgot Password flow)
// ═══════════════════════════════════════════════════════════════════════════════
function Login({onLogin}){
  const [mode,setMode]=useState("login"); // "login"|"register"|"activate"|"orgpick"|"reset"|"confirm"
  const [regForm,setRegForm]=useState({orgName:"",coachName:"",email:"",password:"",confirm:""});
  const [actForm,setActForm]=useState({email:"",accessCode:"",password:"",confirm:""});
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [newPass,setNewPass]=useState("");
  const [confirm,setConfirm]=useState("");
  const [code,setCode]=useState("");
  const [err,setErr]=useState("");
  const [info,setInfo]=useState("");
  const [busy,setBusy]=useState(false);
  const [orgChoices,setOrgChoices]=useState([]); // [{orgId,orgName,role}]
  const inp={width:"100%",padding:"11px 14px",border:"0.5px solid rgba(0,0,0,0.20)",borderRadius:8,fontSize:16,fontFamily:"inherit",background:"#fff",color:"#1a1a1a"};
  const lbl={fontSize:15,fontWeight:700,color:"#1a1a1a",display:"block",marginBottom:5};

  async function doLogin(e){
    e.preventDefault();setErr("");setBusy(true);
    if(API){
      try{
        const r=await fetch(`${API}/crickithub/auth/login`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:email.trim().toLowerCase(),password:pass})});
        const d=await r.json();
        if(r.ok&&d.user){setBusy(false);onLogin(d.user);return;}
        // Multi-org: server returns orgs array for coach to pick
        if(r.ok&&d.orgs&&d.orgs.length>1){setBusy(false);setOrgChoices(d.orgs);setMode("orgpick");return;}
        if(r.ok&&d.orgs&&d.orgs.length===1){setBusy(false);onLogin(d.orgs[0]);return;}
        setErr(d.message||"Invalid credentials.");setBusy(false);return;
      }catch{setErr("Sign in failed — check your connection.");}
    }
    const u=DEMO_USERS.find(u=>u.email===email.trim().toLowerCase()&&u.password===pass);
    setBusy(false);
    if(!u){setErr("Invalid email or password.");return;}
    onLogin(u);
  }
  async function doRegister(e){
    e.preventDefault();setErr("");
    if(regForm.password!==regForm.confirm){setErr("Passwords do not match.");return;}
    if(regForm.password.length<8){setErr("Password must be at least 8 characters.");return;}
    if(!regForm.orgName.trim()){setErr("Academy / org name is required.");return;}
    setBusy(true);
    if(API){
      try{
        const r=await fetch(`${API}/crickithub/auth/register`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({orgName:regForm.orgName.trim(),coachName:regForm.coachName.trim(),coachEmail:regForm.email.trim().toLowerCase(),coachPassword:regForm.password,managerName:regForm.managerName||"",managerEmail:regForm.managerEmail||"",managerPassword:regForm.managerPassword||""})});
        const d=await r.json();
        if(r.ok){setInfo("Account created! Sign in with your email and password.");go("login");setEmail(regForm.email.trim().toLowerCase());}
        else setErr(d.message||"Registration failed.");
      }catch{setErr("Registration failed — check your connection.");}
    }
    setBusy(false);
  }
  async function doActivate(e){
    e.preventDefault();setErr("");
    if(actForm.password!==actForm.confirm){setErr("Passwords do not match.");return;}
    if(actForm.password.length<8){setErr("Password must be at least 8 characters.");return;}
    setBusy(true);
    if(API){
      try{
        const r=await fetch(`${API}/crickithub/auth/activate`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:actForm.email.trim().toLowerCase(),accessCode:actForm.accessCode.trim().toUpperCase(),password:actForm.password})});
        const d=await r.json();
        if(r.ok){setInfo("Account activated! Sign in with your email and password.");go("login");setEmail(actForm.email.trim().toLowerCase());}
        else setErr(d.message||"Activation failed.");
      }catch{setErr("Activation failed — check your connection.");}
    }
    setBusy(false);
  }
  function pickOrg(org){onLogin(org);}
  async function doResetReq(e){
    e.preventDefault();setErr("");setBusy(true);
    if(API){try{await fetch(`${API}/crickithub/auth/reset-request`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:email.trim().toLowerCase()})});}catch{}}
    setInfo("If that email exists a 6-digit code has been sent. Check your inbox.");
    setMode("confirm");setBusy(false);
  }
  async function doResetConfirm(e){
    e.preventDefault();setErr("");
    if(newPass!==confirm){setErr("Passwords do not match.");return;}
    if(newPass.length<8){setErr("Minimum 8 characters.");return;}
    setBusy(true);
    if(API){
      try{
        const r=await fetch(`${API}/crickithub/auth/reset-confirm`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:email.trim().toLowerCase(),code,newPassword:newPass})});
        const d=await r.json();
        if(!r.ok){setErr(d.message||"Invalid or expired code.");setBusy(false);return;}
      }catch{setErr("Reset failed — try again.");setBusy(false);return;}
    }
    setInfo("Password updated. Sign in with your new password.");
    setMode("login");setPass("");setNewPass("");setConfirm("");setCode("");setBusy(false);
  }
  const go=m=>{setMode(m);setErr("");setInfo("");};

  const GOLD="#EF9F27";
  const loginInp={width:"100%",padding:"13px 15px",border:"1.5px solid #dde8e2",borderRadius:10,fontSize:15,fontFamily:"inherit",background:"#fff",color:"#1a1a1a",boxSizing:"border-box",outline:"none",transition:"border-color .15s"};
  const loginLbl={fontSize:11,fontWeight:700,color:"#4a6358",textTransform:"uppercase",letterSpacing:"0.1em",display:"block",marginBottom:6};

  return(
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"linear-gradient(160deg,#0f4a2c 0%,#1A7A4A 45%,#1e6b44 100%)"}}>
      <div style={{width:390,background:"#fff",borderRadius:20,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.28)",margin:"16px"}}>

        {/* ── Top banner ── */}
        <div style={{background:"linear-gradient(135deg,#0f4a2c 0%,#1A7A4A 100%)",padding:"36px 28px 32px",textAlign:"center",position:"relative",overflow:"hidden"}}>
          {/* Cricket ball seam decorative circles */}
          <div style={{position:"absolute",top:-40,right:-40,width:140,height:140,borderRadius:"50%",border:"2px solid rgba(255,255,255,0.07)"}}/>
          <div style={{position:"absolute",top:-20,right:-20,width:100,height:100,borderRadius:"50%",border:"2px solid rgba(255,255,255,0.05)"}}/>
          <div style={{position:"absolute",bottom:-50,left:-30,width:120,height:120,borderRadius:"50%",border:"2px solid rgba(239,159,39,0.12)"}}/>
          {/* Cricket ball icon */}
          <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:52,height:52,background:"rgba(255,255,255,0.12)",borderRadius:14,marginBottom:16,backdropFilter:"blur(4px)"}}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="11" stroke="white" strokeWidth="1.8"/>
              <path d="M8 14 Q14 8 20 14 Q14 20 8 14Z" fill="white" opacity="0.9"/>
              <path d="M10 10.5 Q14 8 18 10.5" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
              <path d="M10 17.5 Q14 20 18 17.5" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
            </svg>
          </div>
          <div style={{fontSize:34,fontWeight:800,letterSpacing:"-1px",lineHeight:1,marginBottom:6}}>
            <span style={{color:"#fff"}}>Crickit</span><span style={{color:GOLD}}>Match</span>
          </div>
          <div style={{fontSize:12,fontWeight:500,color:"rgba(255,255,255,0.6)",letterSpacing:"0.14em",textTransform:"uppercase"}}>Youth cricket management</div>
          {/* Decorative accent line */}
          <div style={{display:"flex",justifyContent:"center",gap:4,marginTop:18}}>
            <div style={{width:32,height:2,background:"rgba(255,255,255,0.2)",borderRadius:1}}/>
            <div style={{width:20,height:2,background:GOLD,borderRadius:1}}/>
            <div style={{width:32,height:2,background:"rgba(255,255,255,0.2)",borderRadius:1}}/>
          </div>
        </div>

        {/* ── Form area ── */}
        <div style={{padding:"28px 28px 24px"}}>
          {err&&<div style={{background:"#fcebeb",color:"#A32D2D",borderRadius:8,padding:"10px 14px",fontSize:12,marginBottom:14,fontWeight:500}}>{err}</div>}
          {info&&<div style={{background:"#e6f4ec",color:G,borderRadius:8,padding:"10px 14px",fontSize:12,marginBottom:14,fontWeight:500}}>{info}</div>}

          {mode==="login"&&<form onSubmit={doLogin}>
            <div style={{marginBottom:16}}><label style={loginLbl}>Email address</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="coach@lahub.com" style={loginInp} required/></div>
            <div style={{marginBottom:8}}><label style={loginLbl}>Password</label><input type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" style={loginInp} required/></div>
            <div style={{textAlign:"right",marginBottom:22}}><button type="button" onClick={()=>go("reset")} style={{background:"none",border:"none",cursor:"pointer",fontSize:13,fontWeight:600,color:G,fontFamily:"inherit"}}>Forgot password?</button></div>
            <button type="submit" disabled={busy} style={{width:"100%",padding:14,background:G,color:"#fff",border:"none",borderRadius:10,fontSize:15,fontWeight:600,cursor:"pointer",fontFamily:"inherit",opacity:busy?.6:1,marginBottom:12}}>{busy?"Signing in…":"Sign in"}</button>
            <div style={{display:"flex",gap:10,marginBottom:20}}>
              <button type="button" onClick={()=>go("register")} style={{flex:1,padding:"11px",border:`1.5px solid ${G}`,borderRadius:10,background:"transparent",color:G,fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>Register academy →</button>
              <button type="button" onClick={()=>go("activate")} style={{flex:1,padding:"11px",border:"1.5px solid #c8e6d6",borderRadius:10,background:"transparent",color:"#4a5568",fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"inherit"}}>Access code</button>
            </div>
          </form>}

        {mode==="reset"&&<form onSubmit={doResetReq}>
          <p style={{fontSize:13,color:"#6b7280",marginBottom:16,lineHeight:1.6}}>Enter your email and we'll send a 6-digit reset code.</p>
          <div style={{marginBottom:20}}><label style={lbl}>Email</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="coach@lahub.com" style={inp} required/></div>
          <button type="submit" disabled={busy} style={{...cs.btnP,width:"100%",padding:11,fontSize:14,marginBottom:10,opacity:busy?.6:1}}>{busy?"Sending…":"Send reset code"}</button>
          <button type="button" onClick={()=>go("login")} style={{...cs.btnG,width:"100%",padding:11,fontSize:13}}>Back to sign in</button>
        </form>}

        {mode==="confirm"&&<form onSubmit={doResetConfirm}>
          <div style={{marginBottom:12}}><label style={lbl}>6-digit code</label><input type="text" value={code} onChange={e=>setCode(e.target.value)} placeholder="123456" style={inp} maxLength={6} required/></div>
          <div style={{marginBottom:12}}><label style={lbl}>New password</label><input type="password" value={newPass} onChange={e=>setNewPass(e.target.value)} placeholder="Min 8 characters" style={inp} required/></div>
          <div style={{marginBottom:20}}><label style={lbl}>Confirm password</label><input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="Repeat password" style={inp} required/></div>
          <button type="submit" disabled={busy} style={{...cs.btnP,width:"100%",padding:11,fontSize:14,marginBottom:10,opacity:busy?.6:1}}>{busy?"Updating…":"Set new password"}</button>
          <button type="button" onClick={()=>go("login")} style={{...cs.btnG,width:"100%",padding:11,fontSize:13}}>Back to sign in</button>
        </form>}

        {mode==="register"&&<form onSubmit={doRegister}>
          <div style={{fontSize:13,color:"#6b7280",marginBottom:16,lineHeight:1.6}}>Create a free CrickitMatch account for your academy or coaching school.</div>
          <div style={{marginBottom:12}}><label style={lbl}>Academy / org name *</label><input style={inp} value={regForm.orgName} onChange={e=>setRegForm(f=>({...f,orgName:e.target.value}))} placeholder="LA Hub U13" required/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Your name</label><input style={inp} value={regForm.coachName} onChange={e=>setRegForm(f=>({...f,coachName:e.target.value}))} placeholder="Coach Ravi Kumar"/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Your email *</label><input type="email" style={inp} value={regForm.email} onChange={e=>setRegForm(f=>({...f,email:e.target.value}))} placeholder="coach@youracademy.com" required/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Password *</label><input type="password" style={inp} value={regForm.password} onChange={e=>setRegForm(f=>({...f,password:e.target.value}))} placeholder="Min 8 characters" required/></div>
          <div style={{marginBottom:14}}><label style={lbl}>Confirm password *</label><input type="password" style={inp} value={regForm.confirm} onChange={e=>setRegForm(f=>({...f,confirm:e.target.value}))} placeholder="Repeat password" required/></div>
          <div style={{borderTop:"0.5px solid rgba(0,0,0,0.10)",paddingTop:14,marginBottom:14}}>
            <div style={{fontSize:13,fontWeight:600,color:"#6b7280",marginBottom:10}}>Manager account (optional)</div>
            <div style={{marginBottom:10}}><label style={lbl}>Manager name</label><input style={inp} value={regForm.managerName||""} onChange={e=>setRegForm(f=>({...f,managerName:e.target.value}))} placeholder="Manager name"/></div>
            <div style={{marginBottom:10}}><label style={lbl}>Manager email</label><input type="email" style={inp} value={regForm.managerEmail||""} onChange={e=>setRegForm(f=>({...f,managerEmail:e.target.value}))} placeholder="manager@yourorg.com"/></div>
            <div style={{marginBottom:0}}><label style={lbl}>Manager temporary password</label><input type="password" style={inp} value={regForm.managerPassword||""} onChange={e=>setRegForm(f=>({...f,managerPassword:e.target.value}))} placeholder="Min 6 characters"/></div>
          </div>
          <button type="submit" disabled={busy} style={{...cs.btnP,width:"100%",padding:14,fontSize:16,fontWeight:700,marginBottom:10,opacity:busy?.6:1}}>{busy?"Creating account…":"Create free account"}</button>
          <button type="button" onClick={()=>go("login")} style={{...cs.btnG,width:"100%",padding:11,fontSize:13}}>Back to sign in</button>
          <div style={{marginTop:12,fontSize:12,color:"#9ca3af",textAlign:"center"}}>Free plan · No credit card required</div>
        </form>}

        {mode==="activate"&&<form onSubmit={doActivate}>
          <div style={{fontSize:13,color:"#6b7280",marginBottom:16,lineHeight:1.6}}>Enter the access code your coach gave you to activate your player account.</div>
          <div style={{marginBottom:12}}><label style={lbl}>Your email *</label><input type="email" style={inp} value={actForm.email} onChange={e=>setActForm(f=>({...f,email:e.target.value}))} placeholder="your@email.com" required/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Access code *</label><input style={{...inp,textTransform:"uppercase",letterSpacing:"0.1em",fontFamily:"monospace"}} value={actForm.accessCode} onChange={e=>setActForm(f=>({...f,accessCode:e.target.value.toUpperCase()}))} placeholder="CM-XXXXXX" required/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Set your password *</label><input type="password" style={inp} value={actForm.password} onChange={e=>setActForm(f=>({...f,password:e.target.value}))} placeholder="Min 8 characters" required/></div>
          <div style={{marginBottom:20}}><label style={lbl}>Confirm password *</label><input type="password" style={inp} value={actForm.confirm} onChange={e=>setActForm(f=>({...f,confirm:e.target.value}))} placeholder="Repeat password" required/></div>
          <button type="submit" disabled={busy} style={{...cs.btnP,width:"100%",padding:14,fontSize:16,fontWeight:700,marginBottom:10,opacity:busy?.6:1}}>{busy?"Activating…":"Activate my account"}</button>
          <button type="button" onClick={()=>go("login")} style={{...cs.btnG,width:"100%",padding:11,fontSize:13}}>Back to sign in</button>
        </form>}

        {mode==="orgpick"&&<div>
          <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:6}}>Select organisation</div>
          <div style={{...cs.muted,marginBottom:14}}>Your email is linked to multiple organisations. Which one are you logging into today?</div>
          {orgChoices.map(o=>(
            <div key={o.orgId} onClick={()=>pickOrg(o)}
              style={{...cs.card,cursor:"pointer",marginBottom:8,border:`1.5px solid ${G}`,background:"#fff"}}>
              <div style={{fontSize:15,fontWeight:700,color:"#1a1a1a"}}>{o.orgName||o.orgId}</div>
              <div style={{fontSize:12,color:"#6b7280",marginTop:3}}>{o.role} · {o.email}</div>
            </div>
          ))}
          <button type="button" onClick={()=>{setMode("login");setOrgChoices([]);}} style={{...cs.btnG,width:"100%",padding:11,fontSize:13,marginTop:4}}>Back</button>
        </div>}
          {mode==="login"&&!API&&<div style={{background:"#fff",border:"1px solid #c8e6d6",borderRadius:10,padding:"10px 14px",marginBottom:18}}>
            <div style={{fontSize:10,fontWeight:700,color:G,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Demo accounts</div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:"0.5px solid #e8f4ed"}}>
              <span style={{fontSize:11,color:"#4a5568"}}>coach@lahub.com</span><span style={{fontSize:11,color:"#9ca3af",fontFamily:"monospace"}}>coach123</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:"0.5px solid #e8f4ed"}}>
              <span style={{fontSize:11,color:"#4a5568"}}>manager@lahub.com</span><span style={{fontSize:11,color:"#9ca3af",fontFamily:"monospace"}}>manager123</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0"}}>
              <span style={{fontSize:11,color:"#4a5568"}}>player@lahub.com</span><span style={{fontSize:11,color:"#9ca3af",fontFamily:"monospace"}}>player123</span>
            </div>
          </div>}
          {mode==="login"&&<div style={{borderTop:"0.5px solid #e2e8e4",paddingTop:16,textAlign:"center"}}>
            <a href="https://crickithub.com/guide.html" target="_blank" rel="noopener noreferrer" style={{fontSize:13,fontWeight:600,color:G,textDecoration:"none"}}>User Guide — how it works</a>
            <div style={{fontSize:11,color:"#9ca3af",marginTop:10}}>CrickitMatch by ArcGain LLC</div>
          </div>}
        </div>{/* /form area */}
      </div>{/* /card */}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// SUPERADMIN
// ═══════════════════════════════════════════════════════════════════════════════
function SuperAdmin({apiFetch}){
  const [orgs,setOrgs]=useState([]);
  const [loading,setLoading]=useState(true);
  const [showForm,setShowForm]=useState(false);
  const [form,setForm]=useState({orgName:"",plan:"TRIAL",coachName:"",coachEmail:"",coachPassword:"",managerName:"",managerEmail:"",managerPassword:""});
  const [err,setErr]=useState("");
  const [busy,setBusy]=useState(false);
  const [successMsg,setSuccessMsg]=useState("");
  const [editOrg,setEditOrg]=useState(null); // org being edited
  const [editPlan,setEditPlan]=useState("TRIAL");
  const [editNotes,setEditNotes]=useState("");
  const [editBusy,setEditBusy]=useState(false);
  const [analyticsModal,setAnalyticsModal]=useState(null);
  const [detailOrg,setDetailOrg]=useState(null);
  const [analyticsType,setAnalyticsType]=useState("180days");
  const [analyticsNote,setAnalyticsNote]=useState("");
  const [analyticsBusy,setAnalyticsBusy]=useState(false);

  useEffect(()=>{
    apiFetch("/crickithub/admin/orgs").then(d=>{if(d?.orgs)setOrgs(d.orgs);setLoading(false);});
  },[]);

  async function suspend(orgId,s){
    await apiFetch(`/crickithub/admin/orgs/${orgId}/status`,"PUT",{status:s?"SUSPENDED":"ACTIVE"});
    setOrgs(os=>os.map(o=>o.orgId===orgId?{...o,status:s?"SUSPENDED":"ACTIVE"}:o));
  }

  async function generateAdminCode(orgId){
    if(!window.confirm("Generate an admin code for this org? This cannot be undone.")) return;
    const code="ORG-"+Array.from({length:6},()=>"ABCDEFGHJKLMNPQRSTUVWXYZ23456789"[Math.floor(Math.random()*32)]).join("");
    await apiFetch(`/crickithub/admin/orgs/${orgId}/status`,"PUT",{adminCode:code});
    setOrgs(os=>os.map(o=>o.orgId===orgId?{...o,adminCode:code}:o));
    setDetailOrg(d=>d?{...d,adminCode:code}:d);
  }

  function openEdit(o){setEditOrg(o);setEditPlan(o.plan||"TRIAL");setEditNotes(o.notes||"");}

  async function saveEdit(){
    if(!editOrg) return;
    setEditBusy(true);
    await apiFetch(`/crickithub/admin/orgs/${editOrg.orgId}/status`,"PUT",{status:editOrg.status||"ACTIVE",plan:editPlan,notes:editNotes});
    setOrgs(os=>os.map(o=>o.orgId===editOrg.orgId?{...o,plan:editPlan,notes:editNotes}:o));
    setEditOrg(null);setEditBusy(false);
  }

  async function saveAnalyticsPromo(){
    if(!analyticsModal) return;
    setAnalyticsBusy(true);
    await apiFetch(`/crickithub/admin/orgs/${analyticsModal.orgId}/analytics`,"PUT",{analyticsPromo:analyticsType,analyticsPromoNote:analyticsNote});
    setOrgs(os=>os.map(o=>o.orgId===analyticsModal.orgId?{...o,analyticsPromo:analyticsType}:o));
    setAnalyticsModal(null);setAnalyticsBusy(false);
  }

  async function createOrg(){
    if(!form.orgName){setErr("Org name is required.");return;}
    if(!form.coachEmail||!form.coachPassword){setErr("Coach email and temporary password are required.");return;}
    if(form.coachPassword.length<6){setErr("Temporary password must be at least 6 characters.");return;}
    setBusy(true);setErr("");
    const r=await apiFetch("/crickithub/admin/orgs","POST",form,true);
    setBusy(false);
    if(r&&!r._err){
      setOrgs(os=>[...os,{...form,orgId:r.orgId,adminCode:r.adminCode,status:"ACTIVE",createdAt:new Date().toISOString()}]);
      setShowForm(false);
      setForm({orgName:"",plan:"TRIAL",coachName:"",coachEmail:"",coachPassword:"",managerName:"",managerEmail:"",managerPassword:""});
      setSuccessMsg(`Organisation created. Coach can log in with ${form.coachEmail}. Admin code: ${r.adminCode} — save this somewhere safe.`);
      setTimeout(()=>setSuccessMsg(""),12000);
    } else {
      setErr("Create org failed: "+(r?._err||"Unknown error — check browser console for details."));
    }
  }
  const pb=p=>p==="PAID"?"green":p==="TRIAL"?"amber":p==="SUSPENDED"?"red":"gray";
  return(
    <div>
      <SectionHdr title="SuperAdmin dashboard" sub="Manage all CrickitMatch organisations and plans."/>
      {successMsg&&<div style={{background:"#e6f4ec",border:"0.5px solid #9FE1CB",borderRadius:8,padding:"10px 14px",fontSize:12,color:G,marginBottom:12}}>{successMsg}</div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
        {[["Total",orgs.length],["Active",orgs.filter(o=>o.status==="ACTIVE").length],["Trial",orgs.filter(o=>o.plan==="TRIAL").length],["Suspended",orgs.filter(o=>o.status==="SUSPENDED").length]].map(([l,v])=>(
          <div key={l} style={{...cs.card,marginBottom:0}}><div style={cs.muted}>{l}</div><div style={{fontSize:22,fontWeight:500,marginTop:3}}>{v}</div></div>
        ))}
      </div>
      {err&&<AlertBox type="red" msg={err} onClose={()=>setErr("")}/>}
      <div style={{marginBottom:12}}><button style={cs.btnP} onClick={()=>setShowForm(s=>!s)}>{showForm?"Cancel":"+ Create organisation"}</button></div>
      {showForm&&<div style={cs.card}>
        <div style={{fontSize:13,fontWeight:500,marginBottom:10}}>New organisation</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
          <div><label style={cs.label}>Org name *</label><input style={cs.input} value={form.orgName} onChange={e=>setForm(f=>({...f,orgName:e.target.value}))} placeholder="LA Hub"/></div>
          <div><label style={cs.label}>Plan</label><select style={cs.select} value={form.plan} onChange={e=>setForm(f=>({...f,plan:e.target.value}))}><option value="TRIAL">Trial</option><option value="FREE">Free</option><option value="PAID">Paid</option></select></div>
        </div>
        <div style={{fontSize:12,fontWeight:500,color:"#1a1a1a",marginBottom:8,paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Coach login *</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:12}}>
          <div><label style={cs.label}>Coach name</label><input style={cs.input} value={form.coachName} onChange={e=>setForm(f=>({...f,coachName:e.target.value}))} placeholder="Ravi Kumar"/></div>
          <div><label style={cs.label}>Coach email *</label><input type="email" style={cs.input} value={form.coachEmail} onChange={e=>setForm(f=>({...f,coachEmail:e.target.value}))} placeholder="coach@org.com"/></div>
          <div><label style={cs.label}>Temporary password *</label><input type="password" style={cs.input} value={form.coachPassword} onChange={e=>setForm(f=>({...f,coachPassword:e.target.value}))} placeholder="Min 6 characters"/></div>
        </div>
        <div style={{fontSize:12,fontWeight:500,color:"#1a1a1a",marginBottom:8,paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Manager login (optional)</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
          <div><label style={cs.label}>Manager name</label><input style={cs.input} value={form.managerName} onChange={e=>setForm(f=>({...f,managerName:e.target.value}))} placeholder="Priya Shah"/></div>
          <div><label style={cs.label}>Manager email</label><input type="email" style={cs.input} value={form.managerEmail} onChange={e=>setForm(f=>({...f,managerEmail:e.target.value}))} placeholder="manager@org.com"/></div>
          <div><label style={cs.label}>Temporary password</label><input type="password" style={cs.input} value={form.managerPassword} onChange={e=>setForm(f=>({...f,managerPassword:e.target.value}))} placeholder="Min 6 characters"/></div>
        </div>
        <div style={{...cs.muted,marginBottom:12}}>The coach and manager can change their password after logging in via their profile.</div>
        <button style={{...cs.btnP,opacity:busy?.6:1}} onClick={createOrg} disabled={busy}>{busy?"Creating…":"Create org"}</button>
      </div>}
      {loading?<div style={cs.muted}>Loading…</div>:<div style={cs.card}>
        <div style={{fontSize:13,fontWeight:500,marginBottom:10}}>All organisations</div>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>{["Org","Plan","Status","Admin code","Created",""].map(h=><th key={h} style={{textAlign:"left",padding:"5px 8px",color:"#6b7280",fontWeight:500,background:"#f8f9f7",fontSize:11}}>{h}</th>)}</tr></thead>
          <tbody>{orgs.map(o=>(
            <tr key={o.orgId} onClick={()=>setDetailOrg(o)} style={{cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.background="#f8faf9"} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:500}}>{o.orgName}</td>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}><Badge color={pb(o.plan)}>{o.plan}</Badge></td>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}><Badge color={o.status==="ACTIVE"?"green":o.status==="SUSPENDED"?"red":"gray"}>{o.status}</Badge></td>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>
                <span style={{fontFamily:"monospace",fontSize:11,color:"#185FA5",background:"#e6f1fb",padding:"2px 7px",borderRadius:4,letterSpacing:"0.06em",cursor:"pointer"}} onClick={()=>navigator.clipboard?.writeText(o.adminCode||"")} title="Click to copy">{o.adminCode||"—"}</span>
              </td>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{o.createdAt?new Date(o.createdAt).toLocaleDateString():"—"}</td>
              <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}} onClick={e=>e.stopPropagation()}>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                  <button style={cs.btnG} onClick={()=>openEdit(o)}>Edit plan</button>
                  <button style={{...cs.btnG,color:"#185FA5"}} onClick={()=>setAnalyticsModal(o)}>Analytics promo</button>
                  {o.status!=="SUSPENDED"?<button style={{...cs.btnG,color:"#A32D2D"}} onClick={()=>suspend(o.orgId,true)}>Suspend</button>:<button style={{...cs.btnG,color:G}} onClick={()=>suspend(o.orgId,false)}>Reinstate</button>}
                </div>
              </td>
            </tr>
          ))}
          {orgs.length===0&&<tr><td colSpan={6} style={{padding:"10px 8px",color:"#6b7280"}}>No organisations yet.</td></tr>}
          </tbody>
        </table>
      </div>}

      {/* ── Org detail modal ── */}
      {detailOrg&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
        onClick={e=>{if(e.target===e.currentTarget)setDetailOrg(null);}}>
        <div style={{background:"#fff",borderRadius:14,padding:"24px",width:"100%",maxWidth:460,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.2)"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18}}>
            <div style={{fontSize:16,fontWeight:700}}>{detailOrg.orgName}</div>
            <button onClick={()=>setDetailOrg(null)} style={{background:"rgba(0,0,0,0.08)",border:"none",borderRadius:"50%",width:30,height:30,cursor:"pointer",fontSize:18,color:"#6b7280",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
          </div>
          {[
            ["Org ID",          detailOrg.orgId],
            ["Plan",            detailOrg.plan],
            ["Status",          detailOrg.status||"ACTIVE"],
            ["Original creator",detailOrg.coachName||"—"],
            ["Creator email",   detailOrg.adminEmail||detailOrg.coachEmail||"—"],
            ["Admin code",      detailOrg.adminCode||"—"],
            ["Registered",      detailOrg.createdAt?new Date(detailOrg.createdAt).toLocaleDateString():"—"],
            ["Analytics promo", detailOrg.analyticsPromo||"None"],
            ["Notes",           detailOrg.notes||"—"],
          ].map(([label,val])=>(
            <div key={label} style={{display:"flex",gap:12,padding:"8px 0",borderBottom:"0.5px solid rgba(0,0,0,0.06)",alignItems:"center"}}>
              <span style={{fontSize:12,color:"#6b7280",minWidth:140,flexShrink:0}}>{label}</span>
              <span style={{fontSize:13,fontWeight:500,fontFamily:label==="Admin code"||label==="Org ID"?"monospace":"inherit",color:label==="Admin code"?"#185FA5":"#1a1a1a",flex:1,wordBreak:"break-all"}}>{val}</span>
              {label==="Admin code"&&val!=="—"&&<button onClick={()=>navigator.clipboard?.writeText(val)} style={{...cs.btnG,padding:"2px 8px",fontSize:10,flexShrink:0}}>Copy</button>}
              {label==="Admin code"&&val==="—"&&<button onClick={()=>generateAdminCode(detailOrg.orgId)} style={{...cs.btnG,padding:"2px 8px",fontSize:10,flexShrink:0,color:G}}>Generate</button>}
            </div>
          ))}
          <div style={{marginTop:18,display:"flex",gap:8,flexWrap:"wrap"}}>
            <button style={cs.btnP} onClick={()=>{setDetailOrg(null);openEdit(detailOrg);}}>Edit plan</button>
            <button style={{...cs.btnG,color:"#185FA5"}} onClick={()=>{setDetailOrg(null);setAnalyticsModal(detailOrg);}}>Analytics promo</button>
            {detailOrg.status!=="SUSPENDED"
              ?<button style={{...cs.btnG,color:"#A32D2D"}} onClick={()=>{suspend(detailOrg.orgId,true);setDetailOrg(null);}}>Suspend org</button>
              :<button style={{...cs.btnG,color:G}} onClick={()=>{suspend(detailOrg.orgId,false);setDetailOrg(null);}}>Reinstate org</button>}
          </div>
        </div>
      </div>}

      {/* ── Edit plan modal ── */}
      {editOrg&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div style={{background:"#fff",borderRadius:14,padding:"24px 24px",width:"100%",maxWidth:420,boxShadow:"0 8px 40px rgba(0,0,0,0.18)"}}>
          <div style={{fontSize:16,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Edit plan — {editOrg.orgName}</div>
          <div style={{fontSize:12,color:"#6b7280",marginBottom:16}}>Changes take effect immediately on the coach's next login.</div>

          <label style={cs.label}>Subscription plan</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:4}}>
            {["TRIAL","FREE","DISCOUNTED","PAID","SUSPENDED"].map(p=>(
              <button key={p} onClick={()=>setEditPlan(p)} style={{padding:"8px 4px",border:`2px solid ${editPlan===p?G:"rgba(0,0,0,0.15)"}`,borderRadius:8,background:editPlan===p?G:"#fff",color:editPlan===p?"#fff":"#1a1a1a",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit",textAlign:"center"}}>{p}</button>
            ))}
          </div>

          {/* Plan descriptions */}
          <div style={{background:"#f8f9f7",borderRadius:8,padding:"8px 12px",fontSize:11,color:"#6b7280",marginBottom:14}}>
            {editPlan==="TRIAL"&&"30-day free access. Season Analytics locked."}
            {editPlan==="FREE"&&"Unlimited free access. Season Analytics locked."}
            {editPlan==="DISCOUNTED"&&"Paid plan at reduced rate. Season Analytics unlocked."}
            {editPlan==="PAID"&&"Full paid plan. Season Analytics unlocked."}
            {editPlan==="SUSPENDED"&&"Access suspended. Coach cannot log in."}
          </div>

          <label style={cs.label}>Internal notes (not visible to org)</label>
          <textarea style={{...cs.textarea,minHeight:60,marginBottom:16}} value={editNotes} onChange={e=>setEditNotes(e.target.value)} placeholder="e.g. Promo code LAHUB50 applied, 50% discount for 3 months"/>

          <div style={{display:"flex",gap:8}}>
            <button style={{...cs.btnP,flex:1,opacity:editBusy?.6:1}} onClick={saveEdit} disabled={editBusy}>{editBusy?"Saving…":"Save changes"}</button>
            <button style={cs.btnG} onClick={()=>setEditOrg(null)}>Cancel</button>
          </div>
        </div>
      </div>}
      {/* ── Analytics promo modal ── */}
      {analyticsModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div style={{background:"#fff",borderRadius:14,padding:"24px",width:"100%",maxWidth:400,boxShadow:"0 8px 40px rgba(0,0,0,0.18)"}}>
          <div style={{fontSize:16,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Analytics promo — {analyticsModal.orgName}</div>
          <div style={{fontSize:12,color:"#6b7280",marginBottom:16}}>Grant this org free access to Season Analytics as a promotional offer.</div>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            {[["180days","180 days free"],["90days","90 days free"],["forever","Free forever"]].map(([v,l])=>(
              <button key={v} onClick={()=>setAnalyticsType(v)} style={{flex:1,padding:"10px",border:`2px solid ${analyticsType===v?"#185FA5":"rgba(0,0,0,0.15)"}`,borderRadius:8,background:analyticsType===v?"#e6f1fb":"#fff",color:analyticsType===v?"#185FA5":"#1a1a1a",cursor:"pointer",fontSize:13,fontWeight:analyticsType===v?700:400,fontFamily:"inherit"}}>{l}</button>
            ))}
          </div>
          <label style={cs.label}>Internal note (optional)</label>
          <textarea style={{...cs.textarea,minHeight:56,marginBottom:16}} value={analyticsNote} onChange={e=>setAnalyticsNote(e.target.value)} placeholder="e.g. Promotional partner — LA Hub founding coach"/>
          <div style={{display:"flex",gap:8}}>
            <button style={{...cs.btnP,flex:1,background:"#185FA5",opacity:analyticsBusy?.6:1}} onClick={saveAnalyticsPromo} disabled={analyticsBusy}>{analyticsBusy?"Saving…":"Grant access"}</button>
            <button style={cs.btnG} onClick={()=>setAnalyticsModal(null)}>Cancel</button>
          </div>
        </div>
      </div>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// SCHEDULE
// ═══════════════════════════════════════════════════════════════════════════════
const EMPTY_MATCH={tournament:"",venue:"",date:"",time:"",opponent:"",notes:"",teamName:"",ageCategory:"U13",coachName:"",coachEmail:"",managerName:"",managerEmail:"",matchType:"hub"};
function Schedule({user,matches,setMatches,selectedMatchId,onSelectMatch,onSaveMatch,onUpdateMatch,onDeleteMatch,teamMeta,setTeamMeta,onSaveTeamMeta,matchFrozen,apiFetch}){
  const isManager=user.role==="MANAGER";
  const isCoach=user.role==="COACH";
  const [showForm,setShowForm]=useState(false);
  const [form,setForm]=useState(EMPTY_MATCH);
  const [editId,setEditId]=useState(null);
  const [err,setErr]=useState("");
  const canEdit=user.role==="MANAGER"||user.role==="COACH";
  function save(){
    if(!form.date||!form.opponent){setErr("Date and opponent required.");return;}
    // Sync team details to teamMeta so other tabs stay consistent
    const teamFields={teamName:form.teamName,ageCategory:form.ageCategory,tournament:form.tournament,coachName:form.coachName,coachEmail:form.coachEmail,managerName:form.managerName,managerEmail:form.managerEmail};
    if(setTeamMeta) setTeamMeta(tm=>({...tm,...teamFields}));
    if(onSaveTeamMeta) onSaveTeamMeta({...teamMeta,...teamFields});
    if(editId){
      const{_hasData,...cleanForm}=form;
      const existing=matches.find(m=>m.matchId===editId);
      const{_hasData:_existingHasData,...cleanExisting}=existing||{};
      onUpdateMatch({...cleanExisting,...cleanForm,matchId:editId});
      setMatches(ms=>ms.map(m=>m.matchId===editId?{...m,...cleanForm}:m));
    }
    else{const m={...form,matchId:"M"+Date.now()};onSaveMatch(m);setMatches(ms=>[...ms,m]);}
    setForm(EMPTY_MATCH);setShowForm(false);setEditId(null);setErr("");
  }
  function edit(m){
    if(m.frozen){alert("This match is frozen. Match details cannot be changed.");return;}
    if(m.reportLocked){alert("The match report is locked. Unlock the report first to edit match details.");return;}
    if(isManager&&m._hasData){alert("Data has been recorded for this match. Managers cannot edit matches with recorded data.");return;}setForm({tournament:m.tournament||teamMeta?.tournament||"",venue:m.venue||"",date:m.date||"",time:m.time||"",opponent:m.opponent||"",notes:m.notes||"",teamName:m.teamName||teamMeta?.teamName||"",ageCategory:m.ageCategory||teamMeta?.ageCategory||"U13",coachName:m.coachName||teamMeta?.coachName||"",coachEmail:m.coachEmail||teamMeta?.coachEmail||"",managerName:m.managerName||teamMeta?.managerName||"",managerEmail:m.managerEmail||teamMeta?.managerEmail||"",matchType:m.matchType||"hub"});setEditId(m.matchId);setShowForm(true);}
  function del(m){
    if(isManager){alert("Only the Coach can inactivate a match.");return;}
    if(m.frozen){alert("This match is frozen and cannot be inactivated. Frozen matches are permanently locked.");return;}
    const hasData=m._hasData;
    if(hasData){alert("Data has been recorded for this match. Use Freeze in the Match Report tab to lock it instead.");return;}
    if(!window.confirm("Inactivate this match? It will be hidden from the schedule."))return;
    onDeleteMatch(m.matchId,"inactivate");
    setMatches(ms=>ms.map(x=>x.matchId===m.matchId?{...x,inactive:true}:x));
  }
  const sorted=[...matches].filter(m=>!m.inactive).sort((a,b)=>new Date(a.date+" "+a.time)-new Date(b.date+" "+b.time));
  const now=new Date().toISOString().split("T")[0]; // today's date as YYYY-MM-DD string
  return(
    <div>
      <SectionHdr title="Match schedule" sub="All upcoming and past matches for this team."/>
      {canEdit&&<div style={{marginBottom:12}}><button style={cs.btnP} onClick={()=>{setShowForm(s=>!s);setEditId(null);setForm(EMPTY_MATCH);}}>{showForm?"Cancel":"+ Add match"}</button></div>}
      {showForm&&<div style={cs.card}>
        <div style={{fontSize:13,fontWeight:500,marginBottom:10}}>{editId?"Edit match":"New match"}</div>
        <AlertBox type="red" msg={err} onClose={()=>setErr("")}/>
        <div style={{fontSize:12,fontWeight:700,color:"#6b7280",marginBottom:8,paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Match details</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <label style={cs.label}>Tournament</label>
            <input style={cs.input} value={form.tournament} onChange={e=>setForm(f=>({...f,tournament:e.target.value}))} placeholder="e.g. LA Hub Selection Cycle 2026"/>
            {[...new Set(matches.filter(m=>m.tournament).map(m=>m.tournament))].length>0&&
              <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:6}}>
                <span style={{fontSize:11,color:"#9ca3af",alignSelf:"center",flexShrink:0}}>Past:</span>
                {[...new Set(matches.filter(m=>m.tournament).map(m=>m.tournament))].map(t=>(
                  <button key={t} type="button" onClick={()=>setForm(f=>({...f,tournament:t}))}
                    style={{fontSize:11,padding:"3px 10px",borderRadius:20,border:`1px solid ${form.tournament===t?"#1A7A4A":"rgba(0,0,0,0.15)"}`,background:form.tournament===t?"#1A7A4A":"#fff",color:form.tournament===t?"#fff":"#1a1a1a",cursor:"pointer",fontFamily:"inherit"}}>
                    {t}
                  </button>
                ))}
              </div>}
          </div>
          <div><label style={cs.label}>Opponent *</label><input style={cs.input} value={form.opponent} onChange={e=>setForm(f=>({...f,opponent:e.target.value}))} placeholder="Northside CC"/></div>
          <div>
            <label style={cs.label}>Match type</label>
            <div style={{display:"flex",gap:6}}>
              {[["hub","Hub Match"],["open","Open Match"]].map(([val,lbl])=>(
                <button key={val} type="button" onClick={()=>setForm(f=>({...f,matchType:val}))}
                  style={{flex:1,padding:"8px 4px",border:`2px solid ${(form.matchType||"hub")===val?G:"rgba(0,0,0,0.15)"}`,borderRadius:8,background:(form.matchType||"hub")===val?G:"#fff",color:(form.matchType||"hub")===val?"#fff":"#1a1a1a",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>
                  {lbl}
                </button>
              ))}
            </div>
            <div style={{fontSize:11,color:"#9ca3af",marginTop:4}}>
              {(form.matchType||"hub")==="hub"?"Age quotas apply. Hub Report available.":"No quotas. Tracking only. No Hub Report."}
            </div>
          </div>
          <div><label style={cs.label}>Venue</label><input style={cs.input} value={form.venue} onChange={e=>setForm(f=>({...f,venue:e.target.value}))} placeholder="Hansen Dam Cricket Ground"/></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <div><label style={cs.label}>Date *</label><input type="date" style={cs.input} value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))}/></div>
            <div><label style={cs.label}>Time</label><input type="time" style={cs.input} value={form.time} onChange={e=>setForm(f=>({...f,time:e.target.value}))}/></div>
          </div>
        </div>
        <div style={{fontSize:12,fontWeight:700,color:"#6b7280",marginBottom:8,paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Team details</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div style={{gridColumn:"1/-1"}}><label style={cs.label}>Team name</label><input style={cs.input} value={form.teamName} onChange={e=>setForm(f=>({...f,teamName:e.target.value}))} placeholder="LA Hub Team A"/></div>
          <div><label style={cs.label}>Age category</label><select style={cs.select} value={form.ageCategory||"U13"} onChange={e=>setForm(f=>({...f,ageCategory:e.target.value}))}><option>U11</option><option>U13</option><option>U15</option><option>U17</option><option>U19</option><option value="Open/Youth">Open/Youth</option></select></div>
          <div style={{gridColumn:"1/-1",display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label style={cs.label}>Coach name</label><input style={cs.input} value={form.coachName} onChange={e=>setForm(f=>({...f,coachName:e.target.value}))} placeholder="Coach Ravi Kumar"/></div>
            <div><label style={cs.label}>Coach email</label><input type="email" style={cs.input} value={form.coachEmail} onChange={e=>setForm(f=>({...f,coachEmail:e.target.value}))} placeholder="coach@org.com"/></div>
          </div>
          <div style={{gridColumn:"1/-1",display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label style={cs.label}>Manager name</label><input style={cs.input} value={form.managerName} onChange={e=>setForm(f=>({...f,managerName:e.target.value}))} placeholder="Manager name"/></div>
            <div><label style={cs.label}>Manager email</label><input type="email" style={cs.input} value={form.managerEmail} onChange={e=>setForm(f=>({...f,managerEmail:e.target.value}))} placeholder="manager@org.com"/></div>
          </div>
        </div>
        <div style={{marginBottom:10}}><label style={cs.label}>Notes</label><textarea style={{...cs.textarea,minHeight:56}} value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} rows={2}/></div>
        <div style={cs.row}><button style={cs.btnP} onClick={save}>{editId?"Save changes":"Add match"}</button><button style={cs.btnG} onClick={()=>{setShowForm(false);setEditId(null);setForm(EMPTY_MATCH);}}>Cancel</button></div>
      </div>}
      {sorted.length===0&&<div style={{...cs.card,textAlign:"center",padding:"32px 20px",background:"#f8faf9"}}>
        <div style={{fontSize:36,marginBottom:10}}>📅</div>
        <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>No matches scheduled</div>
        <div style={cs.muted}>{canEdit?"Tap '+ Add match' to schedule your first match.":"No matches have been scheduled yet."}</div>
      </div>}
      {sorted.map(m=>{
        const isPast=m.date?m.date<now:false;
        const isSel=m.matchId===selectedMatchId;
        return(
          <div key={m.matchId} style={{
            ...cs.card,
            borderColor:isSel?G:isPast?"rgba(0,0,0,0.06)":"rgba(0,0,0,0.10)",
            borderWidth:isSel?1.5:.5,
            opacity:isPast?.8:1,cursor:"pointer",
            boxShadow:isSel?`0 3px 16px rgba(26,122,74,0.15)`:"0 1px 4px rgba(0,0,0,0.04)",
            background:isSel?"#f6fdf9":"#fff",
          }} onClick={()=>onSelectMatch(m.matchId)}>
            <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}}>
              <div style={{flex:1}}>
                <div style={{...cs.row,marginBottom:6,flexWrap:"wrap"}}>
                  <div style={{background:isPast?"#f1efe8":"#e6f4ec",color:isPast?"#888780":G,borderRadius:6,padding:"3px 10px",fontSize:12,fontWeight:500}}>
                    {m.date?(()=>{const [y,mo,d]=m.date.split("-");const dt=new Date(+y,+mo-1,+d);return dt.toLocaleDateString("en-US",{weekday:"short",day:"numeric",month:"short"});})():"No date"}{m.time?" · "+m.time:""}
                  </div>
                  {isPast&&<Badge color="gray">Past</Badge>}
                  {!isPast&&<Badge color="green">Upcoming</Badge>}
                  {isSel&&<Badge color="blue">Active</Badge>}
                  <Badge color={(m.matchType||"hub")==="open"?"blue":"gray"}>{(m.matchType||"hub")==="open"?"OPEN":"HUB"}</Badge>
                </div>
                <div style={{fontSize:15,fontWeight:500,marginBottom:2}}>vs {m.opponent||"TBC"}</div>
                <div style={cs.muted}>{[m.tournament,m.venue].filter(Boolean).join(" · ")||"No details"}</div>
                {m.notes&&<div style={{...cs.muted,marginTop:4,fontStyle:"italic"}}>{m.notes}</div>}
              </div>
              {canEdit&&<div style={cs.row} onClick={e=>e.stopPropagation()}>
                {(!m.frozen&&!(m.matchId===selectedMatchId&&matchFrozen))&&!m.reportLocked&&<button style={cs.btnG} onClick={()=>edit(m)}>Edit</button>}
                {(m.frozen||(m.matchId===selectedMatchId&&matchFrozen))&&<Badge color="gray">Frozen</Badge>}
                {!m.frozen&&!(m.matchId===selectedMatchId&&matchFrozen)&&m.reportLocked&&<Badge color="amber">Report locked</Badge>}
                {!m.frozen&&!(m.matchId===selectedMatchId&&matchFrozen)&&!m.reportLocked&&isCoach&&!m._hasData&&<button style={{...cs.btnG,color:"#A32D2D"}} onClick={()=>del(m)} title="Inactivate match">Inactivate</button>}
                {!m.frozen&&!(m.matchId===selectedMatchId&&matchFrozen)&&!m.reportLocked&&isCoach&&m._hasData&&<button style={{...cs.btnG,color:"#9ca3af",cursor:"default"}} title="Match has data — freeze instead to lock it">🔒 Has data</button>}
              </div>}
            </div>
            {isSel&&<div style={{marginTop:10,paddingTop:10,borderTop:"0.5px solid rgba(0,0,0,0.08)",fontSize:12,color:G,fontWeight:500}}>Active match — use tabs above to manage team, track play and generate reports.</div>}
          </div>
        );
      })}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// TEAM SETUP
// ═══════════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════════════════
// ORG ADMIN — staff management (Coach and Manager can access)
// ═══════════════════════════════════════════════════════════════════════════════
function OrgAdmin({user,teamMeta,setTeamMeta,onSaveTeamMeta,saveMsg,apiFetch,canSeeAdminCode}){
  const [orgInfo,setOrgInfo]=useState(null);
  const [loading,setLoading]=useState(true);
  const [showAddForm,setShowAddForm]=useState(false);
  const [addForm,setAddForm]=useState({name:"",email:"",phone:"",password:"",confirm:"",role:"COACH"});
  const [addErr,setAddErr]=useState("");
  const [addBusy,setAddBusy]=useState(false);
  const [resetTarget,setResetTarget]=useState(null); // email being reset
  const [codeAccessTarget,setCodeAccessTarget]=useState(null); // email getting toggle
  const [resetPass,setResetPass]=useState("");
  const [resetBusy,setResetBusy]=useState(false);
  const [deactTarget,setDeactTarget]=useState(null); // email being deactivated
  const [adminCodeInput,setAdminCodeInput]=useState("");
  const [deactBusy,setDeactBusy]=useState(false);
  const [showCode,setShowCode]=useState(false);
  // Team details (editable by coach and manager)
  const [local,setLocal]=useState(()=>({teamName:"",ageCategory:"U13",coachName:"",coachEmail:"",...teamMeta}));
  const isCoach=user.role==="COACH";

  useEffect(()=>{
    if(!apiFetch) return;
    apiFetch("/crickithub/org/admin").then(d=>{
      if(d) setOrgInfo(d);
      setLoading(false);
    });
  },[]);

  function setL(k,v){setLocal(m=>({...m,[k]:v}));}
  function saveTeam(){setTeamMeta(local);onSaveTeamMeta(local);}

  async function addStaff(){
    setAddErr("");
    if(!addForm.name.trim()||!addForm.email.trim()||!addForm.password){setAddErr("Name, email and password required.");return;}
    if(addForm.password!==addForm.confirm){setAddErr("Passwords do not match.");return;}
    if(addForm.password.length<6){setAddErr("Password must be at least 6 characters.");return;}
    setAddBusy(true);
    const r=await apiFetch("/crickithub/org/admin/staff","POST",{name:addForm.name.trim(),email:addForm.email.trim().toLowerCase(),phone:addForm.phone||"",password:addForm.password,role:addForm.role});
    setAddBusy(false);
    if(r?.ok){
      setOrgInfo(o=>({...o,staff:[...(o.staff||[]),r.member]}));
      setAddForm({name:"",email:"",password:"",confirm:"",role:"COACH"});
      setShowAddForm(false);
    } else setAddErr(r?._err||"Failed — email may already be in use.");
  }

  async function resetPassword(){
    if(!resetPass||resetPass.length<6){alert("Password must be at least 6 characters.");return;}
    setResetBusy(true);
    const r=await apiFetch(`/crickithub/org/admin/staff/${encodeURIComponent(resetTarget)}/password`,"PUT",{password:resetPass});
    setResetBusy(false);
    if(r?.ok){setResetTarget(null);setResetPass("");alert("Password updated. Share the new temporary password with the staff member.");}
    else alert("Reset failed — try again.");
  }

  async function deactivate(){
    if(!adminCodeInput.trim()){alert("Enter the admin code to deactivate.");return;}
    setDeactBusy(true);
    const r=await apiFetch(`/crickithub/org/admin/staff/${encodeURIComponent(deactTarget)}/deactivate`,"PUT",{adminCode:adminCodeInput.trim().toUpperCase()});
    setDeactBusy(false);
    if(r?.ok){
      setOrgInfo(o=>({...o,staff:(o.staff||[]).map(m=>m.email===deactTarget?{...m,active:false}:m)}));
      setDeactTarget(null);setAdminCodeInput("");
    } else alert(r?._err||"Incorrect admin code. Check and try again.");
  }

  async function reactivate(email){
    const r=await apiFetch(`/crickithub/org/admin/staff/${encodeURIComponent(email)}/reactivate`,"PUT",{});
    if(r?.ok) setOrgInfo(o=>({...o,staff:(o.staff||[]).map(m=>m.email===email?{...m,active:true}:m)}));
  }

  async function toggleCodeAccess(email,grant){
    const r=await apiFetch(`/crickithub/org/admin/staff/${encodeURIComponent(email)}/codeaccess`,"PUT",{grant});
    if(r?.ok) setOrgInfo(o=>({...o,staff:(o.staff||[]).map(m=>m.email===email?{...m,canSeeAdminCode:grant}:m)}));
    else alert(r?._err||"Permission denied — you must have admin code access yourself.");
  }

  const coaches=(orgInfo?.staff||[]).filter(m=>m.role==="COACH");
  const managers=(orgInfo?.staff||[]).filter(m=>m.role==="MANAGER");

  function StaffRow({m}){
    return(
      <div style={{padding:"10px 0",borderBottom:"0.5px solid rgba(0,0,0,0.07)"}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:8,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:160}}>
            <div style={{fontSize:13,fontWeight:700,color:m.active===false?"#9ca3af":"#1a1a1a"}}>{m.name}</div>
            <div style={{fontSize:11,color:"#9ca3af"}}>{m.email}{m.phone?" · "+m.phone:""}</div>
          </div>
          <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"wrap"}}>
            <Badge color={m.active===false?"gray":m.role==="COACH"?"green":"blue"}>{m.active===false?"Inactive":m.role==="COACH"?"Coach":"Manager"}</Badge>
            {m.canSeeAdminCode&&<Badge color="amber">Has code</Badge>}
          </div>
        </div>
        {/* Reset password inline */}
        {resetTarget===m.email
          ?<div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap",marginTop:8}}>
            <input type="password" style={{...cs.input,width:150,padding:"6px 10px"}} value={resetPass} onChange={e=>setResetPass(e.target.value)} placeholder="New password" autoFocus/>
            <button style={{...cs.btnP,padding:"6px 14px",fontSize:12,opacity:resetBusy?.6:1}} onClick={resetPassword} disabled={resetBusy}>{resetBusy?"Saving…":"Set password"}</button>
            <button style={cs.btnG} onClick={()=>{setResetTarget(null);setResetPass("");}}>Cancel</button>
          </div>
          :/* Deactivate code inline */
          deactTarget===m.email
          ?<div style={{background:"#fcebeb",border:"0.5px solid #F09595",borderRadius:8,padding:"10px",marginTop:8}}>
            <div style={{fontSize:12,color:"#A32D2D",marginBottom:8,fontWeight:600}}>Enter admin code to deactivate {m.name}</div>
            <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
              <input style={{...cs.input,width:130,textTransform:"uppercase",letterSpacing:"0.1em",fontFamily:"monospace"}} value={adminCodeInput} onChange={e=>setAdminCodeInput(e.target.value.toUpperCase())} placeholder="ORG-XXXXXX" autoFocus/>
              <button style={{...cs.btnP,background:"#A32D2D",padding:"6px 14px",fontSize:12,opacity:deactBusy?.6:1}} onClick={deactivate} disabled={deactBusy}>{deactBusy?"Deactivating…":"Confirm deactivate"}</button>
              <button style={cs.btnG} onClick={()=>{setDeactTarget(null);setAdminCodeInput("");}}>Cancel</button>
            </div>
          </div>
          :<div style={{display:"flex",gap:4,marginTop:6,flexWrap:"wrap"}}>
            <button style={cs.btnG} onClick={()=>{setResetTarget(m.email);setResetPass("");}}>Reset password</button>
            {canSeeAdminCode&&<button style={{...cs.btnG,color:m.canSeeAdminCode?"#854F0B":"#185FA5"}} onClick={()=>toggleCodeAccess(m.email,!m.canSeeAdminCode)}>
              {m.canSeeAdminCode?"Revoke code access":"Grant code access"}
            </button>}
            {m.active===false
              ?<button style={{...cs.btnG,color:G}} onClick={()=>reactivate(m.email)}>Reactivate</button>
              :<button style={{...cs.btnG,color:"#A32D2D"}} onClick={()=>{setDeactTarget(m.email);setAdminCodeInput("");}}>Deactivate</button>}
          </div>}
      </div>
    );
  }

  return(
    <div>
      <SectionHdr title="Org admin" sub="Manage coaches, managers and team details for your organisation."/>

      {loading?<div style={cs.muted}>Loading…</div>:<>

        {/* ── Org info + admin code ── */}
        <div style={{...cs.card,background:"#f0faf4",border:"1px solid #9FE1CB"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a"}}>{orgInfo?.orgName||"Your org"}</div>
              <div style={{fontSize:12,color:"#6b7280"}}>{(orgInfo?.plan==="SUSPENDED"||orgInfo?.plan==="suspended")?"No active subscription":"Plan: "+(orgInfo?.plan||"FREE")} · Registered {orgInfo?.createdAt?new Date(orgInfo.createdAt).toLocaleDateString():"—"}</div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:11,color:"#6b7280",marginBottom:3}}>Admin code</div>
              {canSeeAdminCode
                ?<div style={{display:"flex",alignItems:"center",gap:6}}>
                  {showCode
                    ?<span style={{fontFamily:"monospace",fontSize:14,fontWeight:700,color:G,letterSpacing:"0.1em"}}>{orgInfo?.adminCode||"—"}</span>
                    :<span style={{fontFamily:"monospace",fontSize:14,color:"#9ca3af",letterSpacing:"0.1em"}}>ORG-••••••</span>}
                  <button onClick={()=>setShowCode(s=>!s)} style={{...cs.btnG,padding:"3px 8px",fontSize:11}}>{showCode?"Hide":"Show"}</button>
                  {showCode&&<button onClick={()=>navigator.clipboard?.writeText(orgInfo?.adminCode||"")} style={{...cs.btnG,padding:"3px 8px",fontSize:11}}>Copy</button>}
                </div>
                :<span style={{fontFamily:"monospace",fontSize:14,color:"#9ca3af",letterSpacing:"0.1em"}}>ORG-••••••</span>}
              <div style={{fontSize:10,color:"#9ca3af",marginTop:3}}>{canSeeAdminCode?"Required to deactivate accounts":"Contact original registrant for code"}</div>
            </div>
          </div>
        </div>

        {/* ── Team details (editable by all) ── */}
        <div style={cs.card}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Team details</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
            <div style={{gridColumn:"1/-1"}}><label style={cs.label}>Team name</label><input style={cs.input} value={local.teamName||""} onChange={e=>setL("teamName",e.target.value)} placeholder="LA Hub Team A"/></div>
            <div><label style={cs.label}>Age category</label><select style={cs.select} value={local.ageCategory||"U13"} onChange={e=>setL("ageCategory",e.target.value)}><option>U11</option><option>U13</option><option>U15</option><option>U17</option><option>U19</option><option value="Open/Youth">Open/Youth</option></select></div>
            <div><label style={cs.label}>Coach name</label><input style={cs.input} value={local.coachName||""} onChange={e=>setL("coachName",e.target.value)} placeholder="Coach Ravi Kumar"/></div>
            <div><label style={cs.label}>Coach email</label><input type="email" style={cs.input} value={local.coachEmail||""} onChange={e=>setL("coachEmail",e.target.value)} placeholder="coach@org.com"/></div>
          </div>
          <div style={cs.row}><button style={cs.btnP} onClick={saveTeam}>Save team details</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>
        </div>

        {/* ── Add coach/manager form ── */}
        <div style={cs.card}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:showAddForm?10:0}}>
            <div>
              <div style={{fontSize:13,fontWeight:500}}>Add coach or manager</div>
              {!showAddForm&&<div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>Any logged-in coach or manager can add new staff accounts.</div>}
            </div>
            <button style={cs.btnP} onClick={()=>{setShowAddForm(s=>!s);setAddErr("");}}>{showAddForm?"Cancel":"+ Add staff"}</button>
          </div>
          {showAddForm&&<>
            {addErr&&<AlertBox type="red" msg={addErr} onClose={()=>setAddErr("")}/>}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
              <div><label style={cs.label}>Full name *</label><input style={cs.input} value={addForm.name} onChange={e=>setAddForm(f=>({...f,name:e.target.value}))} placeholder="Full name"/></div>
              <div><label style={cs.label}>Phone (optional)</label><input type="tel" style={cs.input} value={addForm.phone||""} onChange={e=>setAddForm(f=>({...f,phone:e.target.value}))} placeholder="+1 (555) 000-0000"/></div>
              <div style={{gridColumn:"1/-1"}}><label style={cs.label}>Email *</label><input type="email" style={cs.input} value={addForm.email} onChange={e=>setAddForm(f=>({...f,email:e.target.value}))} placeholder="staff@org.com"/></div>
              <div><label style={cs.label}>Role *</label>
                <div style={{display:"flex",gap:6}}>
                  {["COACH"].map(r=><button key={r} type="button" onClick={()=>setAddForm(f=>({...f,role:r}))} style={{flex:1,padding:"7px",border:`2px solid ${addForm.role===r?G:"rgba(0,0,0,0.15)"}`,borderRadius:6,background:addForm.role===r?"#e6f4ec":"#fff",color:addForm.role===r?G:"#6b7280",cursor:"pointer",fontSize:12,fontWeight:addForm.role===r?700:400,fontFamily:"inherit"}}>{r==="COACH"?"Coach":"Manager"}</button>)}
                </div>
              </div>
              <div></div>
              <div><label style={cs.label}>Temporary password *</label><input type="password" style={cs.input} value={addForm.password} onChange={e=>setAddForm(f=>({...f,password:e.target.value}))} placeholder="Min 6 characters"/></div>
              <div><label style={cs.label}>Confirm password *</label><input type="password" style={cs.input} value={addForm.confirm} onChange={e=>setAddForm(f=>({...f,confirm:e.target.value}))} placeholder="Repeat password"/></div>
            </div>
            <div style={{fontSize:11,color:"#9ca3af",marginBottom:10}}>Share the email + temporary password with the staff member. They can update their password from their profile.</div>
            <button style={{...cs.btnP,opacity:addBusy?.6:1}} onClick={addStaff} disabled={addBusy}>{addBusy?"Creating…":"Create account"}</button>
          </>}
        </div>

        {/* ── Coaches list ── */}
        <div style={cs.card}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:2}}>Coaches ({coaches.length})</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:8}}>Coaches have full access to all match tracking, reporting and analytics.</div>
          {coaches.length===0?<div style={cs.muted}>No coaches on record.</div>
          :coaches.map(m=><StaffRow key={m.email} m={m}/>)}
        </div>

        {/* ── Managers list ── */}
        <div style={cs.card}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:2}}>Managers ({managers.length})</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:8}}>Managers can schedule matches, assign squads, manage logistics and notes.</div>
          {managers.length===0?<div style={cs.muted}>No managers yet. Add one above.</div>
          :managers.map(m=><StaffRow key={m.email} m={m}/>)}
        </div>

      </>}
    </div>
  );
}


// ═══════════════════════════════════════════════════════════════════════════════
// TEAM ASSEMBLY — persistent squad + match selection
// ═══════════════════════════════════════════════════════════════════════════════
function TeamAssembly({user,squad,setSquad,selected,setSelected,teamSheet,setTeamSheet,teamLocked,setTeamLocked,teamAssigned,setTeamAssigned,teamAssignedBy,onConfirm,onSaveSquad,matchFrozen,matches,activeMatchId,onSelectMatch,apiFetch}){
  const [tab,setTab]=useState("squad");
  const [gName,setGName]=useState("");
  const [gRole,setGRole]=useState("BATTING");
  const [gCat,setGCat]=useState("U13");
  const [gEmail,setGEmail]=useState("");
  const [gPhone,setGPhone]=useState("");
  const [gGlobalId,setGGlobalId]=useState("");
  const [gGlobalIdBusy,setGGlobalIdBusy]=useState(false);
  const [gGlobalIdMsg,setGGlobalIdMsg]=useState(null); // {ok:bool, text:string}
  const [editId,setEditId]=useState(null);
  const [editRole,setEditRole]=useState("BATTING");
  const [editCat,setEditCat]=useState("U13");
  const [editName,setEditName]=useState("");
  const [editEmail,setEditEmail]=useState("");
  const [editPhone,setEditPhone]=useState("");
  const [editLinkCode,setEditLinkCode]=useState("");
  const [editLinkBusy,setEditLinkBusy]=useState(false);
  const [editLinkMsg,setEditLinkMsg]=useState(null); // {ok,text,name}

  async function verifyGlobalId(code,msgSetter,busySetter){
    const c=code.toUpperCase().trim();
    if(!c){msgSetter(null);return;}
    busySetter(true);msgSetter(null);
    const r=await apiFetch(`/crickithub/player/lookup?code=${c}`);
    busySetter(false);
    if(r?.found) msgSetter({ok:true,text:`✓ ${r.name} (${r.orgName})`,name:r.name});
    else msgSetter({ok:false,text:"Code not found in any org."});
  }

  async function linkCareer(playerId){
    const to=editLinkCode.toUpperCase().trim();
    const player=squad.find(p=>p.id===playerId);
    if(!player||!to) return;
    const from=player.accessCode;
    if(!from){setEditLinkMsg({ok:false,text:"This player has no access code yet — save them to squad first."});return;}
    if(!editLinkMsg?.ok){setEditLinkMsg({ok:false,text:"Verify the code first."});return;}
    if(!window.confirm(`Link ${player.name} (${from}) to career record of ${editLinkMsg.name} (${to})? This cannot be undone.`)) return;
    setEditLinkBusy(true);
    const r=await apiFetch("/crickithub/player/alias","POST",{fromCode:from,toCode:to});
    setEditLinkBusy(false);
    if(r?.ok){
      setEditLinkMsg({ok:true,text:`Career linked · ${to}`});
    } else {
      // Check if Lambda returned a chained alias error with canonical code
      const msg=r?.message||"Failed to link.";
      const chainMatch=msg.match(/Use the canonical code instead: (CM-[A-Z0-9]+)/);
      if(chainMatch){
        // Surface the canonical code with a tap-to-use button
        setEditLinkMsg({ok:false,text:msg,canonicalCode:chainMatch[1]});
      } else {
        setEditLinkMsg({ok:false,text:msg});
      }
    }
  }
  const [battingOrder,setBattingOrder]=useState([]);
  const [err,setErr]=useState("");
  const [showMatchPicker,setShowMatchPicker]=useState(false);

  const isCoach=user.role==="COACH";
  const isManager=user.role==="MANAGER";
  const canEdit=isCoach||isManager;

  useEffect(()=>{
    setBattingOrder(prev=>{
      const existing=prev.filter(id=>selected.has(id));
      const newIds=[...selected].filter(id=>!existing.includes(id));
      return [...existing,...newIds];
    });
  },[selected]);

  function addToSquad(){
    if(!gName.trim()){setErr("Name required.");return;}
    if(gGlobalId.trim()&&!gGlobalIdMsg?.ok){setErr("Verify the Global Player ID before adding.");return;}
    const code=gGlobalId.trim()?gGlobalId.trim().toUpperCase():undefined; // Lambda generates if not provided
    const p={id:"p"+Date.now(),name:gName.trim(),role:gRole,cat:gCat,email:gEmail.trim(),phone:gPhone.trim(),source:"manual",...(code&&{accessCode:code})};
    const ns=[...squad,p];
    setSquad(ns);onSaveSquad&&onSaveSquad(ns);
    setGName("");setGEmail("");setGPhone("");setGGlobalId("");setGGlobalIdMsg(null);setErr("");
  }
  function removeFromSquad(id){
    const ns=squad.filter(p=>p.id!==id);
    setSquad(ns);onSaveSquad&&onSaveSquad(ns);
    const sel=new Set(selected);sel.delete(id);setSelected(sel);
  }
  function startEdit(p){setEditId(p.id);setEditRole(p.role);setEditCat(p.cat||"U13");setEditName(p.name||"");setEditEmail(p.email||"");setEditPhone(p.phone||"");setEditLinkCode("");setEditLinkMsg(null);}
  function saveEdit(id){
    const orig=squad.find(p=>p.id===id);
    const nameChanged=orig&&editName.trim()&&editName.trim()!==orig.name;
    const ns=squad.map(p=>p.id===id?{...p,name:editName.trim()||p.name,email:editEmail.trim()||p.email,phone:editPhone.trim(),role:editRole,cat:editCat,accessCode:nameChanged?undefined:p.accessCode}:p);
    setSquad(ns);onSaveSquad&&onSaveSquad(ns);setEditId(null);
  }
  function toggle(id){
    if(matchFrozen)return;
    const ns=new Set(selected);ns.has(id)?ns.delete(id):ns.add(id);setSelected(ns);
  }
  function moveUp(idx){if(idx===0)return;const o=[...battingOrder];[o[idx-1],o[idx]]=[o[idx],o[idx-1]];setBattingOrder(o);}
  function moveDown(idx){if(idx===battingOrder.length-1)return;const o=[...battingOrder];[o[idx],o[idx+1]]=[o[idx+1],o[idx]];setBattingOrder(o);}

  // Step 1: Assign (Coach or Manager)
  function assignTeam(){
    if(selected.size<11){setErr("Select at least 11 players.");return;}
    const pm=Object.fromEntries(squad.map(p=>[p.id,p]));
    const players=[...selected].map(id=>pm[id]).filter(Boolean);
    if(players.length===0){setErr("Player list is empty — please refresh and try again.");return;}
    onConfirm(players,"assign",user.name);
    setErr("");setTab("match");
  }

  // Step 2: Confirm (Coach only)
  function confirmTeam(){
    if(selected.size<11){setErr("Select at least 11 players.");return;}
    const pm=Object.fromEntries(squad.map(p=>[p.id,p]));
    const ordered=battingOrder.filter(id=>selected.has(id)).map(id=>pm[id]).filter(Boolean);
    if(ordered.length===0){setErr("Player list is empty — please refresh and try again.");return;}
    setTeamSheet(ordered);setTeamLocked(true);
    onConfirm(ordered,"confirm",user.name);
    setErr("");setTab("match");
  }

  function unlock(){if(!window.confirm("Unlock team sheet? This allows changes to the assigned squad and batting order."))return;setTeamLocked(false);setTeamSheet([]);}
  const pm=Object.fromEntries(squad.map(p=>[p.id,p]));
  const activeMatch=matches?.find(m=>m.matchId===activeMatchId);
  const upcomingMatches=[...(matches||[])].filter(m=>!m.inactive).sort((a,b)=>a.date<b.date?-1:1);

  // Team status label
  const teamStatus=matchFrozen?"frozen":teamLocked?"confirmed":teamAssigned?"assigned":null;
  const statusColor={frozen:"gray",confirmed:"green",assigned:"amber"}[teamStatus]||"gray";

  return(
    <div>
      <SectionHdr title="Team assembly" sub="Build your squad, then assign players for this match."/>

      {/* ── Active match banner ── */}
      <div style={{...cs.card,background:activeMatch?"#f0faf4":"#faeeda",border:`1px solid ${activeMatch?"#9FE1CB":"#FAC775"}`,marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
          <div>
            {activeMatch
              ?<>
                <div style={{fontSize:12,color:"#6b7280",marginBottom:2}}>Active match</div>
                <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a"}}>vs {activeMatch.opponent||"TBC"}</div>
                <div style={{fontSize:12,color:"#6b7280"}}>{activeMatch.tournament?activeMatch.tournament+" · ":""}{activeMatch.date||"No date"}</div>
              </>
              :<div style={{fontSize:13,fontWeight:700,color:"#854F0B"}}>No match selected — select one to build a team sheet</div>}
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
            {teamStatus&&<Badge color={statusColor}>{teamStatus==="assigned"?`Assigned by ${teamAssignedBy||"coach"}`:teamStatus==="confirmed"?"Confirmed":"Frozen"}</Badge>}
            {canEdit&&<button style={cs.btnS} onClick={()=>setShowMatchPicker(p=>!p)}>{showMatchPicker?"Cancel":"Change match"}</button>}
          </div>
        </div>
        {showMatchPicker&&<div style={{marginTop:12,borderTop:"0.5px solid rgba(0,0,0,0.10)",paddingTop:10}}>
          <div style={{fontSize:12,fontWeight:700,color:"#6b7280",marginBottom:8}}>Select a match:</div>
          {upcomingMatches.length===0
            ?<div style={cs.muted}>No matches scheduled yet.</div>
            :upcomingMatches.map(m=>{
              const isSel=m.matchId===activeMatchId;
              const [y,mo,d]=(m.date||"").split("-");
              const dateStr=m.date?new Date(+y,+mo-1,+d).toLocaleDateString("en-US",{weekday:"short",day:"numeric",month:"short"}):"No date";
              return(
                <div key={m.matchId} onClick={()=>{onSelectMatch&&onSelectMatch(m.matchId);setShowMatchPicker(false);setTab("match");}}
                  style={{...cs.row,padding:"8px 10px",borderRadius:8,cursor:"pointer",marginBottom:4,background:isSel?"#e6f4ec":"#fff",border:`1px solid ${isSel?G:"rgba(0,0,0,0.10)"}`}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a"}}>vs {m.opponent||"TBC"}</div>
                    <div style={{fontSize:12,color:"#6b7280"}}>{dateStr}{m.time?" · "+m.time:""}{m.tournament?" · "+m.tournament:""}</div>
                  </div>
                  {isSel&&<Badge color="green">Active</Badge>}
                </div>
              );
            })}
        </div>}
      </div>

      <div style={{display:"flex",gap:6,marginBottom:14}}>
        {["squad","match"].map(t=><button key={t} onClick={()=>setTab(t)} style={{padding:"7px 18px",border:"0.5px solid",borderColor:tab===t?G:"rgba(0,0,0,0.15)",borderRadius:8,background:tab===t?G:"#fff",color:tab===t?"#fff":"#1a1a1a",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>{t==="squad"?"Squad manager":"Match team"}</button>)}
      </div>
      <AlertBox type="red" msg={err} onClose={()=>setErr("")}/>

      {/* ══ SQUAD MANAGER TAB ══ */}
      {tab==="squad"&&<>
        {canEdit&&<div style={{...cs.card,background:"#f6fdf9",border:`1px solid #c8e6d6`}}>
          <div style={{fontSize:13,fontWeight:700,color:G,marginBottom:10,display:"flex",alignItems:"center",gap:6}}><span>➕</span> Add player to squad</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
            <div style={{gridColumn:"1/-1"}}><label style={cs.label}>Player name *</label><input style={cs.input} value={gName} onChange={e=>setGName(e.target.value)} placeholder="Full name"/></div>
            <div><label style={cs.label}>Role</label><select style={cs.select} value={gRole} onChange={e=>setGRole(e.target.value)}>{Object.entries(ROLES).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select></div>
            <div><label style={cs.label}>Age category</label><select style={cs.select} value={gCat} onChange={e=>setGCat(e.target.value)}><option>U11</option><option>U13</option><option>U15</option><option>U17</option><option>U19</option><option value="Open/Youth">Open/Youth</option></select></div>
            <div><label style={cs.label}>Email (optional — needed for player access)</label><input type="email" style={cs.input} value={gEmail} onChange={e=>setGEmail(e.target.value)} placeholder="player@email.com"/></div>
            <div><label style={cs.label}>Phone (optional)</label><input type="tel" style={cs.input} value={gPhone} onChange={e=>setGPhone(e.target.value)} placeholder="+1 (555) 000-0000"/></div>
            <div style={{gridColumn:"1/-1"}}>
              <label style={cs.label}>Global Player ID (optional — if this player has played at another school)</label>
              <div style={{display:"flex",gap:6,alignItems:"center"}}>
                <input style={{...cs.input,flex:1,textTransform:"uppercase",fontFamily:"monospace",letterSpacing:"0.08em"}} value={gGlobalId} onChange={e=>{setGGlobalId(e.target.value.toUpperCase());setGGlobalIdMsg(null);}} placeholder="CM-XXXXXX"/>
                <button type="button" style={{...cs.btnG,whiteSpace:"nowrap",opacity:gGlobalIdBusy?.5:1}} disabled={gGlobalIdBusy||!gGlobalId.trim()} onClick={()=>verifyGlobalId(gGlobalId,setGGlobalIdMsg,setGGlobalIdBusy)}>{gGlobalIdBusy?"Checking…":"Verify"}</button>
              </div>
              {gGlobalIdMsg&&<div style={{fontSize:11,marginTop:4,color:gGlobalIdMsg.ok?"#1A7A4A":"#A32D2D"}}>{gGlobalIdMsg.text}</div>}
              {!gGlobalId&&<div style={{fontSize:11,color:"#9ca3af",marginTop:3}}>Leave blank to auto-generate a new code.</div>}
            </div>
          </div>
          <button style={cs.btnP} onClick={addToSquad}>Add to squad</button>
        </div>}
        {squad.length===0
          ?<div style={{...cs.card,background:"#f8faf9",textAlign:"center",padding:"32px 20px"}}>
            <div style={{fontSize:36,marginBottom:10}}>👥</div>
            <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>No players yet</div>
            <div style={cs.muted}>Add your first player using the form above.</div>
          </div>
          :<div style={cs.card}>
            <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Squad ({squad.length} players)</div>
            <div style={{...cs.muted,marginBottom:10}}>Tap role/category badge to edit. Access codes let players log in to see their own stats.</div>
            {squad.map(p=>(
              <div key={p.id} style={{padding:"8px 0",borderBottom:"0.5px solid rgba(0,0,0,0.07)"}}>
                {editId===p.id
                  ?<div style={{display:"flex",flexDirection:"column",gap:8}}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <div><label style={cs.label}>Name</label><input style={cs.input} value={editName} onChange={e=>setEditName(e.target.value)} placeholder="Player name"/></div>
                      <div><label style={cs.label}>Email</label><input type="email" style={cs.input} value={editEmail} onChange={e=>setEditEmail(e.target.value)} placeholder="player@email.com"/></div>
                      <div><label style={cs.label}>Phone</label><input type="tel" style={cs.input} value={editPhone} onChange={e=>setEditPhone(e.target.value)} placeholder="+1 (555) 000-0000"/></div>
                      <div><label style={cs.label}>Role</label><select style={cs.select} value={editRole} onChange={e=>setEditRole(e.target.value)}>{Object.entries(ROLES).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select></div>
                      <div><label style={cs.label}>Age cat.</label><select style={cs.select} value={editCat} onChange={e=>setEditCat(e.target.value)}><option>U11</option><option>U13</option><option>U15</option><option>U17</option><option>U19</option><option value="Open/Youth">Open/Youth</option></select></div>
                    </div>
                    <div style={cs.row}><button style={cs.btnP} onClick={()=>saveEdit(p.id)}>Save</button><button style={cs.btnG} onClick={()=>setEditId(null)}>Cancel</button></div>
                    {p.accessCode&&<div style={{marginTop:10,padding:"10px 12px",background:"#f8f9fb",borderRadius:8,border:"0.5px solid rgba(0,0,0,0.08)"}}>
                      <div style={{fontSize:12,fontWeight:700,color:"#185FA5",marginBottom:6}}>Link to career record</div>
                      <div style={{fontSize:11,color:"#6b7280",marginBottom:8}}>If this player has a different access code at another school, link them here to unify career stats.</div>
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <input style={{...cs.input,flex:1,textTransform:"uppercase",fontFamily:"monospace",letterSpacing:"0.08em",fontSize:12}} value={editLinkCode} onChange={e=>{setEditLinkCode(e.target.value.toUpperCase());setEditLinkMsg(null);}} placeholder="CM-XXXXXX (their code at other school)"/>
                        <button type="button" style={{...cs.btnG,whiteSpace:"nowrap",fontSize:11,opacity:editLinkBusy?.5:1}} disabled={editLinkBusy||!editLinkCode.trim()} onClick={()=>verifyGlobalId(editLinkCode,setEditLinkMsg,setEditLinkBusy)}>{editLinkBusy?"Checking…":"Verify"}</button>
                      </div>
                      {editLinkMsg&&<div style={{fontSize:11,marginTop:4,color:editLinkMsg.ok?"#1A7A4A":"#A32D2D"}}>
                        {editLinkMsg.text}
                        {editLinkMsg.canonicalCode&&<button onClick={()=>{setEditLinkCode(editLinkMsg.canonicalCode);setEditLinkMsg(null);}} style={{display:"block",marginTop:6,padding:"3px 10px",border:"1.5px solid #185FA5",borderRadius:6,background:"#eef4fb",color:"#185FA5",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"monospace",letterSpacing:"0.08em"}}>Use {editLinkMsg.canonicalCode} instead →</button>}
                      </div>}
                      {editLinkMsg?.ok&&!editLinkMsg.text.startsWith("Career linked")&&<button style={{...cs.btnP,marginTop:8,fontSize:12,opacity:editLinkBusy?.5:1}} disabled={editLinkBusy} onClick={()=>linkCareer(p.id)}>Confirm link</button>}
                    </div>}
                  </div>
                  :<div>
                    <div style={cs.rowWrap}>
                      <span style={{flex:1,fontSize:14,fontWeight:700,color:canEdit?"#1A7A4A":"#1a1a1a",cursor:canEdit?"pointer":"default",textDecoration:canEdit?"underline dotted":"none"}} onClick={()=>canEdit&&startEdit(p)} title={canEdit?"Click to edit player details":""}>{p.name}</span>
                      <button onClick={()=>startEdit(p)} style={{...cs.badge("blue"),cursor:"pointer",border:"none",fontFamily:"inherit"}}>{ROLES[p.role]?.label}</button>
                      <button onClick={()=>startEdit(p)} style={{...cs.badge("gray"),cursor:"pointer",border:"none",fontFamily:"inherit"}}>{p.cat||"U13"}</button>
                      {canEdit&&<button onClick={()=>removeFromSquad(p.id)} style={{...cs.btnG,color:"#A32D2D",padding:"3px 8px",fontSize:11}}>Remove</button>}
                    </div>
                    {p.accessCode&&<div style={{display:"flex",alignItems:"center",gap:6,marginTop:4}}>
                      <span style={{fontSize:11,color:"#9ca3af"}}>Access code:</span>
                      <span style={{fontFamily:"monospace",fontSize:12,fontWeight:700,color:"#185FA5",background:"#e6f1fb",padding:"2px 8px",borderRadius:6,letterSpacing:"0.08em"}}>{p.accessCode}</span>
                      <button onClick={()=>navigator.clipboard?.writeText(p.accessCode)} style={{fontSize:10,padding:"2px 7px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:4,background:"#fff",cursor:"pointer",color:"#6b7280",fontFamily:"inherit"}}>Copy</button>
                    </div>}
                    {(p.email||p.phone)&&<div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>{[p.email,p.phone].filter(Boolean).join(" · ")}</div>}
                  </div>}
              </div>
            ))}
          </div>}
      </>}

      {/* ══ MATCH TEAM TAB ══ */}
      {tab==="match"&&<>

        {/* Player selection — available to Coach and Manager if not frozen */}
        {!matchFrozen&&canEdit&&!teamLocked&&<div style={cs.card}>
          <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Select players for this match</div>
          <div style={{...cs.muted,marginBottom:10}}>Tick players from your squad. Minimum 11.</div>
          {squad.length===0
            ?<div style={cs.muted}>Add players to your squad first (Squad manager tab).</div>
            :squad.map(p=>{
              const sel=selected.has(p.id);
              return(<div key={p.id} style={{...cs.row,padding:"7px 0",borderBottom:"0.5px solid rgba(0,0,0,0.07)"}}>
                <button onClick={()=>toggle(p.id)} style={{width:28,height:28,borderRadius:"50%",border:`2px solid ${sel?G:"rgba(0,0,0,0.20)"}`,background:sel?G:"transparent",color:sel?"#fff":"transparent",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>✓</button>
                <span style={{flex:1,fontSize:14,fontWeight:700,color:"#1a1a1a",marginLeft:8}}>{p.name}</span>
                <span style={cs.muted}>{ROLES[p.role]?.label} · {p.cat||"U13"}</span>
              </div>);
            })}
        </div>}

        {/* Batting order — Coach sees full controls, Manager sees greyed out view */}
        {selected.size>0&&!teamLocked&&!matchFrozen&&<div style={cs.card}>
          <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Batting order ({selected.size} selected)</div>
          {isManager&&<div style={{...cs.muted,marginBottom:8,background:"#faeeda",padding:"6px 10px",borderRadius:6,color:"#854F0B"}}>Batting order is set by the Coach on match day.</div>}
          <div style={{...cs.muted,marginBottom:8}}>{isCoach?"Use arrows to set batting order before confirming.":"Players are listed below — order will be set by the Coach."}</div>
          {battingOrder.filter(id=>selected.has(id)).map((id,idx)=>{
            const p=pm[id];if(!p)return null;
            return(<div key={id} style={{...cs.row,padding:"6px 0",borderBottom:"0.5px solid rgba(0,0,0,0.07)",opacity:isManager?.75:1}}>
              <span style={{width:24,fontSize:13,fontWeight:700,color:"#9ca3af",flexShrink:0}}>{idx+1}.</span>
              <span style={{flex:1,fontSize:14,fontWeight:700,color:"#1a1a1a"}}>{p.name}</span>
              <span style={{...cs.muted,marginRight:8}}>{ROLES[p.role]?.label}</span>
              {isCoach&&<div style={{display:"flex",gap:4}}>
                <button onClick={()=>moveUp(idx)} disabled={idx===0} style={{width:30,height:30,border:"1px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",cursor:idx===0?"not-allowed":"pointer",opacity:idx===0?.3:1,fontSize:14,fontFamily:"inherit"}}>↑</button>
                <button onClick={()=>moveDown(idx)} style={{width:30,height:30,border:"1px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>↓</button>
              </div>}
            </div>);
          })}
          <div style={{marginTop:12,display:"flex",gap:8,flexWrap:"wrap"}}>
            {/* Both Coach and Manager can Assign */}
            <button style={{...cs.btnS,opacity:selected.size<11?.4:1}} onClick={assignTeam} disabled={selected.size<11}>
              Assign team
            </button>
            {/* Only Coach can Confirm */}
            {isCoach&&<button style={{...cs.btnP,opacity:selected.size<11?.4:1}} onClick={confirmTeam} disabled={selected.size<11}>
              Confirm team sheet
            </button>}
          </div>
          {isManager&&<div style={{fontSize:11,color:"#9ca3af",marginTop:8}}>Tap "Assign team" to save the squad for logistics planning. The Coach will confirm the final batting order on match day.</div>}
          {isCoach&&<div style={{fontSize:11,color:"#9ca3af",marginTop:8}}>Assign saves the squad for logistics. Confirm locks the batting order and enables the match trackers.</div>}
        </div>}

        {/* Re-edit after assign — Coach can make changes before confirming */}
        {teamAssigned&&!teamLocked&&!matchFrozen&&isCoach&&<div style={{...cs.card,background:"#faeeda",border:"1px solid #FAC775",marginBottom:8}}>
          <div style={{fontSize:13,fontWeight:700,color:"#854F0B",marginBottom:4}}>Team assigned — ready to confirm</div>
          <div style={{fontSize:12,color:"#854F0B",marginBottom:10}}>You can add/swap players or update the batting order, then confirm when ready.</div>
          <button style={{...cs.btnP,background:"#854F0B"}} onClick={()=>{setTeamAssigned(false);}}>Edit team</button>
        </div>}

        {/* Team status card */}
        <div style={{...cs.card,background:teamLocked?"#f0faf4":teamAssigned?"#fefaf0":"#f8f9f7",border:`1px solid ${teamLocked?"#9FE1CB":teamAssigned?"#FAC775":"rgba(0,0,0,0.08)"}`}}>
          <div style={{...cs.rowWrap,justifyContent:"space-between",marginBottom:8}}>
            <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a"}}>
              {matchFrozen?"Frozen team":teamLocked?"Confirmed team":teamAssigned?"Assigned squad":"Team"}
              {teamSheet.length>0&&` (${teamSheet.length})`}
            </div>
            <div style={cs.row}>
              {teamLocked&&!matchFrozen&&isCoach&&<button style={cs.btnG} onClick={unlock}>Unlock</button>}
              {teamStatus&&<Badge color={statusColor}>{teamStatus}</Badge>}
            </div>
          </div>
          {teamAssigned&&teamAssignedBy&&<div style={{fontSize:11,color:"#854F0B",marginBottom:8}}>Assigned by {teamAssignedBy}</div>}
          {teamSheet.length===0
            ?<div style={cs.muted}>No team assigned yet.</div>
            :<div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {teamSheet.map((p,i)=>(
                <span key={p.id} style={{display:"inline-flex",alignItems:"center",gap:4,background:"#fff",border:"0.5px solid rgba(0,0,0,0.12)",padding:"4px 12px",borderRadius:20,fontSize:13,fontWeight:600}}>
                  {teamLocked&&<span style={{color:"#9ca3af"}}>{i+1}.</span>}{p.name}<span style={cs.muted}>{ROLES[p.role]?.label}</span>
                </span>
              ))}
            </div>}
        </div>
      </>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// HUB RULES — Tournament quota configuration
// ═══════════════════════════════════════════════════════════════════════════════
const DEFAULT_HUB_RULES = {
  BATTING:    {u11Min:20,u11Max:30,u13Min:20,u13Max:30,u15Min:25,u15Max:35,bowlU11Min:0,bowlU11Max:1,bowlU13Min:0,bowlU13Max:1,bowlU15Min:0,bowlU15Max:1},
  BATTING_AR: {u11Min:10,u11Max:20,u13Min:10,u13Max:20,u15Min:15,u15Max:25,bowlU11Min:1,bowlU11Max:2,bowlU13Min:1,bowlU13Max:2,bowlU15Min:1,bowlU15Max:2},
  BOWLING_AR: {u11Min:5, u11Max:15,u13Min:5, u13Max:15,u15Min:10,u15Max:20,bowlU11Min:2,bowlU11Max:4,bowlU13Min:2,bowlU13Max:4,bowlU15Min:3,bowlU15Max:4},
  BOWLING:    {u11Min:0, u11Max:10,u13Min:0, u13Max:10,u15Min:0, u15Max:10,bowlU11Min:3,bowlU11Max:5,bowlU13Min:3,bowlU13Max:5,bowlU15Min:4,bowlU15Max:6},
  WK:         {u11Min:20,u11Max:30,u13Min:20,u13Max:30,u15Min:25,u15Max:35,bowlU11Min:0,bowlU11Max:1,bowlU13Min:0,bowlU13Max:1,bowlU15Min:0,bowlU15Max:1},
};
function HubRules({user,hubRules,setHubRules,onSave,saveMsg,matches}){
  const [local,setLocal]=useState(()=>({...DEFAULT_HUB_RULES,...hubRules}));
  const canEdit=user.role==="COACH"||user.role==="MANAGER";
  useEffect(()=>{setLocal(r=>({...DEFAULT_HUB_RULES,...r,...hubRules}));},[]);
  function setField(role,field,val){setLocal(r=>({...r,[role]:{...r[role],[field]:parseInt(val)||0}}));}
  function save(){setHubRules(local);onSave&&onSave(local);}
  const tournaments=[...new Set((matches||[]).filter(m=>m.tournament).map(m=>m.tournament))];
  const [selTournament,setSelTournament]=useState(tournaments[0]||"");
  const roleLabels={BATTING:"Batter",BATTING_AR:"Batting All Rounder",BOWLING_AR:"Bowling All Rounder",BOWLING:"Bowler",WK:"Wicketkeeper"};
  return(
    <div>
      <SectionHdr title="Hub rules" sub="Set batting and bowling quotas per tournament. These drive the quota bars in Batting and Bowling trackers."/>
      {tournaments.length>0&&<div style={{...cs.card,marginBottom:0}}>
        <label style={cs.label}>Tournament</label>
        <select style={cs.select} value={selTournament} onChange={e=>setSelTournament(e.target.value)}>
          {tournaments.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        {selTournament&&<div style={{fontSize:12,color:"#6b7280",marginTop:6}}>Rules below apply to: <strong>{selTournament}</strong></div>}
      </div>}
      {["BATTING","BATTING_AR","BOWLING_AR","BOWLING","WK"].map(role=>{
        const r=local[role]||{};
        return(<div key={role} style={cs.card}>
          <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:10}}>{roleLabels[role]}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:6}}>
            <div style={{gridColumn:"1/-1",fontSize:12,fontWeight:600,color:"#6b7280",borderBottom:"0.5px solid rgba(0,0,0,0.08)",paddingBottom:4,marginBottom:4}}>BATTING QUOTA (balls)</div>
            <div><label style={cs.label}>U11 min balls</label><input type="number" style={cs.input} value={r.u11Min||0} onChange={e=>setField(role,"u11Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U11 max balls</label><input type="number" style={cs.input} value={r.u11Max||0} onChange={e=>setField(role,"u11Max",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U13 min balls</label><input type="number" style={cs.input} value={r.u13Min||0} onChange={e=>setField(role,"u13Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U13 max balls</label><input type="number" style={cs.input} value={r.u13Max||0} onChange={e=>setField(role,"u13Max",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U15 min balls</label><input type="number" style={cs.input} value={r.u15Min||0} onChange={e=>setField(role,"u15Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U15 max balls</label><input type="number" style={cs.input} value={r.u15Max||0} onChange={e=>setField(role,"u15Max",e.target.value)} disabled={!canEdit}/></div>
            <div style={{gridColumn:"1/-1",fontSize:12,fontWeight:600,color:"#6b7280",borderBottom:"0.5px solid rgba(0,0,0,0.08)",paddingBottom:4,marginBottom:4,marginTop:4}}>BOWLING QUOTA (overs)</div>
            <div><label style={cs.label}>U11 min overs</label><input type="number" style={cs.input} value={r.bowlU11Min||0} onChange={e=>setField(role,"bowlU11Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U11 max overs</label><input type="number" style={cs.input} value={r.bowlU11Max||0} onChange={e=>setField(role,"bowlU11Max",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U13 min overs</label><input type="number" style={cs.input} value={r.bowlU13Min||0} onChange={e=>setField(role,"bowlU13Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U13 max overs</label><input type="number" style={cs.input} value={r.bowlU13Max||0} onChange={e=>setField(role,"bowlU13Max",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U15 min overs</label><input type="number" style={cs.input} value={r.bowlU15Min||0} onChange={e=>setField(role,"bowlU15Min",e.target.value)} disabled={!canEdit}/></div>
            <div><label style={cs.label}>U15 max overs</label><input type="number" style={cs.input} value={r.bowlU15Max||0} onChange={e=>setField(role,"bowlU15Max",e.target.value)} disabled={!canEdit}/></div>
          </div>
        </div>);
      })}
      {canEdit&&<div style={cs.row}><button style={cs.btnP} onClick={save}>Save Hub rules</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// SEASON ANALYTICS — Pro feature, gated by org plan
// ═══════════════════════════════════════════════════════════════════════════════

// ── Player PDF export — rich visual report using html2canvas ─────────────────
async function exportPlayerPDF(pdata,season,careerView,setExporting){
  if(!pdata)return;
  setExporting(true);

  // ── Colours ───────────────────────────────────────────────────────────────
  const G="#1A7A4A",CA="#EF9F27",CR="#E24B4A",CB="#185FA5",CT="#5DCAA5",CP="#6B21A8";
  const TRACK="#f1efe8";

  // ── Stats ─────────────────────────────────────────────────────────────────
  const fmtD=d=>{if(!d)return"?";const[y,mo,dy]=d.split("-");return new Date(+y,+mo-1,+dy).toLocaleDateString("en-US",{month:"short",day:"numeric"});};
  const lbl=m=>careerView?fmtD(m.date)+(m.tournament?" ["+m.tournament.slice(0,5)+"]":""):"vs "+(m.opponent||"?").slice(0,16);

  const bm=[...pdata.matches].filter(m=>m.batting).sort((a,b)=>a.date<b.date?-1:1);
  const bowlM=[...pdata.matches].filter(m=>m.bowling&&m.bowling.overs>0).sort((a,b)=>a.date<b.date?-1:1);
  const fldM=[...pdata.matches].filter(m=>m.fielding).sort((a,b)=>a.date<b.date?-1:1);

  const batPM=bm.map(m=>{
    const log=m.batting?.ballLog||[];
    const balls=m.batting?.balls||0,runs=m.batting?.runs||0,dots=m.batting?.dots||0;
    const s6=log.filter(b=>b==="6").length,s4=log.filter(b=>b==="4").length;
    const s3=log.filter(b=>b==="3").length,s2=log.filter(b=>b==="2").length,s1=log.filter(b=>b==="1").length;
    const bR=s4*4+s6*6,bB=s4+s6;
    const nbSR=balls-bB>0?Math.round((runs-bR)/(balls-bB)*100):0;
    const sr=balls>0?Math.round(runs/balls*100):0;
    const dot=balls>0?Math.round(dots/balls*100):0;
    const q=ROLES[pdata.role]?.[(m.batting?.cat||"u13").toLowerCase()]||[20,30];
    const qPct=q[1]>0?Math.round(balls/q[1]*100):0;
    return{label:lbl(m),balls,runs,dots,sr,dot,s6,s4,s3,s2,s1,nbSR,qPct,status:m.batting?.status||""};
  });
  const tb=bm.reduce((a,m)=>a+(m.batting?.balls||0),0);
  const tr=bm.reduce((a,m)=>a+(m.batting?.runs||0),0);
  const td=bm.reduce((a,m)=>a+(m.batting?.dots||0),0);
  const avgSR=tb>0?Math.round(tr/tb*100):0;
  const avgDot=tb>0?Math.round(td/tb*100):0;
  const qm=bm.filter(m=>["met","retired"].includes(m.batting?.status)).length;
  const batRet=bm.filter(m=>m.batting?.status==="retired").length;

  const bowlPM=bowlM.map(m=>{
    const balls=(m.bowling.overs||0)*6+(m.bowling.legalInOver||0);
    const gd=m.bowling.good||0,op=m.bowling.overpitch||0,ft=m.bowling.fullToss||0,sh=m.bowling.short||0;
    const tot=gd+op+ft+sh||1;
    const cr=balls>0?parseFloat((gd/Math.max(1,balls-gd)).toFixed(2)):0;
    const econ=m.bowling.overs>0?parseFloat((m.bowling.runs/m.bowling.overs).toFixed(1)):0;
    const dot=balls>0?Math.round(gd/balls*100):0;
    return{label:lbl(m),balls,econ,wkts:m.bowling.wickets||0,gd,op,ft,sh,tot,dot,cr,wd:m.bowling.wides||0,nb:m.bowling.noBalls||0};
  });
  const bto=bowlM.reduce((a,m)=>a+(m.bowling.overs||0),0);
  const btr=bowlM.reduce((a,m)=>a+(m.bowling.runs||0),0);
  const btw=bowlM.reduce((a,m)=>a+(m.bowling.wickets||0),0);
  const btgd=bowlM.reduce((a,m)=>a+(m.bowling.good||0),0);
  const btft=bowlM.reduce((a,m)=>a+(m.bowling.fullToss||0),0);
  const btsh=bowlM.reduce((a,m)=>a+(m.bowling.short||0),0);
  const btwd=bowlM.reduce((a,m)=>a+(m.bowling.wides||0),0);
  const btnb=bowlM.reduce((a,m)=>a+(m.bowling.noBalls||0),0);
  const btbl=bto*6+btwd+btnb;
  const avgEcon=bto>0?(btr/bto).toFixed(1):"-";
  const wsr=btw>0?Math.round(btbl/btw):"-";
  const gdPct=btbl>0?Math.round(btgd/btbl*100):0;
  const lossPct=btbl>0?Math.round((btft+btsh)/btbl*100):0;
  const avgCR=bowlPM.length>0?parseFloat((bowlPM.reduce((a,p)=>a+p.cr,0)/bowlPM.length).toFixed(2)):0;
  const bestCR=bowlPM.reduce((b,p)=>p.cr>b.cr?p:b,{cr:-1,label:""});

  const fsum=k=>fldM.reduce((a,m)=>a+(m.fielding?.[k]||0),0);
  const ftc=fsum("catches"),fmc=fsum("missedCatch"),fro=fsum("runouts"),fmro=fsum("missedRunout");
  const fst=fsum("stumpings"),fmst=fsum("missedStumping");
  const fws=fsum("widesSaved"),fbg=fsum("byesGiven"),frs=fsum("runsSaved"),ffm=fsum("misfields");
  const ftot=ftc+fro+fst,fmiss=fmc+fmro+fmst,fnet=ftot-fmiss;
  const fpct=ftot+fmiss>0?Math.round(ftot/(ftot+fmiss)*100):0;
  const fsp=fsum("sports");

  // ── HTML snippet helpers (NO gap/grid — use flex+margin or table instead) ─
  // html2canvas 1.4.1 hangs on CSS gap — we use margin-right on flex children instead

  const e=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");

  function badge(txt,bg,col){
    return `<span style="background:${bg};color:${col};border-radius:4px;padding:1px 7px;font-size:10px;font-weight:600;margin-left:5px;">${e(txt)}</span>`;
  }

  function mrow(label,val,badgeTxt,badgeBg,badgeCol,valCol){
    return `<div style="display:flex;justify-content:space-between;align-items:center;padding:5px 0;border-bottom:0.5px solid rgba(0,0,0,0.07);">
      <span style="font-size:12px;color:#4a5568;">${e(label)}</span>
      <span style="font-size:12px;font-weight:600;color:${valCol||"#1a1a1a"};">${e(String(val))}${badgeTxt?badge(badgeTxt,badgeBg,badgeCol):""}</span>
    </div>`;
  }

  function hbar(label,pct,clr,valTxt,note){
    return `<div style="margin-bottom:8px;">
      <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:3px;">
        <span style="font-size:11px;color:#1a1a1a;font-weight:500;">${e(label)}</span>
        <span style="font-size:11px;color:${clr};font-weight:600;">${e(valTxt)}${note?` <span style="font-size:10px;color:#9ca3af;font-weight:400;">${e(note)}</span>`:""}</span>
      </div>
      <div style="height:10px;background:${TRACK};border-radius:5px;overflow:hidden;">
        <div style="height:100%;width:${Math.min(100,Math.max(0,pct))}%;background:${clr};border-radius:5px;"></div>
      </div>
    </div>`;
  }

  function segbar(label,segs,tot,rightTxt){
    const total=tot||segs.reduce((a,s)=>a+s.v,0)||1;
    const fills=segs.map(s=>s.v>0?`<div style="height:100%;width:${Math.round(s.v/total*100)}%;background:${s.c};display:inline-block;"></div>`:"").join("");
    return `<div style="margin-bottom:8px;">
      <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:3px;">
        <span style="font-size:11px;color:#1a1a1a;font-weight:500;">${e(label)}</span>
        <span style="font-size:10px;color:#9ca3af;">${e(rightTxt)}</span>
      </div>
      <div style="height:10px;background:${TRACK};border-radius:5px;overflow:hidden;white-space:nowrap;font-size:0;">${fills}</div>
    </div>`;
  }

  function crbar(label,pct,cr){
    const clr=cr>=1.5?G:cr>=0.8?CA:CR;
    return `<div style="display:flex;align-items:center;margin-bottom:7px;">
      <span style="font-size:10px;color:#6b7280;width:60px;flex-shrink:0;">${e(label)}</span>
      <div style="flex:1;height:18px;background:#f1f5f9;border-radius:4px;overflow:hidden;position:relative;">
        <div style="height:100%;width:${Math.min(100,pct)}%;background:${clr};border-radius:4px;display:flex;align-items:center;padding-left:7px;box-sizing:border-box;">
          <span style="font-size:10px;color:#fff;font-weight:700;white-space:nowrap;">${pct}% GL</span>
        </div>
      </div>
      <span style="font-size:11px;font-weight:700;color:#1a1a1a;width:58px;text-align:right;flex-shrink:0;">CR: ${cr.toFixed(2)}</span>
    </div>`;
  }

  function negbar(label,pos,neg,posL,negL){
    const mx=Math.max(pos,neg,1);
    return `<div style="margin-bottom:9px;">
      <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:3px;">
        <span style="font-size:11px;color:#1a1a1a;font-weight:500;">${e(label)}</span>
        <span style="font-size:10px;">${neg>0?`<span style="color:#991b1b;font-weight:600;">&#8722;${neg} ${e(negL)}</span>`:`<span style="color:#9ca3af;">&#8722;0</span>`} &nbsp; ${pos>0?`<span style="color:#166534;font-weight:600;">+${pos} ${e(posL)}</span>`:`<span style="color:#9ca3af;">+0</span>`}</span>
      </div>
      <div style="display:flex;align-items:center;">
        <div style="flex:1;height:9px;background:#f3edf9;border-radius:5px 0 0 5px;overflow:hidden;display:flex;justify-content:flex-end;">
          ${neg>0?`<div style="width:${Math.round(neg/mx*100)}%;background:#A32D2D;height:100%;border-radius:3px 0 0 3px;"></div>`:""}
        </div>
        <div style="width:3px;height:14px;background:#6B21A8;opacity:0.3;flex-shrink:0;"></div>
        <div style="flex:1;height:9px;background:#f3edf9;border-radius:0 5px 5px 0;overflow:hidden;">
          ${pos>0?`<div style="width:${Math.round(pos/mx*100)}%;background:#1A7A4A;height:100%;border-radius:0 3px 3px 0;"></div>`:""}
        </div>
      </div>
    </div>`;
  }

  // Vertical bar chart — uses table for layout (html2canvas-safe)
  function colchart(items,maxVal,note){
    const maxH=80;
    const cols=items.map(it=>{
      const h=maxVal>0?Math.max(4,Math.round(it.v/maxVal*maxH)):4;
      const clr=it.c;
      return `<td style="text-align:center;vertical-align:bottom;padding:0 4px;width:${Math.round(100/items.length)}%;">
        <div style="font-size:11px;font-weight:700;color:${clr};margin-bottom:3px;">${e(String(it.v))}</div>
        <div style="height:${h}px;background:${clr};border-radius:3px 3px 0 0;"></div>
        <div style="font-size:10px;color:#6b7280;margin-top:3px;">${e(it.l)}</div>
      </td>`;
    }).join("");
    return `<table style="width:100%;border-collapse:collapse;height:${maxH+36}px;"><tbody><tr style="vertical-align:bottom;">${cols}</tr></tbody></table>
      <div style="font-size:10px;color:#9ca3af;margin-top:4px;">${e(note)}</div>`;
  }

  // Section header
  function sechdr(title,bg,col){
    return `<div style="background:${bg};border-radius:5px;padding:5px 10px;margin-bottom:10px;">
      <span style="font-size:10px;font-weight:700;color:${col};text-transform:uppercase;letter-spacing:0.07em;">${e(title)}</span>
    </div>`;
  }

  // Card wrapper — NO gap/grid inside, uses margin-based layout
  function card(title,titleCol,bg,border,content,extraStyle=""){
    return `<div style="background:${bg};border:1px solid ${border};border-radius:8px;padding:14px 16px;${extraStyle}">
      ${sechdr(title,bg==="white"||bg==="#fff"?"#f8f9f7":bg,titleCol)}
      ${content}
    </div>`;
  }

  // Two-column layout using table (html2canvas-safe, no gap)
  function twoCol(left,right){
    return `<table style="width:100%;border-collapse:collapse;margin-bottom:14px;"><tbody><tr style="vertical-align:top;">
      <td style="width:49%;padding-right:7px;">${left}</td>
      <td style="width:49%;padding-left:7px;">${right}</td>
    </tr></tbody></table>`;
  }

  // Page wrapper
  function pageWrap(accentCol,subtitle,body){
    return `<div style="background:#fff;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;padding:24px 28px;width:820px;box-sizing:border-box;">
      <div style="background:${accentCol};border-radius:8px;padding:13px 18px;margin-bottom:18px;">
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div>
            <div style="font-size:18px;font-weight:700;color:#fff;">${e(pdata.name)}</div>
            <div style="font-size:11px;color:rgba(255,255,255,0.8);margin-top:2px;">${e(subtitle)}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-size:11px;color:rgba(255,255,255,0.75);">${e(season==="ALL"?"Career — all tournaments":season)}</div>
            <div style="font-size:11px;color:rgba(255,255,255,0.65);">${e(ROLES[pdata.role]?.label||pdata.role)} · ${e(pdata.matches[0]?.batting?.cat||pdata.cat||"—")}</div>
          </div>
        </div>
      </div>
      ${body}
    </div>`;
  }

  // ── Build pages ───────────────────────────────────────────────────────────
  const pages=[];

  // ── PAGE 1: Summary ───────────────────────────────────────────────────────
  {
    const batSum=
      mrow("Total balls",tb)+
      mrow("Total runs",tr)+
      mrow("Avg strike rate",avgSR,avgSR>100?"↑ great":avgSR>70?"↑ improving":"↓ slow",avgSR>100?"#e6f4ec":avgSR>70?"#e6f4ec":"#fcebeb",avgSR>100?G:avgSR>70?G:CR,avgSR>100?G:avgSR>70?G:CR)+
      mrow("Dot ball %",avgDot+"%",avgDot>50?"poor rotation":avgDot>35?"slow rotation":"good rotation",avgDot>50?"#fcebeb":avgDot>35?"#faeeda":"#e6f4ec",avgDot>50?CR:avgDot>35?CA:G,avgDot>50?CR:avgDot>35?CA:G)+
      mrow("Quota met",qm+"/"+bm.length+" matches")+
      mrow("Retired (full quota)",batRet,batRet>0?"✓ full quota":null,"#e6f4ec",G,batRet>0?G:"#9ca3af");

    const miniGrid=[["Catches",ftc,G],["Runouts",fro,CB],["Stumpings",fst,CP],["Missed",fmiss,CR],["Net",(fnet>=0?"+":"")+fnet,fnet>=0?G:CR],["Success%",fpct+"%",fpct>=80?G:fpct>=60?CA:CR]];
    const miniCols=miniGrid.map(([l,v,c])=>`<td style="text-align:center;padding:0 2px;">
      <div style="background:#fff;border:0.5px solid #e0c8f0;border-radius:5px;padding:6px 4px;">
        <div style="font-size:9px;color:#6b7280;margin-bottom:2px;">${l}</div>
        <div style="font-size:16px;font-weight:700;color:${c};">${v}</div>
      </div>
    </td>`).join("");
    const fldSum=`<table style="width:100%;border-collapse:collapse;margin-bottom:10px;"><tbody><tr>${miniCols}</tr></tbody></table>`+
      mrow("Net contribution",(fnet>=0?"+":"")+fnet,fnet>=2?"excellent":fnet>=0?"positive":"negative",fnet>=2?"#e6f4ec":"#fcebeb",fnet>=2?G:CR,fnet>=2?G:CR)+
      mrow("Fielding success%",fpct+"%",fpct>=80?"excellent":fpct>=60?"good":"needs work",fpct>=80?"#e6f4ec":fpct>=60?"#faeeda":"#fcebeb",fpct>=80?G:fpct>=60?CA:CR,fpct>=80?G:fpct>=60?CA:CR)+
      mrow("Sportsmanship pts",fsp,fsp>0?"earned":null,"#faeeda",CA);

    const bowlCols=[["Wickets",btw,btw>5?G:"#1a1a1a"],["Avg economy",avgEcon,parseFloat(avgEcon)<5?G:parseFloat(avgEcon)<8?CA:CR],["Wkt SR",wsr,"#1a1a1a"],["Good len%",gdPct+"%",gdPct>60?G:gdPct>40?CA:CR],["Len loss%",lossPct+"%",lossPct>25?CR:G],["Ctrl rate",avgCR,avgCR>=1.5?G:avgCR>=0.8?CA:CR]]
      .map(([l,v,c])=>`<td style="padding:0 3px;"><div style="background:#fff;border:0.5px solid #f5d9a8;border-radius:5px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#6b7280;margin-bottom:2px;">${l}</div><div style="font-size:15px;font-weight:700;color:${c};">${v}</div></div></td>`).join("");
    const bowlSum=`<table style="width:100%;border-collapse:collapse;"><tbody><tr>${bowlCols}</tr></tbody></table>`;

    let body="";
    if(bm.length||fldM.length) body+=twoCol(
      bm.length?card("Season batting summary",G,"#f8faf9","#c8e6d6",batSum):"",
      fldM.length?card("Fielding season totals",CP,"#fbf8fe","#c9a8e8",fldSum):""
    );
    if(bowlM.length) body+=card("Season bowling summary",CA,"#fffaf5","#f5d9a8",bowlSum);

    pages.push(pageWrap(G,`${pdata.matches.length} matches · ${ROLES[pdata.role]?.label||pdata.role} · ${pdata.matches[0]?.batting?.cat||pdata.cat||"—"}`,body));
  }

  // ── PAGE 2: Batting ───────────────────────────────────────────────────────
  if(bm.length){
    const maxSR=Math.max(1,...batPM.map(p=>p.sr));
    const srItems=batPM.map((p,i)=>({l:careerView?fmtD(bm[i].date).slice(0,6):"M"+(i+1),v:p.sr,c:p.sr>=100?G:p.sr>=50?CA:CR}));

    const srCard=card("Strike rate by match",G,"#f8faf9","#c8e6d6",
      colchart(srItems,maxSR,"Green ≥100 · Amber 50–99 · Red <50"));

    const dotCard=card("Dot ball % per match",CA,"#fffaf5","#f5d9a8",
      batPM.map(p=>hbar(p.label,p.dot,p.dot<35?G:p.dot<=50?CA:CR,p.dot+"%",p.dot<35?"good":p.dot<=50?"slow":"poor")).join("")+
      `<div style="font-size:10px;color:#9ca3af;margin-top:4px;">&lt;35% good · 35–50% slow · &gt;50% poor</div>`);

    const nbCard=card("Non-boundary strike rotation",CB,"#f8f9fc","#c5d8f0",
      batPM.map(p=>hbar(p.label,p.nbSR,p.nbSR>=80?G:p.nbSR>=50?CA:CR,p.nbSR+" nb-SR")).join("")+
      `<div style="font-size:10px;color:#9ca3af;margin-top:4px;">Runs &amp; balls excluding boundaries</div>`);

    const qCard=card("Quota utilisation per match",G,"#f8faf9","#c8e6d6",
      batPM.map(p=>hbar(p.label,p.qPct,p.qPct>=100?G:p.qPct>=60?CA:CR,p.qPct+"%",p.status==="retired"?"retired ✓":p.status==="out"?"out":p.status==="met"?"met":"")).join("")+
      `<div style="font-size:10px;color:#9ca3af;margin-top:4px;">Balls faced ÷ max quota · 100% = full quota</div>`);

    const lgd=[[G,"6s"],[CT,"4s"],[CB,"3s"],["#85B7EB","2s"],["#B5D4F4","1s"]].map(([c,l])=>`<span style="display:inline-flex;align-items:center;margin-right:10px;font-size:10px;color:#6b7280;"><span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${c};margin-right:3px;"></span>${l}</span>`).join("");
    const scCard=card("Scoring breakdown per match",CB,"#f8f9fc","#c5d8f0",
      batPM.map(p=>{const tot=p.s6+p.s4+p.s3+p.s2+p.s1||1;return segbar(p.label,[{v:p.s6,c:G},{v:p.s4,c:CT},{v:p.s3,c:CB},{v:p.s2,c:"#85B7EB"},{v:p.s1,c:"#B5D4F4"}],tot,`${p.runs}r · SR ${p.sr}`);}).join("")+
      `<div style="margin-top:8px;">${lgd}</div>`,"margin-top:14px;");

    const body=twoCol(srCard,dotCard)+twoCol(nbCard,qCard)+scCard;
    pages.push(pageWrap(G,"Batting — match by match",body));
  }

  // ── PAGE 3: Bowling ───────────────────────────────────────────────────────
  if(bowlM.length){
    const maxEcon=Math.max(1,...bowlPM.map(p=>p.econ));
    const econItems=bowlPM.map((p,i)=>({l:careerView?fmtD(bowlM[i].date).slice(0,6):"M"+(i+1),v:p.econ,c:p.econ<=5?G:p.econ<=8?CA:CR}));

    const econCard=card("Economy rate by match",CB,"#f8f9fc","#c5d8f0",
      colchart(econItems,maxEcon,"Green ≤5 · Amber 5–8 · Red >8"));

    const lgd2=[[G,"Good"],[CA,"Overpitch"],[CR,"Full toss"],[CB,"Short"]].map(([c,l])=>`<span style="display:inline-flex;align-items:center;margin-right:10px;font-size:10px;color:#6b7280;"><span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${c};margin-right:3px;"></span>${l}</span>`).join("");
    const lenCard=card("Bowling length control",CA,"#fffaf5","#f5d9a8",
      bowlPM.map(p=>segbar(p.label,[{v:p.gd,c:G},{v:p.op,c:CA},{v:p.ft,c:CR},{v:p.sh,c:CB}],p.tot,Math.round(p.gd/p.tot*100)+"% good length")).join("")+
      `<div style="margin-top:8px;">${lgd2}</div>`);

    const crContent=bowlPM.map(p=>{
      const gdPct2=p.balls>0?Math.round(p.gd/p.balls*100):0;
      return crbar(p.label,gdPct2,p.cr);
    }).join("")+
      `<div style="border-top:0.5px solid rgba(0,0,0,0.08);margin-top:8px;padding-top:8px;">`+
      mrow("Season control rate",avgCR,avgCR>=1.5?"excellent":avgCR>=0.8?"good":"needs work",avgCR>=1.5?"#e6f4ec":avgCR>=0.8?"#faeeda":"#fcebeb",avgCR>=1.5?G:avgCR>=0.8?CA:CR,avgCR>=1.5?G:avgCR>=0.8?CA:CR)+
      (bestCR.cr>0?mrow("Best match",bestCR.label+" — CR "+bestCR.cr.toFixed(2)):"")+
      `<div style="font-size:9px;color:#9ca3af;margin-top:6px;">CR = good length ÷ non-good-length balls. Higher = better. Perfect GL = very high CR.</div></div>`;
    const crCard=card("Control rate — dot balls vs scoring",CB,"#f8f9fc","#c5d8f0",crContent);

    const dotBCard=card("Dot ball % per match",G,"#f8faf9","#c8e6d6",
      bowlPM.map(p=>hbar(p.label,p.dot,p.dot>=60?G:p.dot>=40?CA:CR,p.dot+"%")).join("")+
      `<div style="font-size:10px;color:#9ca3af;margin-top:4px;">Good length balls ÷ total balls · ≥60% = good</div>`);

    const wideCard=card("Wides & no-balls per match",CA,"#fffaf5","#f5d9a8",
      bowlPM.map(p=>`<div style="margin-bottom:7px;">
        <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
          <span style="font-size:11px;color:#1a1a1a;font-weight:500;">${e(p.label)}</span>
          <span style="font-size:11px;"><span style="color:${CA};font-weight:600;">Wd: ${p.wd}</span> &nbsp; <span style="color:${CR};font-weight:600;">Nb: ${p.nb}</span></span>
        </div>
        <div style="display:flex;">
          <div style="flex:1;height:9px;background:${TRACK};border-radius:5px 0 0 5px;overflow:hidden;margin-right:4px;">
            <div style="height:100%;width:${Math.min(100,p.wd*20)}%;background:${CA};border-radius:5px;"></div>
          </div>
          <div style="flex:1;height:9px;background:${TRACK};border-radius:0 5px 5px 0;overflow:hidden;">
            <div style="height:100%;width:${Math.min(100,p.nb*20)}%;background:${CR};border-radius:5px;"></div>
          </div>
        </div>
      </div>`).join("")+`<div style="font-size:10px;color:#9ca3af;margin-top:4px;">Left = wides · Right = no-balls</div>`,"margin-top:14px;");

    const body=twoCol(econCard,lenCard)+twoCol(crCard,dotBCard)+wideCard;
    pages.push(pageWrap(CB,"Bowling — match by match",body));
  }

  // ── PAGE 4: Fielding ──────────────────────────────────────────────────────
  if(fldM.length){
    function fcard(title,items){
      return card(title,CP,"#fbf8fe","#c9a8e8",items.map(([m,pos,neg,pl,nl])=>negbar(m,pos,neg,pl,nl)).join(""));
    }
    const body=twoCol(
      fcard("Catches per match",fldM.map(m=>[lbl(m),m.fielding.catches||0,m.fielding.missedCatch||0,"caught","missed"])),
      fcard("Runouts per match",fldM.map(m=>[lbl(m),m.fielding.runouts||0,m.fielding.missedRunout||0,"effected","missed"]))
    )+twoCol(
      fcard("Stumpings per match",fldM.map(m=>[lbl(m),m.fielding.stumpings||0,m.fielding.missedStumping||0,"effected","missed"])),
      fcard("WK — wides saved vs byes",fldM.map(m=>[lbl(m),m.fielding.widesSaved||0,m.fielding.byesGiven||0,"saved","byes"]))
    )+card("Runs saved vs misfields",CP,"#fbf8fe","#c9a8e8",
      fldM.map(m=>negbar(lbl(m),m.fielding.runsSaved||0,m.fielding.misfields||0,"saved","misfield")).join(""));
    pages.push(pageWrap("#6B21A8","Fielding — match by match",body));
  }

  // ── Render: inject → html2canvas → jsPDF ─────────────────────────────────
  const doc=new jsPDF({unit:"pt",format:"a4"});
  const PW=doc.internal.pageSize.getWidth(),PH=doc.internal.pageSize.getHeight();
  const MAR=18,CW=PW-MAR*2;

  const container=document.createElement("div");
  container.style.cssText="position:absolute;left:-9999px;top:0;width:820px;";
  document.body.appendChild(container);

  try{
    // Capture each page
    for(let pi=0;pi<pages.length;pi++){
      container.innerHTML=pages[pi];
      await new Promise(r=>setTimeout(r,60));
      const canvas=await Promise.race([
        html2canvas(container.firstChild,{scale:2,backgroundColor:"#ffffff",logging:false,useCORS:false,allowTaint:true,imageTimeout:0}),
        new Promise((_,rej)=>setTimeout(()=>rej(new Error("timeout")),10000)),
      ]);
      const imgData=canvas.toDataURL("image/png");
      const scaledH=(canvas.height/canvas.width)*CW;
      if(pi>0)doc.addPage();
      if(scaledH<=PH-MAR*2){
        doc.addImage(imgData,"PNG",MAR,MAR,CW,scaledH);
      } else {
        const scale=CW/canvas.width;
        const slicePx=Math.floor((PH-MAR*2)/scale);
        let off=0;
        while(off<canvas.height){
          if(off>0)doc.addPage();
          const sh=Math.min(canvas.height-off,slicePx);
          const sc=document.createElement("canvas");
          sc.width=canvas.width;sc.height=sh;
          sc.getContext("2d").drawImage(canvas,0,-off);
          doc.addImage(sc.toDataURL("image/png"),"PNG",MAR,MAR,CW,sh*scale);
          off+=sh;
        }
      }
    }

    // Tournament comparison (career) — live Chart.js canvas capture
    if(careerView){
      const tourIds=[`tc-bat-${pdata.id}`,`tc-bowl-${pdata.id}`,`tc-fld-${pdata.id}`];
      const tourTitles=["Batting — avg SR & dot ball% by tournament","Bowling — economy & wickets/match","Fielding — success rate by tournament"];
      await new Promise(r=>setTimeout(r,300));
      let firstTour=true,ty=MAR+30;
      for(let ci=0;ci<tourIds.length;ci++){
        const el=document.getElementById(tourIds[ci]);
        if(!el)continue;
        try{
          const c=await Promise.race([
            html2canvas(el,{scale:2,backgroundColor:"#ffffff",logging:false}),
            new Promise((_,rej)=>setTimeout(()=>rej(new Error("t/o")),6000)),
          ]);
          if(firstTour){
            doc.addPage();
            doc.setFillColor(24,95,165);doc.rect(0,0,PW,42,"F");
            doc.setFont("Helvetica","bold");doc.setFontSize(13);doc.setTextColor(255,255,255);
            doc.text("Tournament Comparison",MAR,27);
            doc.setFont("Helvetica","normal");doc.setFontSize(9);doc.setTextColor(200,220,255);
            doc.text(pdata.name+" · "+season,PW-MAR,27,"right");
            firstTour=false;ty=54;
          }
          const ih=Math.min(185,(c.height/c.width)*CW);
          if(ty+ih+28>PH-20){doc.addPage();ty=MAR;}
          doc.setFont("Helvetica","bold");doc.setFontSize(9);doc.setTextColor(30,30,30);
          doc.text(tourTitles[ci],MAR,ty);ty+=12;
          doc.addImage(c.toDataURL("image/png"),"PNG",MAR,ty,CW,ih);
          ty+=ih+18;
        }catch(e2){console.warn("Tour chart skip",e2);}
      }
    }
  }finally{
    if(document.body.contains(container))document.body.removeChild(container);
  }

  // Footer
  const np=doc.internal.getNumberOfPages();
  for(let i=1;i<=np;i++){
    doc.setPage(i);
    doc.setFillColor(248,249,247);doc.rect(0,PH-20,PW,20,"F");
    doc.setDrawColor(210,210,210);doc.setLineWidth(0.3);doc.line(0,PH-20,PW,PH-20);
    doc.setFont("Helvetica","normal");doc.setFontSize(7);doc.setTextColor(150,150,150);
    doc.text("CrickitMatch by ArcGain LLC · Confidential player analytics",MAR,PH-7);
    doc.text("Page "+i+" of "+np,PW-MAR,PH-7,"right");
  }

  const sn=pdata.name.replace(/[^a-zA-Z0-9]/g,"_");
  const ss=(season==="ALL"?"Career":season).replace(/[^a-zA-Z0-9]/g,"_");
  doc.save(`PlayerReport_${sn}_${ss}_${new Date().toISOString().split("T")[0]}.pdf`);

  setExporting(false);
}

async function exportSeasonPDF(stats,selectedPlayer,season,matches,statsEntries,setExportingSeason){
  if(setExportingSeason)setExportingSeason(true);
  try{
  const G="#1A7A4A",CA="#EF9F27",CR="#E24B4A",CB="#185FA5",CP="#6B21A8";
  const TRACK="#f1efe8";
  const e=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");

  const entries=statsEntries||Object.entries(stats).filter(([id])=>selectedPlayer==="ALL"||id===selectedPlayer);
  const allPlayers=Object.values(stats);
  const seasonMatches=season==="ALL"?matches:matches.filter(m=>m.tournament===season);
  const totalRuns=allPlayers.flatMap(p=>p.matches.map(m=>m.batting?.runs||0)).reduce((a,b)=>a+b,0);
  const totalWkts=allPlayers.flatMap(p=>p.matches.map(m=>m.bowling?.wickets||0)).reduce((a,b)=>a+b,0);
  const totalBalls=allPlayers.flatMap(p=>p.matches.map(m=>m.batting?.balls||0)).reduce((a,b)=>a+b,0);
  const teamSR=totalBalls>0?Math.round(totalRuns/totalBalls*100):0;

  // Top performers
  const batPlayers=allPlayers.filter(p=>p.matches.some(m=>m.batting));
  const bowlPlayers=allPlayers.filter(p=>p.matches.some(m=>m.bowling&&m.bowling.overs>0));
  const topRunsV=batPlayers.length>0?Math.max(...batPlayers.map(p=>p.matches.reduce((a,m)=>a+(m.batting?.runs||0),0))):0;
  const topRunsNames=batPlayers.filter(p=>p.matches.reduce((a,m)=>a+(m.batting?.runs||0),0)===topRunsV).map(p=>p.name);
  const topRuns={name:topRunsNames.join(" & ")||"—",v:topRunsV};

  const srPlayers=batPlayers.filter(p=>p.matches.reduce((a,m)=>a+(m.batting?.balls||0),0)>=10);
  const topSRV=srPlayers.length>0?Math.max(...srPlayers.map(p=>{const tb=p.matches.reduce((a,m)=>a+(m.batting?.balls||0),0),tr=p.matches.reduce((a,m)=>a+(m.batting?.runs||0),0);return tb>0?Math.round(tr/tb*100):0;})):0;
  const topSRNames=srPlayers.filter(p=>{const tb=p.matches.reduce((a,m)=>a+(m.batting?.balls||0),0),tr=p.matches.reduce((a,m)=>a+(m.batting?.runs||0),0);return tb>0&&Math.round(tr/tb*100)===topSRV;}).map(p=>p.name);
  const topSR={name:topSRNames.join(" & ")||"—",v:topSRV};

  const topWktsV=bowlPlayers.length>0?Math.max(...bowlPlayers.map(p=>p.matches.reduce((a,m)=>a+(m.bowling?.wickets||0),0))):0;
  const topWktsNames=bowlPlayers.filter(p=>p.matches.reduce((a,m)=>a+(m.bowling?.wickets||0),0)===topWktsV).map(p=>p.name);
  const topWkts={name:topWktsNames.join(" & ")||"—",v:topWktsV};

  // ── HTML helpers ──────────────────────────────────────────────────────────
  function thStyle(extra=""){return `style="padding:7px 10px;font-size:11px;font-weight:700;color:#1a1a1a;background:#f0f4f2;text-align:left;white-space:nowrap;border-bottom:1.5px solid #c8e6d6;${extra}"`;}
  function tdStyle(color="#1a1a1a",bold=false,extra=""){return `style="padding:6px 10px;font-size:12px;border-bottom:0.5px solid rgba(0,0,0,0.06);color:${color};${bold?"font-weight:700;":""}${extra}"`;}
  function badge(txt,bg,col){return `<span style="background:${bg};color:${col};border-radius:5px;padding:2px 8px;font-size:11px;font-weight:600;">${e(txt)}</span>`;}

  function srMiniBar(bm){
    const maxSR=Math.max(1,...bm.map(p=>{const b=p.batting?.balls||0,r=p.batting?.runs||0;return b>0?Math.round(r/b*100):0;}));
    const bars=bm.map((m,i)=>{
      const sr=m.batting?.balls>0?Math.round((m.batting.runs||0)/m.batting.balls*100):0;
      const clr=sr>=100?G:sr>=50?CA:CR;
      const h=maxSR>0?Math.max(4,Math.round(sr/maxSR*28)):4;
      return `<div style="display:flex;flex-direction:column;align-items:center;flex:1;gap:1px;">
        <div style="font-size:9px;font-weight:700;color:${clr};">${sr}</div>
        <div style="width:100%;height:${h}px;background:${clr};border-radius:2px 2px 0 0;"></div>
        <div style="font-size:9px;color:#9ca3af;">M${i+1}</div>
      </div>`;
    }).join("");
    return `<div style="display:flex;align-items:flex-end;height:48px;margin-top:4px;">${bars}</div>`;
  }

  function pageWrap(accentCol,title,sub,body){
    return `<div style="background:#fff;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;padding:24px 28px;width:820px;box-sizing:border-box;">
      <div style="background:${accentCol};border-radius:8px;padding:12px 18px;display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;">
        <div>
          <div style="font-size:17px;font-weight:700;color:#fff;">${e(title)}</div>
          <div style="font-size:11px;color:rgba(255,255,255,0.8);margin-top:2px;">${e(sub)}</div>
        </div>
        <div style="text-align:right;">
          <div style="font-size:11px;color:rgba(255,255,255,0.7);">CrickitMatch · ArcGain LLC</div>
          <div style="font-size:11px;color:rgba(255,255,255,0.6);">Generated ${new Date().toLocaleDateString()}</div>
        </div>
      </div>
      ${body}
    </div>`;
  }

  function sectionHdr(title,bg,col){
    return `<div style="background:${bg};border-radius:6px;padding:6px 12px;margin-bottom:10px;margin-top:4px;">
      <span style="font-size:11px;font-weight:700;color:${col};text-transform:uppercase;letter-spacing:0.07em;">${e(title)}</span>
    </div>`;
  }

  const pages=[];

  // ── PAGE 1: Cover + Team Summary ──────────────────────────────────────────
  const metricCard=(label,val,col="#1a1a1a")=>`
    <div style="background:#f8faf9;border:0.5px solid #c8e6d6;border-radius:8px;padding:14px 16px;text-align:center;">
      <div style="font-size:11px;color:#6b7280;margin-bottom:4px;">${e(label)}</div>
      <div style="font-size:28px;font-weight:700;color:${col};">${e(String(val))}</div>
    </div>`;

  // Best GD% bowler (min 2 overs)
  const gdPlayers=bowlPlayers.filter(p=>p.matches.reduce((a,m)=>a+(m.bowling?.overs||0),0)>=2);
  const topGDV=gdPlayers.length>0?Math.max(...gdPlayers.map(p=>{const tb=p.matches.reduce((a,m)=>a+(m.bowling?.overs||0)*6+(m.bowling?.wides||0)+(m.bowling?.noBalls||0),0),tg=p.matches.reduce((a,m)=>a+(m.bowling?.good||0),0);return tb>0?Math.round(tg/tb*100):0;})):0;
  const topGDNames=gdPlayers.filter(p=>{const tb=p.matches.reduce((a,m)=>a+(m.bowling?.overs||0)*6+(m.bowling?.wides||0)+(m.bowling?.noBalls||0),0),tg=p.matches.reduce((a,m)=>a+(m.bowling?.good||0),0);return tb>0&&Math.round(tg/tb*100)===topGDV;}).map(p=>p.name);
  const topGD={name:topGDNames.join(" & ")||"—",v:gdPlayers.length>0?topGDV+"%":"—"};

  // Best field net
  const fldPlayers2=allPlayers.filter(p=>p.matches.some(m=>m.fielding));
  const fldNet=p=>{const fm=p.matches.filter(m=>m.fielding);const s=k=>fm.reduce((a,m)=>a+(m.fielding?.[k]||0),0);return(s("catches")+s("runouts")+s("stumpings"))-(s("missedCatch")+s("missedRunout")+s("missedStumping"));};
  const topNetV=fldPlayers2.length>0?Math.max(...fldPlayers2.map(fldNet)):0;
  const topNetNames=fldPlayers2.filter(p=>fldNet(p)===topNetV).map(p=>p.name);
  const topNet={name:topNetNames.join(" & ")||"—",v:fldPlayers2.length>0?(topNetV>=0?"+":"")+topNetV:"—"};

  // Most catches
  const topCatchV=fldPlayers2.length>0?Math.max(...fldPlayers2.map(p=>p.matches.reduce((a,m)=>a+(m.fielding?.catches||0),0))):0;
  const topCatchNames=fldPlayers2.filter(p=>p.matches.reduce((a,m)=>a+(m.fielding?.catches||0),0)===topCatchV).map(p=>p.name);
  const topCatch={name:topCatchNames.join(" & ")||"—",v:topCatchV};

  // Count only matches that have actual data recorded
  const playedMatchIds=new Set(entries.flatMap(([,p])=>p.matches.filter(m=>m.batting||m.bowling||m.fielding).map(m=>m.matchId)));
  const playedCount=playedMatchIds.size||seasonMatches.length;

  const topCard=(label,name,val,col,bg,border)=>`
    <div style="background:${bg};border:1px solid ${border};border-radius:8px;padding:12px 14px;flex:1;min-width:140px;">
      <div style="font-size:10px;font-weight:700;color:${col};text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;opacity:0.75;">${e(label)}</div>
      <div style="font-size:13px;font-weight:700;color:#1a1a1a;line-height:1.3;margin-bottom:4px;">${e(name)}</div>
      <div style="font-size:20px;font-weight:700;color:${col};">${e(String(val))}</div>
    </div>`;

  const rowLabel=(txt)=>`<div style="font-size:10px;font-weight:700;color:#9ca3af;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;margin-top:10px;">${txt}</div>`;

  const coverBody=`
    <div style="display:flex;margin-bottom:16px;">
      ${metricCard("Matches played",playedCount)}
      <div style="width:12px;"></div>
      ${metricCard("Team runs",totalRuns,G)}
      <div style="width:12px;"></div>
      ${metricCard("Team SR",teamSR,teamSR>100?G:teamSR>70?CA:CR)}
      <div style="width:12px;"></div>
      ${metricCard("Total wickets",totalWkts,G)}
    </div>
    ${sectionHdr("Top performers","#f0faf4",G)}
    ${rowLabel("Batting")}
    <div style="display:flex;gap:12px;margin-bottom:6px;">
      ${topCard("Most runs",topRuns.name,topRuns.v,G,"#f0faf4","#c8e6d6")}
      ${topCard("Best avg SR",topSR.name,topSR.v,topSR.v>=100?G:CA,"#f0faf4","#c8e6d6")}
    </div>
    ${rowLabel("Bowling")}
    <div style="display:flex;gap:12px;margin-bottom:6px;">
      ${topCard("Most wickets",topWkts.name,topWkts.v,CB,"#eef4fb","#b5d4f4")}
      ${topCard("Best Good Length GD%",topGD.name,topGD.v,CB,"#eef4fb","#b5d4f4")}
    </div>
    ${rowLabel("Fielding")}
    <div style="display:flex;gap:12px;margin-bottom:8px;">
      ${topCard("Best fielder net",topNet.name,topNet.v,CP,"#fbf8fe","#c9a8e8")}
      ${topCard("Most catches",topCatch.name,topCatch.v,CP,"#fbf8fe","#c9a8e8")}
    </div>`;
  pages.push(pageWrap(G,`Season Report — ${season}`,`${playedCount} matches played · ${entries.length} players`,coverBody));

  // ── PAGE 2: Batting aggregate table ──────────────────────────────────────
  const batRows=entries.filter(([,p])=>p.matches.some(m=>m.batting)).sort((a,b)=>{
    const ra=a[1].matches.reduce((s,m)=>s+(m.batting?.runs||0),0);
    const rb=b[1].matches.reduce((s,m)=>s+(m.batting?.runs||0),0);
    return rb-ra;
  }).map(([,p])=>{
    const bm=p.matches.filter(m=>m.batting).sort((a,b)=>a.date<b.date?-1:1);
    const tb=bm.reduce((a,m)=>a+(m.batting?.balls||0),0),tr=bm.reduce((a,m)=>a+(m.batting?.runs||0),0),td=bm.reduce((a,m)=>a+(m.batting?.dots||0),0);
    const asr=tb>0?Math.round(tr/tb*100):0,dp=tb>0?Math.round(td/tb*100):0;
    const qm=bm.filter(m=>["met","retired"].includes(m.batting?.status)).length;
    const out=bm.filter(m=>m.batting?.status==="out").length,ret=bm.filter(m=>m.batting?.status==="retired").length;
    const srClr=asr>=100?G:asr>=50?CA:CR;
    const dpClr=dp>50?CR:dp<35?G:CA;
    const perMatch=bm.map(m=>{
      const sr=m.batting?.balls>0?Math.round((m.batting.runs||0)/m.batting.balls*100):0;
      const dp2=m.batting?.balls>0?Math.round((m.batting.dots||0)/m.batting.balls*100):0;
      const rot=dp2<35?"good":dp2<=50?"slow":"poor";
      const rotC=dp2<35?G:dp2<=50?CA:CR;
      const srC=sr>=100?G:sr>=50?CA:CR;
      const st=m.batting?.status||"";
      return `<tr style="background:#fafcfb;">
        <td style="padding:4px 10px 4px 28px;font-size:11px;color:#6b7280;font-style:italic;">↳ vs ${e(m.opponent||"?")}</td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;"></td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;"></td>
        <td style="padding:4px 10px;font-size:11px;color:#374151;">${m.batting?.balls||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:#374151;">${m.batting?.runs||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:${srC};font-weight:600;">${sr}</td>
        <td style="padding:4px 10px;font-size:11px;color:${rotC};font-weight:600;">${dp2}%</td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;">—</td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;">—</td>
        <td style="padding:4px 10px;font-size:11px;color:${st==="retired"?G:st==="out"?CR:"#6b7280"};">${st}</td>
      </tr>`;
    }).join("");
    return `<tr>
      <td ${tdStyle("#1a1a1a",true)}>${e(p.name)}</td>
      <td ${tdStyle("#6b7280")}>${e(ROLES[p.role]?.label||p.role)}</td>
      <td ${tdStyle()}>${bm.length}</td>
      <td ${tdStyle()}>${tb}</td>
      <td ${tdStyle(tr>50?G:"#1a1a1a",tr>50)}>${tr}</td>
      <td ${tdStyle(srClr,true)}>${asr}</td>
      <td ${tdStyle(dpClr,true)}>${dp}%</td>
      <td ${tdStyle()}>${qm}/${bm.length}</td>
      <td ${tdStyle(out>2?CR:"#1a1a1a")}>${out}</td>
      <td ${tdStyle(ret>0?G:"#9ca3af",ret>0)}>${ret}</td>
    </tr>${perMatch}`;
  }).join("");

  const batPage=`
    ${sectionHdr("Batting — season aggregates","#f0faf4",G)}
    <table style="width:100%;border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;">
      <thead><tr>
        <th ${thStyle("min-width:140px;")}>Player</th>
        <th ${thStyle()}>Role</th>
        <th ${thStyle()}>M</th>
        <th ${thStyle()}>Balls</th>
        <th ${thStyle()}>Runs</th>
        <th ${thStyle()}>Avg SR</th>
        <th ${thStyle()}>Dot%</th>
        <th ${thStyle()}>Quota</th>
        <th ${thStyle()}>Out</th>
        <th ${thStyle()}>Retired</th>
      </tr></thead>
      <tbody>${batRows}</tbody>
    </table>`;
  pages.push(pageWrap(G,"Batting — season aggregates",`${season} · ${entries.filter(([,p])=>p.matches.some(m=>m.batting)).length} batters`,batPage));

  // ── PAGE 3: Batting ball quality table ───────────────────────────────────
  // Helper to extract pip value/quality/dotType
  const pV=b=>typeof b==="object"?b.v:b;
  const pQ=b=>typeof b==="object"?b.q:null;
  const pDt=b=>typeof b==="object"?b.dt:null;

  const batQualEntries=entries.filter(([,p])=>p.matches.some(m=>m.batting));
  const hasAnyQuality=batQualEntries.some(([,p])=>{
    const log=p.matches.flatMap(m=>m.batting?.ballLog||[]);
    return log.filter(b=>pQ(b)).length>=3;
  });

  if(hasAnyQuality){
    const qualRows=batQualEntries.sort((a,b)=>{
      const ra=a[1].matches.reduce((s,m)=>s+(m.batting?.runs||0),0);
      const rb=b[1].matches.reduce((s,m)=>s+(m.batting?.runs||0),0);
      return rb-ra;
    }).map(([,p])=>{
      const bm=p.matches.filter(m=>m.batting).sort((a,b)=>a.date<b.date?-1:1);
      const allLog=bm.flatMap(m=>m.batting?.ballLog||[]);
      const totalBalls=bm.reduce((a,m)=>a+(m.batting?.balls||0),0);
      const tagged=allLog.filter(b=>pQ(b)).length;
      const dataPct=totalBalls>0?Math.round(tagged/totalBalls*100):0;

      if(tagged<3){
        // Insufficient data — show dash row
        return `<tr>
          <td ${tdStyle("#1a1a1a",true)}>${e(p.name)}</td>
          ${["—","—","—","—","—","—"].map(()=>`<td ${tdStyle("#9ca3af")}>—</td>`).join("")}
          <td ${tdStyle("#9ca3af")}>${dataPct}%</td>
        </tr>`;
      }

      // SR vs each quality
      const srFor=q=>{
        const balls=allLog.filter(b=>pQ(b)===q);
        if(!balls.length) return null;
        const runs=balls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
        return Math.round(runs/balls.length*100);
      };
      const ftSR=srFor("FT"),shSR=srFor("SH"),gdSR=srFor("GD");

      // QC score = runs off GD / GD balls
      const gdBalls=allLog.filter(b=>pQ(b)==="GD");
      const gdRuns=gdBalls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
      const qcScore=gdBalls.length>0?parseFloat((gdRuns/gdBalls.length).toFixed(2)):null;
      const qcClr=qcScore===null?"#9ca3af":qcScore>=1.0?G:qcScore>=0.5?CA:CR;

      // Dot type breakdown
      const dotBalls=allLog.filter(b=>pV(b)==="."&&pQ(b));
      const beaten=dotBalls.filter(b=>pDt(b)==="beat").length;
      const fielded=dotBalls.filter(b=>pDt(b)==="fielded").length;
      const beatenPct=dotBalls.length>0?Math.round(beaten/dotBalls.length*100):null;
      const fieldedPct=dotBalls.length>0?Math.round(fielded/dotBalls.length*100):null;
      const beatenClr=beatenPct===null?"#9ca3af":beatenPct>=30?CR:beatenPct>=15?CA:G;
      const fieldedClr=fieldedPct===null?"#9ca3af":fieldedPct>=20?G:CA;
      const dataPctClr=dataPct>=60?G:dataPct>=30?CA:CR;

      const srCell=(sr,q)=>sr===null
        ?`<td ${tdStyle("#9ca3af")}>—</td>`
        :`<td ${tdStyle(sr>=100?G:sr>=50?CA:CR,true)}>${sr}</td>`;

      return `<tr>
        <td ${tdStyle("#1a1a1a",true)}>${e(p.name)}</td>
        <td ${tdStyle(qcClr,true)}>${qcScore!==null?qcScore.toFixed(2):"—"}</td>
        ${srCell(ftSR,"FT")}
        ${srCell(shSR,"SH")}
        ${srCell(gdSR,"GD")}
        <td ${tdStyle(beatenClr,beatenPct!==null)}>${beatenPct!==null?beatenPct+"%":"—"}</td>
        <td ${tdStyle(fieldedClr,fieldedPct!==null)}>${fieldedPct!==null?fieldedPct+"%":"—"}</td>
        <td ${tdStyle(dataPctClr)}>${dataPct}%</td>
      </tr>`;
    }).join("");

    const qualPage=`
      ${sectionHdr("Batting — ball quality analysis","#f5eeff","#6B21A8")}
      <table style="width:100%;border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;">
        <thead><tr>
          <th ${thStyle("min-width:140px;")}>Player</th>
          <th ${thStyle()}>QC score</th>
          <th ${thStyle()}>SR vs FT</th>
          <th ${thStyle()}>SR vs SH</th>
          <th ${thStyle()}>SR vs GD</th>
          <th ${thStyle()}>Beaten%</th>
          <th ${thStyle()}>Fielded%</th>
          <th ${thStyle()}>Data%</th>
        </tr></thead>
        <tbody>${qualRows}</tbody>
      </table>
      <div style="margin-top:12px;padding:8px 12px;background:#f5f5f5;border-radius:6px;font-size:10px;color:#6b7280;">
        QC ≥1.0 = scoring freely vs quality bowling · 0.5–1.0 = managing · &lt;0.5 = troubled by good bowling · — = fewer than 3 tagged balls · Data% = % of balls with quality tagged
      </div>`;
    pages.push(pageWrap("#6B21A8","Batting — ball quality analysis",`${season} · how batters perform against quality vs poor bowling`,qualPage));
  }

  // ── PAGE 4: Bowling aggregate table ──────────────────────────────────────
  const bowlRows=entries.filter(([,p])=>p.matches.some(m=>m.bowling&&m.bowling.overs>0)).sort((a,b)=>{
    const wa=a[1].matches.reduce((s,m)=>s+(m.bowling?.wickets||0),0);
    const wb=b[1].matches.reduce((s,m)=>s+(m.bowling?.wickets||0),0);
    const ra=a[1].matches.reduce((s,m)=>s+(m.bowling?.runs||0),0);
    const rb=b[1].matches.reduce((s,m)=>s+(m.bowling?.runs||0),0);
    return wb-wa||ra-rb;
  }).map(([,p])=>{
    const bm=p.matches.filter(m=>m.bowling&&m.bowling.overs>0).sort((a,b)=>a.date<b.date?-1:1);
    const to=bm.reduce((a,m)=>a+(m.bowling?.overs||0),0),tr=bm.reduce((a,m)=>a+(m.bowling?.runs||0),0),tw=bm.reduce((a,m)=>a+(m.bowling?.wickets||0),0);
    const twd=bm.reduce((a,m)=>a+(m.bowling?.wides||0),0),tnb=bm.reduce((a,m)=>a+(m.bowling?.noBalls||0),0);
    const tgd=bm.reduce((a,m)=>a+(m.bowling?.good||0),0),tft=bm.reduce((a,m)=>a+(m.bowling?.fullToss||0),0),tsh=bm.reduce((a,m)=>a+(m.bowling?.short||0),0);
    const twd2=bm.reduce((a,m)=>a+(m.bowling?.wides||0),0),tnb2=bm.reduce((a,m)=>a+(m.bowling?.noBalls||0),0);
    const tbl=to*6+twd2+tnb2,ae=to>0?(tr/to).toFixed(1):"-",wsr=tw>0?Math.round(to*6/tw):"-";
    const gdp=tbl>0?Math.round(tgd/tbl*100):0,lossp=tbl>0?Math.round((tft+tsh)/tbl*100):0;
    const aeClr=parseFloat(ae)>8?CR:parseFloat(ae)<5?G:CA;
    const perMatch=bm.map(m=>{
      const mec=m.bowling?.overs>0?((m.bowling.runs||0)/m.bowling.overs).toFixed(1):"-";
      const mecC=parseFloat(mec)>8?CR:parseFloat(mec)<5?G:CA;
      const mbl=m.bowling?.overs>0?(m.bowling.overs*6+(m.bowling.wides||0)+(m.bowling.noBalls||0)):0;
      const mgd=m.bowling?.good||0;
      const mgdp=mbl>0?Math.round(mgd/mbl*100):0;
      const mft=(m.bowling?.fullToss||0),msh=(m.bowling?.short||0);
      const mlossp=mbl>0?Math.round((mft+msh)/mbl*100):0;
      return `<tr style="background:#f8f9fc;">
        <td style="padding:4px 10px 4px 28px;font-size:11px;color:#6b7280;font-style:italic;">↳ vs ${e(m.opponent||"?")}</td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;"></td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;"></td>
        <td style="padding:4px 10px;font-size:11px;color:#374151;">${m.bowling?.overs||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:#374151;">${m.bowling?.runs||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:${G};font-weight:600;">${m.bowling?.wickets||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:${mecC};font-weight:600;">${mec}</td>
        <td style="padding:4px 10px;font-size:11px;color:#9ca3af;">—</td>
        <td style="padding:4px 10px;font-size:11px;color:${mgdp>60?G:mgdp<40?CR:CA};">${mgdp}%</td>
        <td style="padding:4px 10px;font-size:11px;color:${mlossp>25?CR:G};">${mlossp}%</td>
        <td style="padding:4px 10px;font-size:11px;color:${(m.bowling?.wides||0)>2?CR:"#374151"};">${m.bowling?.wides||0}</td>
        <td style="padding:4px 10px;font-size:11px;color:${(m.bowling?.noBalls||0)>1?CR:"#374151"};">${m.bowling?.noBalls||0}</td>
      </tr>`;
    }).join("");
    return `<tr>
      <td ${tdStyle("#1a1a1a",true)}>${e(p.name)}</td>
      <td ${tdStyle("#6b7280")}>${e(ROLES[p.role]?.label||p.role)}</td>
      <td ${tdStyle()}>${bm.length}</td>
      <td ${tdStyle()}>${to}</td>
      <td ${tdStyle()}>${tr}</td>
      <td ${tdStyle(tw>5?G:"#1a1a1a",tw>5)}>${tw}</td>
      <td ${tdStyle(aeClr,true)}>${ae}</td>
      <td ${tdStyle()}>${wsr}</td>
      <td ${tdStyle(gdp>60?G:gdp<40?CR:CA,true)}>${gdp}%</td>
      <td ${tdStyle(lossp>25?CR:G,true)}>${lossp}%</td>
      <td ${tdStyle(twd>5?CR:"#1a1a1a")}>${twd}</td>
      <td ${tdStyle(tnb>3?CR:"#1a1a1a")}>${tnb}</td>
    </tr>${perMatch}`;
  }).join("");

  const bowlPage=`
    ${sectionHdr("Bowling — season aggregates","#f0f4fc",CB)}
    <table style="width:100%;border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;">
      <thead><tr>
        <th ${thStyle("min-width:140px;background:#eef2fb;")}>Player</th>
        <th ${thStyle("background:#eef2fb;")}>Role</th>
        <th ${thStyle("background:#eef2fb;")}>M</th>
        <th ${thStyle("background:#eef2fb;")}>Overs</th>
        <th ${thStyle("background:#eef2fb;")}>Runs</th>
        <th ${thStyle("background:#eef2fb;")}>Wkts</th>
        <th ${thStyle("background:#eef2fb;")}>Avg ER</th>
        <th ${thStyle("background:#eef2fb;")}>Wkt SR</th>
        <th ${thStyle("background:#eef2fb;")}>GD%</th>
        <th ${thStyle("background:#eef2fb;")}>Loss%</th>
        <th ${thStyle("background:#eef2fb;")}>Wd</th>
        <th ${thStyle("background:#eef2fb;")}>Nb</th>
      </tr></thead>
      <tbody>${bowlRows}</tbody>
    </table>`;
  pages.push(pageWrap(CB,"Bowling — season aggregates",`${season} · ${entries.filter(([,p])=>p.matches.some(m=>m.bowling&&m.bowling.overs>0)).length} bowlers`,bowlPage));

  // ── PAGE 4: Fielding table ────────────────────────────────────────────────
  const fldRows=[...entries].map(([,p])=>{
    const fm=p.matches.filter(m=>m.fielding);
    if(!fm.length)return null;
    const s=k=>fm.reduce((a,m)=>a+(m.fielding?.[k]||0),0);
    const tc=s("catches"),mc=s("missedCatch"),ro=s("runouts"),mro=s("missedRunout"),st=s("stumpings"),mst=s("missedStumping"),sp=s("sports");
    const tot=tc+ro+st,miss=mc+mro+mst,net=tot-miss,pct=tot+miss>0?Math.round(tot/(tot+miss)*100):0;
    return{name:p.name,tc,mc,ro,mro,st,mst,sp,net,pct};
  }).filter(Boolean).sort((a,b)=>b.net-a.net||b.tc-a.tc).map(r=>{
    const pctBadge=badge(r.pct+"%",r.pct>=80?"#e6f4ec":r.pct>=60?"#faeeda":"#fcebeb",r.pct>=80?G:r.pct>=60?CA:CR);
    return `<tr>
      <td ${tdStyle("#1a1a1a",true)}>${e(r.name)}</td>
      <td ${tdStyle(G,true)}>${r.tc}</td>
      <td ${tdStyle(CR)}>${r.mc}</td>
      <td ${tdStyle(CB,true)}>${r.ro}</td>
      <td ${tdStyle(CR)}>${r.mro}</td>
      <td ${tdStyle(CP)}>${r.st}</td>
      <td ${tdStyle(CR)}>${r.mst}</td>
      <td ${tdStyle(CA)}>${r.sp}</td>
      <td ${tdStyle(r.net>=0?G:CR,true)}>${(r.net>=0?"+":"")+r.net}</td>
      <td style="padding:6px 10px;border-bottom:0.5px solid rgba(0,0,0,0.06);">${pctBadge}</td>
    </tr>`;
  }).join("");

  const fldPage=`
    ${sectionHdr("Fielding — season totals","#faf5ff",CP)}
    <table style="width:100%;border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;">
      <thead><tr>
        <th ${thStyle("min-width:160px;background:#f5eeff;")}>Player</th>
        <th ${thStyle("background:#f5eeff;color:"+G+";")}>C</th>
        <th ${thStyle("background:#f5eeff;color:"+CR+";")}>MC</th>
        <th ${thStyle("background:#f5eeff;color:"+CB+";")}>RO</th>
        <th ${thStyle("background:#f5eeff;color:"+CR+";")}>MRO</th>
        <th ${thStyle("background:#f5eeff;color:"+CP+";")}>ST</th>
        <th ${thStyle("background:#f5eeff;color:"+CR+";")}>MST</th>
        <th ${thStyle("background:#f5eeff;color:"+CA+";")}>SP</th>
        <th ${thStyle("background:#f5eeff;")}>Net</th>
        <th ${thStyle("background:#f5eeff;")}>Success%</th>
      </tr></thead>
      <tbody>${fldRows}</tbody>
    </table>`;
  pages.push(pageWrap(CP,"Fielding — season totals",`${season} · ${entries.filter(([,p])=>p.matches.some(m=>m.fielding)).length} players`,fldPage));

  // ── Render all pages via html2canvas ──────────────────────────────────────
  const doc=new jsPDF({unit:"pt",format:"a4"});
  const PW=doc.internal.pageSize.getWidth(),PH=doc.internal.pageSize.getHeight();
  const MAR=18,FOOTER=22,CW=PW-MAR*2,USABLE=PH-MAR*2-FOOTER;

  const container=document.createElement("div");
  container.style.cssText="position:absolute;left:-9999px;top:0;width:820px;";
  document.body.appendChild(container);

  async function renderHtml(html){
    container.innerHTML=html;
    await new Promise(r=>setTimeout(r,40));
    return Promise.race([
      html2canvas(container.firstChild||container,{scale:2,backgroundColor:"#ffffff",logging:false,useCORS:false,allowTaint:true,imageTimeout:0}),
      new Promise((_,rej)=>setTimeout(()=>rej(new Error("timeout")),15000)),
    ]);
  }

  function placeCanvas(canvas,y){
    const scaledH=(canvas.height/canvas.width)*CW;
    doc.addImage(canvas.toDataURL("image/png"),"PNG",MAR,y,CW,scaledH);
    return scaledH;
  }

  try{
    // ── Page 1: Cover ────────────────────────────────────────────────────────
    {
      const canvas=await renderHtml(pages[0]);
      placeCanvas(canvas,MAR);
    }

    // ── Pages 2-4: Batting / Bowling / Fielding ──────────────────────────────
    for(let pi=1;pi<pages.length;pi++){
      const pageHtml=pages[pi];
      const tbodyStart=pageHtml.indexOf("<tbody>");
      const tbodyEnd=pageHtml.lastIndexOf("</tbody>")+8;
      const theadStart=pageHtml.indexOf("<thead>");
      const theadEnd=pageHtml.indexOf("</thead>")+8;

      // ── No tbody = Fielding — render as whole section across pages ──────────
      if(tbodyStart===-1){
        const canvas=await renderHtml(pageHtml);
        const scaledH=(canvas.height/canvas.width)*CW;
        doc.addPage();
        if(scaledH<=USABLE){
          doc.addImage(canvas.toDataURL("image/png"),"PNG",MAR,MAR,CW,scaledH);
        } else {
          const scale=CW/canvas.width;
          const slicePx=Math.floor(USABLE/scale);
          let off=0,isFirst=true;
          while(off<canvas.height){
            if(!isFirst)doc.addPage();isFirst=false;
            const sh=Math.min(canvas.height-off,slicePx);
            const sc=document.createElement("canvas");
            sc.width=canvas.width;sc.height=sh;
            sc.getContext("2d").drawImage(canvas,0,-off);
            doc.addImage(sc.toDataURL("image/png"),"PNG",MAR,MAR,CW,sh*scale);
            off+=sh;
          }
        }
        continue;
      }

      // ── Has tbody = Batting or Bowling ──────────────────────────────────────
      // Render page accent banner + section header + table column headers
      const pageTopHtml=pageHtml.slice(0,tbodyStart)+"<tbody></tbody></table></div>";
      doc.addPage();
      const topCanvas=await renderHtml(pageTopHtml);
      let curY=MAR+placeCanvas(topCanvas,MAR)+2;

      // Extract thead for repeating on continuation pages
      const theadHtml=pageHtml.slice(theadStart,theadEnd);
      const tableWrap=(rows,showHdr=false)=>`<div style="background:#fff;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;padding:0 28px;width:820px;box-sizing:border-box;"><table style="width:100%;border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;"><thead style="${showHdr?"":"visibility:hidden;height:0;font-size:0;"}">${theadHtml.slice(7,-8)}</thead><tbody>${rows}</tbody></table></div>`;

      // Split tbody into per-player groups
      // Aggregate rows = <tr> without background fafcfb/f8f9fc
      // Per-match rows = <tr style="background:#fafcfb"> or <tr style="background:#f8f9fc">
      const tbodyContent=pageHtml.slice(tbodyStart+7,tbodyEnd-8);
      const playerGroups=[];
      let buf="";
      for(const chunk of tbodyContent.split(/(?=<tr[^>]*>)/)){
        if(!chunk.trim())continue;
        const isPerMatch=chunk.includes("background:#fafcfb")||chunk.includes("background:#f8f9fc");
        if(!isPerMatch&&buf){
          playerGroups.push(buf);
          buf=chunk;
        } else {
          buf+=chunk;
        }
      }
      if(buf.trim())playerGroups.push(buf);

      // Place each player group — new page if no space
      for(const group of playerGroups){
        if(!group.trim())continue;
        const rowCanvas=await renderHtml(tableWrap(group,false));
        const rowH=(rowCanvas.height/rowCanvas.width)*CW;

        if(curY+rowH>PH-MAR-FOOTER){
          // Not enough room — new page, repeat column header only (no accent banner)
          doc.addPage();
          const hdrCanvas=await renderHtml(tableWrap("",true));
          curY=MAR+placeCanvas(hdrCanvas,MAR)+2;
        }

        placeCanvas(rowCanvas,curY);
        curY+=rowH+1;
      }
    }
  }finally{
    if(document.body.contains(container))document.body.removeChild(container);
  }

  // Footer on all pages
  const np=doc.internal.getNumberOfPages();
  for(let i=1;i<=np;i++){
    doc.setPage(i);
    doc.setFillColor(248,249,247);doc.rect(0,PH-FOOTER,PW,FOOTER,"F");
    doc.setDrawColor(210,210,210);doc.setLineWidth(0.3);doc.line(0,PH-FOOTER,PW,PH-FOOTER);
    doc.setFont("Helvetica","normal");doc.setFontSize(7);doc.setTextColor(150,150,150);
    doc.text("CrickitMatch by ArcGain LLC · Season Analytics Report",MAR,PH-7);
    doc.text("Page "+i+" of "+np,PW-MAR,PH-7,"right");
  }

  const ss=(season==="ALL"?"Career":season).replace(/[^a-zA-Z0-9]/g,"_");
  doc.save(`SeasonReport_${ss}_${new Date().toISOString().split("T")[0]}.pdf`);
  }catch(err){console.error("Season PDF error:",err);}
  finally{if(setExportingSeason)setExportingSeason(false);}
}

// ── Chart helper — mounts a Chart.js chart into a canvas after render ─────────
function useChart(canvasId,config,deps){
  useEffect(()=>{
    const el=document.getElementById(canvasId);
    if(!el)return;
    const existing=Chart.getChart(el);
    if(existing)existing.destroy();
    new Chart(el,config);
    return()=>{ try{ Chart.getChart(el)?.destroy(); }catch{} };
  },deps);
}

// ── Shared chart style tokens ─────────────────────────────────────────────────
const CG="#1A7A4A",CA="#EF9F27",CR="#E24B4A",CB="#185FA5",CT="#5DCAA5",CP="#D4537E";
const ctk={color:"#888780",font:{size:10}};
const cgrid={color:"rgba(0,0,0,0.06)"};
const cbase={responsive:true,maintainAspectRatio:false,plugins:{legend:{display:false}},scales:{x:{ticks:ctk,grid:cgrid},y:{ticks:ctk,grid:cgrid}}};

function SecHdr({title}){return <div style={{fontSize:12,fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"0.06em",margin:"18px 0 8px",paddingBottom:6,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>{title}</div>;}
function MetricCard({label,value,sub,color}){return <div style={{background:"#f8f9f7",borderRadius:8,padding:"10px 12px"}}><div style={{fontSize:11,color:"#6b7280",marginBottom:3}}>{label}</div><div style={{fontSize:20,fontWeight:500,color:color||"#1a1a1a"}}>{value}</div>{sub&&<div style={{fontSize:10,color:"#9ca3af",marginTop:2}}>{sub}</div>}</div>;}
function Legend({items}){return <div style={{display:"flex",flexWrap:"wrap",gap:10,fontSize:11,color:"#6b7280",marginBottom:10}}>{items.map(([c,l])=><span key={l}><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:c,marginRight:4,verticalAlign:"middle"}}/>{l}</span>)}</div>;}
function ChartCard({title,sub,children,chartId,height=180}){
  return <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
    <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>{title}</div>
    {sub&&<div style={{fontSize:11,color:"#6b7280",marginBottom:10}}>{sub}</div>}
    {children}
    <div style={{position:"relative",height}}><canvas id={chartId} role="img" aria-label={title}>Chart data</canvas></div>
  </div>;
}

// ── Shared horizontal bar helper ──────────────────────────────────────────────
function HBar({label,value,max,color,suffix="",sub="",showVal=true}){
  const pct=max>0?Math.min(100,Math.round(value/max*100)):0;
  return <div style={{marginBottom:8}}>
    <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
      <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{label}</span>
      {showVal&&<span style={{fontSize:12,color:"#6b7280"}}>{value}{suffix}{sub&&<span style={{marginLeft:6,fontSize:10,color:"#9ca3af"}}>{sub}</span>}</span>}
    </div>
    <div style={{height:10,background:"#f1efe8",borderRadius:5,overflow:"hidden"}}>
      <div style={{height:"100%",width:pct+"%",background:color,borderRadius:5,transition:"width .4s"}}/>
    </div>
  </div>;
}

function HBarSegmented({label,segments,total}){
  // segments: [{value, color, key}]
  const tot=total||segments.reduce((a,s)=>a+s.value,0)||1;
  return <div style={{marginBottom:8}}>
    <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
      <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{label}</span>
      <span style={{fontSize:11,color:"#6b7280"}}>{segments.map(s=>s.key+":"+s.value).join(" · ")}</span>
    </div>
    <div style={{height:12,background:"#f1efe8",borderRadius:5,overflow:"hidden",display:"flex",gap:1}}>
      {segments.map((s,i)=><div key={i} style={{height:"100%",width:(Math.round(s.value/tot*100))+"%",background:s.color,minWidth:s.value>0?2:0}}/>)}
    </div>
  </div>;
}

function HBarNeg({label,pos,neg,posColor,negColor,posLabel,negLabel}){
  const maxVal=Math.max(pos,neg,1);
  return <div style={{marginBottom:8}}>
    <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
      <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{label}</span>
      <span style={{fontSize:11}}>
        <span style={{color:posColor,marginRight:6}}>+{pos} {posLabel}</span>
        <span style={{color:negColor}}>-{neg} {negLabel}</span>
      </span>
    </div>
    <div style={{display:"flex",gap:3,alignItems:"center"}}>
      <div style={{flex:1,height:10,background:"#f1efe8",borderRadius:"5px 0 0 5px",overflow:"hidden",display:"flex",justifyContent:"flex-end"}}>
        <div style={{height:"100%",width:(Math.round(neg/maxVal*100))+"%",background:negColor,borderRadius:"5px 0 0 5px"}}/>
      </div>
      <div style={{width:2,height:14,background:"rgba(0,0,0,0.15)",flexShrink:0}}/>
      <div style={{flex:1,height:10,background:"#f1efe8",borderRadius:"0 5px 5px 0",overflow:"hidden"}}>
        <div style={{height:"100%",width:(Math.round(pos/maxVal*100))+"%",background:posColor,borderRadius:"0 5px 5px 0"}}/>
      </div>
    </div>
  </div>;
}

function ChartSection({title,sub,children}){
  return <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
    <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>{title}</div>
    {sub&&<div style={{fontSize:11,color:"#6b7280",marginBottom:10}}>{sub}</div>}
    {children}
  </div>;
}

// ── Batting charts ─────────────────────────────────────────────────────────────
function BattingCharts({pid,pdata,matches,careerView}){
  const bm=[...pdata.matches].filter(m=>m.batting).sort((a,b)=>a.date<b.date?-1:1);
  if(!bm.length) return <div style={{color:"#9ca3af",fontSize:12,padding:"8px 0"}}>No batting data for this player.</div>;
  const fmtDate=d=>{if(!d)return"?";const[y,mo,dy]=d.split("-");return new Date(+y,+mo-1,+dy).toLocaleDateString("en-US",{month:"short",day:"numeric"});}
  const lbl=m=>careerView?fmtDate(m.date)+(m.tournament?" ["+m.tournament.slice(0,4)+"]":""):"vs "+(m.opponent||"?").slice(0,12);

  // Helper to extract pip value/quality/dotType from mixed log entries
  const pV=b=>typeof b==="object"?b.v:b;
  const pQ=b=>typeof b==="object"?b.q:null;
  const pDt=b=>typeof b==="object"?b.dt:null;

  // Stats per match
  const perMatch=bm.map(m=>{
    const log=m.batting?.ballLog||[];
    const balls=m.batting?.balls||0;
    const runs=m.batting?.runs||0;
    const dots=m.batting?.dots||0;
    const sixes=log.filter(b=>pV(b)==="6").length;
    const fours=log.filter(b=>pV(b)==="4").length;
    const threes=log.filter(b=>pV(b)==="3").length;
    const twos=log.filter(b=>pV(b)==="2").length;
    const ones=log.filter(b=>pV(b)==="1").length;
    const bndryRuns=fours*4+sixes*6;
    const bndryBalls=fours+sixes;
    const nbRuns=runs-bndryRuns;
    const nbBalls=balls-bndryBalls;
    const nbSR=nbBalls>0?Math.round(nbRuns/nbBalls*100):0;
    const sr=balls>0?Math.round(runs/balls*100):0;
    const dotPct=balls>0?Math.round(dots/balls*100):0;
    const q=ROLES[pdata.role]?.[(m.batting?.cat||"u13").toLowerCase()]||[20,30];
    const quotaPct=q[1]>0?Math.round(balls/q[1]*100):0;
    const rotClr=dotPct<35?CG:dotPct<=50?CA:CR;
    const rotTxt=dotPct<35?"Good":dotPct<=50?"Slow":"Poor";
    // Ball quality stats
    const qualBalls=log.filter(b=>pQ(b));
    const tagged=qualBalls.length;
    const gdBalls=log.filter(b=>pQ(b)==="GD");
    const ftBalls=log.filter(b=>pQ(b)==="FT");
    const shBalls=log.filter(b=>pQ(b)==="SH");
    const opBalls=log.filter(b=>pQ(b)==="OP");
    const gdRuns=gdBalls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
    const ftRuns=ftBalls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
    const shRuns=shBalls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
    const opRuns=opBalls.reduce((a,b)=>{const v=pV(b);return a+(v==="."||v==="W"?0:parseInt(v)||0);},0);
    const gdSR=gdBalls.length>0?Math.round(gdRuns/gdBalls.length*100):null;
    const ftSR=ftBalls.length>0?Math.round(ftRuns/ftBalls.length*100):null;
    const shSR=shBalls.length>0?Math.round(shRuns/shBalls.length*100):null;
    const opSR=opBalls.length>0?Math.round(opRuns/opBalls.length*100):null;
    // Boundaries by quality
    const bndries=log.filter(b=>pV(b)==="4"||pV(b)==="6");
    const bndGD=bndries.filter(b=>pQ(b)==="GD").length;
    const bndFT=bndries.filter(b=>pQ(b)==="FT").length;
    const bndSH=bndries.filter(b=>pQ(b)==="SH").length;
    const bndOP=bndries.filter(b=>pQ(b)==="OP").length;
    const bndUnk=bndries.filter(b=>!pQ(b)).length;
    // Dot type breakdown
    const dotBalls=log.filter(b=>pV(b)===".");
    const dotBeaten=dotBalls.filter(b=>pDt(b)==="beat").length;
    const dotDefended=dotBalls.filter(b=>pDt(b)==="defended").length;
    const dotFielded=dotBalls.filter(b=>pDt(b)==="fielded").length;
    const dotUntagged=dotBalls.length-dotBeaten-dotDefended-dotFielded;
    // Wicket quality
    const wicketBall=log.find(b=>pV(b)==="W");
    const wicketQ=wicketBall?pQ(wicketBall):null;
    // QC score — runs off GD ÷ GD balls (batter equivalent of bowling CR)
    const qcScore=gdBalls.length>0?parseFloat((gdRuns/gdBalls.length).toFixed(2)):null;
    return{label:lbl(m),balls,runs,dots,sr,dotPct,sixes,fours,threes,twos,ones,nbSR,quotaPct,status:m.batting?.status||"",rotClr,rotTxt,
      tagged,gdBalls:gdBalls.length,ftBalls:ftBalls.length,shBalls:shBalls.length,opBalls:opBalls.length,
      gdSR,ftSR,shSR,opSR,bndGD,bndFT,bndSH,bndOP,bndUnk,
      dotBeaten,dotDefended,dotFielded,dotUntagged,wicketQ,qcScore};
  });

  // Season totals
  const tb=bm.reduce((a,m)=>a+(m.batting?.balls||0),0);
  const tr=bm.reduce((a,m)=>a+(m.batting?.runs||0),0);
  const td=bm.reduce((a,m)=>a+(m.batting?.dots||0),0);
  const avgSR=tb>0?Math.round(tr/tb*100):0;
  const avgDot=tb>0?Math.round(td/tb*100):0;
  const qm=bm.filter(m=>["met","retired"].includes(m.batting?.status)).length;
  const out=bm.filter(m=>m.batting?.status==="out").length;
  const ret=bm.filter(m=>m.batting?.status==="retired").length;
  const maxSR=Math.max(1,...perMatch.map(p=>p.sr));
  const maxNbSR=Math.max(1,...perMatch.map(p=>p.nbSR));

  return <>
    {/* Season metric cards */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(80px,1fr))",gap:8,marginBottom:10}}>
      <MetricCard label="Total runs" value={tr} color={tr>50?CG:"#1a1a1a"}/>
      <MetricCard label="Total balls" value={tb}/>
      <MetricCard label="Avg SR" value={avgSR} color={avgSR>100?CG:avgSR<50?CR:"#1a1a1a"}/>
      <MetricCard label="Avg dot%" value={avgDot+"%"} color={avgDot>50?CR:avgDot<35?CG:CA}/>
      <MetricCard label="Quota met" value={`${qm}/${bm.length}`}/>
      <MetricCard label="Out" value={out} color={out>2?CR:"#1a1a1a"}/>
      <MetricCard label="Retired" value={ret} color={ret>0?CG:"#9ca3af"} sub="full quota"/>
    </div>

    {/* 1. Strike rate by match */}
    <ChartSection title="Strike rate by match" sub="Green ≥100 · amber 50–99 · red <50">
      {perMatch.map((p,i)=><HBar key={i} label={p.label} value={p.sr} max={maxSR} color={p.sr>=100?CG:p.sr>=50?CA:CR} suffix=""/>)}
    </ChartSection>

    {/* 2. Non-boundary strike rotation */}
    <ChartSection title="Non-boundary strike rotation per match" sub="(Runs − 4s&6s) ÷ (Balls − 4s&6s) × 100 · Measures singles & 2s & 3s ability">
      {perMatch.map((p,i)=><HBar key={i} label={p.label} value={p.nbSR} max={maxNbSR} color={p.nbSR>=80?CG:p.nbSR>=50?CA:CR}/>)}
    </ChartSection>

    {/* 3. Dot ball % per match */}
    <ChartSection title="Dot ball % per match" sub="< 35% = good rotation · 35–50% = slow · > 50% = poor">
      {perMatch.map((p,i)=>(
        <div key={i} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
            <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
            <span style={{fontSize:12,fontWeight:700,background:p.rotClr==="1A7A4A"?"#e6f4ec":p.rotClr===CA?"#faeeda":"#fcebeb",color:p.rotClr,padding:"1px 8px",borderRadius:10}}>{p.dotPct}% — {p.rotTxt}</span>
          </div>
          <div style={{height:10,background:"#f1efe8",borderRadius:5,overflow:"hidden"}}>
            <div style={{height:"100%",width:p.dotPct+"%",background:p.rotClr,borderRadius:5}}/>
          </div>
        </div>
      ))}
    </ChartSection>

    {/* 4. Scoring breakdown per match */}
    <ChartSection title="Scoring breakdown per match" sub="6s & 4s = power hitting · 1s & 3s = strike rotation">
      {perMatch.map((p,i)=>{
        const tot=p.sixes+p.fours+p.threes+p.twos+p.ones||1;
        return <HBarSegmented key={i} label={p.label}
          segments={[{value:p.sixes,color:CG,key:"6s"},{value:p.fours,color:CT,key:"4s"},{value:p.threes,color:CB,key:"3s"},{value:p.twos,color:"#85B7EB",key:"2s"},{value:p.ones,color:"#B5D4F4",key:"1s"}]}
          total={tot}/>;
      })}
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:8}}>
        {[[CG,"6s"],[CT,"4s"],[CB,"3s"],["#85B7EB","2s"],["#B5D4F4","1s"]].map(([c,l])=>(
          <span key={l} style={{fontSize:11,color:"#6b7280",display:"flex",alignItems:"center",gap:4}}>
            <span style={{width:10,height:10,borderRadius:2,background:c,display:"inline-block"}}/>  {l}
          </span>
        ))}
      </div>
    </ChartSection>

    {/* 5. Quota utilisation */}
    <ChartSection title="Quota utilisation % per match" sub="Balls faced ÷ max allowed · 100% = full quota used">
      {perMatch.map((p,i)=><HBar key={i} label={p.label} value={p.quotaPct} max={100} color={p.quotaPct>=100?CG:p.quotaPct>=60?CA:CR} suffix="%" sub={p.status==="retired"?"retired ✓":p.status==="out"?"out":p.status==="met"?"quota met":""}/>)}
    </ChartSection>

    {/* ── BALL QUALITY ANALYTICS ── only shown if any quality data exists */}
    {perMatch.some(p=>p.tagged>0)&&<>
      {/* Coverage note */}
      {(()=>{const tot=perMatch.reduce((a,p)=>a+p.balls,0);const tag=perMatch.reduce((a,p)=>a+p.tagged,0);const pct=tot>0?Math.round(tag/tot*100):0;return <div style={{background:"#f5eeff",border:"0.5px solid #9B59C4",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:"#6B21A8"}}><strong>🏷 Ball quality data</strong> — tagged on {tag} of {tot} balls ({pct}%). {pct<30?"Low coverage — treat charts as directional only.":pct<60?"Moderate coverage.":"Good coverage."}</div>})()}

      {/* Card A — Dot ball breakdown */}
      <ChartSection title="Dot ball breakdown by type" sub="Beaten = bowler won · Defended = batter chose not to score · Fielded = batter had intent, run denied">
        {perMatch.map((p,i)=>{
          const total=p.dotBeaten+p.dotDefended+p.dotFielded+p.dotUntagged||1;
          return <div key={i} style={{marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
              <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
              <span style={{fontSize:11,color:"#6b7280"}}>
                {p.dotBeaten>0&&<span style={{color:"#A32D2D",marginRight:6}}>● {p.dotBeaten} beaten</span>}
                {p.dotDefended>0&&<span style={{color:"#854F0B",marginRight:6}}>▪ {p.dotDefended} defended</span>}
                {p.dotFielded>0&&<span style={{color:CG,marginRight:6}}>◆ {p.dotFielded} fielded</span>}
              </span>
            </div>
            <div style={{height:10,background:"#f1efe8",borderRadius:5,overflow:"hidden",display:"flex"}}>
              <div style={{height:"100%",width:(p.dotBeaten/total*100)+"%",background:"#A32D2D"}}/>
              <div style={{height:"100%",width:(p.dotDefended/total*100)+"%",background:"#EF9F27"}}/>
              <div style={{height:"100%",width:(p.dotFielded/total*100)+"%",background:CG}}/>
              <div style={{height:"100%",width:(p.dotUntagged/total*100)+"%",background:"#e5e7eb"}}/>
            </div>
          </div>;
        })}
        <div style={{display:"flex",gap:12,marginTop:6,flexWrap:"wrap"}}>
          {[["#A32D2D","● Beaten"],["#EF9F27","▪ Defended"],[CG,"◆ Fielded"],["#e5e7eb","Untagged"]].map(([c,l])=>(
            <span key={l} style={{fontSize:11,color:"#6b7280",display:"flex",alignItems:"center",gap:4}}>
              <span style={{width:10,height:10,borderRadius:2,background:c,display:"inline-block",border:"0.5px solid rgba(0,0,0,0.1)"}}/>{l}
            </span>
          ))}
        </div>
      </ChartSection>

      {/* Card B — Strike rate by ball quality */}
      <ChartSection title="Strike rate by ball quality" sub="Shows whether batter scores against quality bowling (GD) or only off bad balls (FT/SH/OP)">
        {perMatch.map((p,i)=>{
          const rows=[["GD","Good length",p.gdSR,p.gdBalls,CG],["FT","Full toss",p.ftSR,p.ftBalls,"#A32D2D"],["SH","Short",p.shSR,p.shBalls,"#185FA5"],["OP","Overpitch",p.opSR,p.opBalls,"#854F0B"]].filter(([,,sr,n])=>n>0);
          if(!rows.length) return null;
          const maxSR2=Math.max(1,...rows.map(r=>r[2]||0));
          return <div key={i} style={{marginBottom:10}}>
            <div style={{fontSize:12,fontWeight:600,color:"#1a1a1a",marginBottom:4}}>{p.label}</div>
            {rows.map(([q,lbl,sr,n,c])=>(
              <div key={q} style={{marginBottom:4}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                  <span style={{fontSize:11,color:c,fontWeight:600}}>{q} <span style={{color:"#6b7280",fontWeight:400}}>{lbl}</span></span>
                  <span style={{fontSize:11,color:sr>=100?CG:sr>=50?CA:CR,fontWeight:700}}>{sr} SR <span style={{color:"#9ca3af",fontWeight:400}}>({n}b)</span></span>
                </div>
                <div style={{height:7,background:"#f1f5f9",borderRadius:4,overflow:"hidden"}}>
                  <div style={{height:"100%",width:Math.min(100,sr/maxSR2*100)+"%",background:sr>=100?CG:sr>=50?CA:CR,borderRadius:4}}/>
                </div>
              </div>
            ))}
          </div>;
        })}
        <div style={{fontSize:11,color:"#9ca3af",marginTop:4}}>High SR vs GD = scoring against quality bowling — key selection indicator.</div>
      </ChartSection>

      {/* Card C — Boundary source */}
      {perMatch.some(p=>p.fours+p.sixes>0)&&<ChartSection title="Boundary source by ball quality" sub="Where are the 4s and 6s coming from? GD boundaries = genuine shot-making ability">
        {perMatch.map((p,i)=>{
          const tot=p.bndGD+p.bndFT+p.bndSH+p.bndOP+p.bndUnk||1;
          const bndTotal=p.fours+p.sixes;
          if(!bndTotal) return null;
          return <div key={i} style={{marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
              <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
              <span style={{fontSize:11,color:"#6b7280"}}>{bndTotal} boundaries · {p.bndGD>0&&<span style={{color:CG,fontWeight:600}}>{Math.round(p.bndGD/bndTotal*100)}% vs GD</span>}</span>
            </div>
            <div style={{height:10,background:"#f1efe8",borderRadius:5,overflow:"hidden",display:"flex"}}>
              <div title="Good length" style={{height:"100%",width:(p.bndGD/tot*100)+"%",background:CG}}/>
              <div title="Full toss" style={{height:"100%",width:(p.bndFT/tot*100)+"%",background:"#A32D2D"}}/>
              <div title="Short" style={{height:"100%",width:(p.bndSH/tot*100)+"%",background:"#185FA5"}}/>
              <div title="Overpitch" style={{height:"100%",width:(p.bndOP/tot*100)+"%",background:"#854F0B"}}/>
              <div title="Untagged" style={{height:"100%",width:(p.bndUnk/tot*100)+"%",background:"#e5e7eb"}}/>
            </div>
          </div>;
        })}
        <div style={{display:"flex",gap:12,marginTop:6,flexWrap:"wrap"}}>
          {[[CG,"GD"],["#A32D2D","FT"],["#185FA5","SH"],["#854F0B","OP"],["#e5e7eb","Untagged"]].map(([c,l])=>(
            <span key={l} style={{fontSize:11,color:"#6b7280",display:"flex",alignItems:"center",gap:4}}>
              <span style={{width:10,height:10,borderRadius:2,background:c,display:"inline-block",border:"0.5px solid rgba(0,0,0,0.1)"}}/>{l}
            </span>
          ))}
        </div>
      </ChartSection>}

      {/* Card D — Wicket quality */}
      {perMatch.some(p=>p.status==="out"&&p.wicketQ)&&<ChartSection title="Wicket quality — how were they dismissed?" sub="Out to GD = genuinely beaten · Out to FT/SH = poor shot selection">
        {perMatch.filter(p=>p.status==="out").map((p,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>
            <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
            {p.wicketQ
              ?<span style={{fontSize:12,fontWeight:700,padding:"2px 10px",borderRadius:10,background:p.wicketQ==="GD"?"#fcebeb":p.wicketQ==="FT"?"#faeeda":"#eef4fb",color:p.wicketQ==="GD"?"#A32D2D":p.wicketQ==="FT"?"#854F0B":"#185FA5"}}>Out — {p.wicketQ} ball</span>
              :<span style={{fontSize:11,color:"#9ca3af"}}>Out — ball not tagged</span>}
          </div>
        ))}
        {(()=>{const outQ=perMatch.filter(p=>p.status==="out"&&p.wicketQ);const gdOut=outQ.filter(p=>p.wicketQ==="GD").length;if(outQ.length>0)return <div style={{fontSize:11,color:"#6b7280",marginTop:6}}>{gdOut}/{outQ.length} tagged dismissals were to GD balls ({outQ.length>0?Math.round(gdOut/outQ.length*100):0}%).</div>})()}
      </ChartSection>}

      {/* Card E — Quality control score */}
      {perMatch.some(p=>p.qcScore!==null)&&<ChartSection title="Quality control score (QC)" sub="Runs ÷ good-length balls faced · measures scoring against quality bowling · higher = better">
        {perMatch.map((p,i)=>{
          if(p.qcScore===null) return <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}><span style={{fontSize:12,color:"#1a1a1a"}}>{p.label}</span><span style={{fontSize:11,color:"#9ca3af"}}>No GD data</span></div>;
          const clr=p.qcScore>=1.0?CG:p.qcScore>=0.5?CA:CR;
          return <div key={i} style={{marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
              <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
              <span style={{fontSize:12,fontWeight:700,color:clr}}>QC: {p.qcScore.toFixed(2)} <span style={{color:"#9ca3af",fontWeight:400}}>({p.gdBalls} GD balls)</span></span>
            </div>
            <div style={{height:8,background:"#f1f5f9",borderRadius:4,overflow:"hidden"}}>
              <div style={{height:"100%",width:Math.min(100,p.qcScore*50)+"%",background:clr,borderRadius:4}}/>
            </div>
          </div>;
        })}
        <div style={{fontSize:11,color:"#9ca3af",marginTop:4}}>QC ≥1.0 = scoring freely vs quality · 0.5–1.0 = managing · &lt;0.5 = troubled by good bowling.</div>
      </ChartSection>}
    </>}
  </>;
}

// ── Bowling charts ──────────────────────────────────────────────────────────────
function BowlingCharts({pid,pdata,careerView}){
  const bm=[...pdata.matches].filter(m=>m.bowling&&m.bowling.overs>0).sort((a,b)=>a.date<b.date?-1:1);
  if(!bm.length) return <div style={{color:"#9ca3af",fontSize:12,padding:"8px 0"}}>No bowling data for this player.</div>;
  const fmtDate2=d=>{if(!d)return"?";const[y,mo,dy]=d.split("-");return new Date(+y,+mo-1,+dy).toLocaleDateString("en-US",{month:"short",day:"numeric"});}
  const lbl=m=>careerView?fmtDate2(m.date)+(m.tournament?" ["+m.tournament.slice(0,4)+"]":""):"vs "+(m.opponent||"?").slice(0,12);

  const perMatch=bm.map(m=>{
    const balls=m.bowling.overs*6+(m.bowling.legalInOver||0);
    const gd=m.bowling.good||0;
    const op=m.bowling.overpitch||0;
    const ft=m.bowling.fullToss||0;
    const sh=m.bowling.short||0;
    const tot=gd+op+ft+sh||1;
    const dotPct=balls>0?Math.round(gd/balls*100):0; // dots ≈ good length balls
    const scoringBalls=balls-gd;
    const cr=balls>0?parseFloat((gd/Math.max(1,scoringBalls)).toFixed(2)):0;
    const econ=m.bowling.overs>0?parseFloat((m.bowling.runs/m.bowling.overs).toFixed(1)):0;
    return{
      label:lbl(m),
      balls,econ,wkts:m.bowling.wickets||0,
      gd,op,ft,sh,tot,dotPct,cr,
      wides:m.bowling.wides||0,nb:m.bowling.noBalls||0,
    };
  });

  // Season totals
  const to=bm.reduce((a,m)=>a+(m.bowling.overs||0),0);
  const tr=bm.reduce((a,m)=>a+(m.bowling.runs||0),0);
  const tw=bm.reduce((a,m)=>a+(m.bowling.wickets||0),0);
  const tgd=bm.reduce((a,m)=>a+(m.bowling.good||0),0);
  const tft=bm.reduce((a,m)=>a+(m.bowling.fullToss||0),0);
  const tsh=bm.reduce((a,m)=>a+(m.bowling.short||0),0);
  const twd3=bm.reduce((a,m)=>a+(m.bowling.wides||0),0);
  const tnb3=bm.reduce((a,m)=>a+(m.bowling.noBalls||0),0);
  const tbl=to*6+twd3+tnb3;
  const avgEcon=to>0?(tr/to).toFixed(1):"-";
  const wsr=tw>0?Math.round(tbl/tw):"-";
  const wkAvg=tw>0?(tr/tw).toFixed(1):"-";
  const gdPct=tbl>0?Math.round(tgd/tbl*100):0;
  const lossPct=tbl>0?Math.round((tft+tsh)/tbl*100):0;
  const maxEcon=Math.max(1,...perMatch.map(p=>p.econ));
  const maxCR=Math.max(0.01,...perMatch.map(p=>p.cr));

  return <>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(80px,1fr))",gap:8,marginBottom:10}}>
      <MetricCard label="Wickets" value={tw} color={tw>5?CG:"#1a1a1a"}/>
      <MetricCard label="Avg economy" value={avgEcon} color={parseFloat(avgEcon)>8?CR:parseFloat(avgEcon)<5?CG:"#1a1a1a"}/>
      <MetricCard label="Wkt SR" value={wsr} sub="balls/wkt"/>
      <MetricCard label="Wkt avg" value={wkAvg} sub="runs/wkt"/>
      <MetricCard label="Good length%" value={gdPct+"%"} color={gdPct>60?CG:gdPct<40?CR:CA}/>
      <MetricCard label="Length loss%" value={lossPct+"%"} color={lossPct>25?CR:CG}/>
    </div>

    {/* 1. Bowling length control — horizontal segmented */}
    <ChartSection title="Bowling length control by match" sub="Good length % shown on right · target >60%">
      {perMatch.map((p,i)=>(
        <div key={i} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
            <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
            <span style={{fontSize:12,fontWeight:700,color:p.gd/p.tot*100>=60?CG:p.gd/p.tot*100>=40?CA:CR}}>{Math.round(p.gd/p.tot*100)}% good</span>
          </div>
          <div style={{height:14,background:"#f1efe8",borderRadius:5,overflow:"hidden",display:"flex",gap:1}}>
            <div style={{width:Math.round(p.gd/p.tot*100)+"%",background:CG,height:"100%"}}/>
            <div style={{width:Math.round(p.op/p.tot*100)+"%",background:CA,height:"100%"}}/>
            <div style={{width:Math.round(p.ft/p.tot*100)+"%",background:CR,height:"100%"}}/>
            <div style={{width:Math.round(p.sh/p.tot*100)+"%",background:CB,height:"100%"}}/>
          </div>
        </div>
      ))}
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:6}}>
        {[[CG,"Good length"],[CA,"Overpitch"],[CR,"Full toss"],[CB,"Short"]].map(([c,l])=>(
          <span key={l} style={{fontSize:11,color:"#6b7280",display:"flex",alignItems:"center",gap:4}}>
            <span style={{width:10,height:10,borderRadius:2,background:c,display:"inline-block"}}/>{l}
          </span>
        ))}
      </div>
    </ChartSection>

    {/* 2. Control rate — dot balls vs scoring balls */}
    <ChartSection title="Bowling control rate by match" sub="Good length balls ÷ non-good-length balls · higher = better control">
      {perMatch.map((p,i)=>(
        <div key={i} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
            <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
            <span style={{fontSize:12,color:"#6b7280"}}>
              <span style={{color:CG,marginRight:4}}>{p.gd} GL</span>
              <span style={{color:CR,marginRight:6}}>{p.balls-p.gd} non-GL</span>
              <span style={{fontWeight:700,color:p.cr>=1.5?CG:p.cr>=0.8?CA:CR}}>CR: {p.cr.toFixed(2)}</span>
            </span>
          </div>
          <div style={{height:10,background:"#f1efe8",borderRadius:5,overflow:"hidden"}}>
            <div style={{height:"100%",width:(p.balls>0?Math.round(p.gd/p.balls*100):0)+"%",background:p.cr>=1.5?CG:p.cr>=0.8?CA:CR,borderRadius:5}}/>
          </div>
        </div>
      ))}
      <div style={{fontSize:11,color:"#9ca3af",marginTop:6}}>CR ≥1.5 = excellent · 0.8–1.5 = good · &lt;0.8 = needs work</div>
    </ChartSection>

    {/* 3. Dot ball % */}
    <ChartSection title="Dot ball % per match" sub="Good length balls as % of total balls bowled · ≥60% = good">
      {perMatch.map((p,i)=><HBar key={i} label={p.label} value={p.dotPct} max={100} color={p.dotPct>=60?CG:p.dotPct>=40?CA:CR} suffix="%"/>)}
    </ChartSection>

    {/* 4. Wides & no-balls */}
    <ChartSection title="Wides & no-balls per match" sub="Lower = better line and length control">
      {perMatch.map((p,i)=>(
        <div key={i} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
            <span style={{fontSize:12,fontWeight:600,color:"#1a1a1a"}}>{p.label}</span>
            <span style={{fontSize:11,color:"#6b7280"}}>
              <span style={{color:CA,marginRight:6}}>Wd: {p.wides}</span>
              <span style={{color:CR}}>Nb: {p.nb}</span>
            </span>
          </div>
          <div style={{display:"flex",gap:4}}>
            <div style={{flex:1,height:8,background:"#f1efe8",borderRadius:5,overflow:"hidden"}}>
              <div style={{height:"100%",width:Math.min(100,p.wides*20)+"%",background:CA,borderRadius:5}}/>
            </div>
            <div style={{flex:1,height:8,background:"#f1efe8",borderRadius:5,overflow:"hidden"}}>
              <div style={{height:"100%",width:Math.min(100,p.nb*20)+"%",background:CR,borderRadius:5}}/>
            </div>
          </div>
        </div>
      ))}
    </ChartSection>

    {/* 5. Economy trend */}
    <ChartSection title="Economy rate per match" sub="Runs conceded per over · green ≤5 · amber 5–8 · red >8">
      {perMatch.map((p,i)=><HBar key={i} label={p.label+" ("+p.wkts+"W)"} value={p.econ} max={maxEcon} color={p.econ<=5?CG:p.econ<=8?CA:CR} suffix=" er"/>)}
    </ChartSection>
  </>;
}

// ── Fielding charts ────────────────────────────────────────────────────────────
function FieldingCharts({pid,pdata,careerView}){
  const fm=[...pdata.matches].filter(m=>m.fielding).sort((a,b)=>a.date<b.date?-1:1);
  if(!fm.length) return <div style={{color:"#9ca3af",fontSize:12,padding:"8px 0"}}>No fielding data for this player.</div>;
  const fmtDate3=d=>{if(!d)return"?";const[y,mo,dy]=d.split("-");return new Date(+y,+mo-1,+dy).toLocaleDateString("en-US",{month:"short",day:"numeric"});}
  const lbl=m=>careerView?fmtDate3(m.date)+(m.tournament?" ["+m.tournament.slice(0,4)+"]":""):"vs "+(m.opponent||"?").slice(0,12);

  const sum=k=>fm.reduce((a,m)=>a+(m.fielding?.[k]||0),0);
  const tc=sum("catches"),mc=sum("missedCatch");
  const ro=sum("runouts"),mro=sum("missedRunout");
  const st=sum("stumpings"),mst=sum("missedStumping");
  const ws=sum("widesSaved"),bg=sum("byesGiven");
  const rs=sum("runsSaved"),mf=sum("misfields");
  const tsp=sum("sports");
  const tot=tc+ro+st,miss=mc+mro+mst,net=tot-miss,pct=tot+miss>0?Math.round(tot/(tot+miss)*100):0;

  return <>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(80px,1fr))",gap:8,marginBottom:10}}>
      <MetricCard label="Catches" value={tc} color={CG} sub={mc>0?"missed "+mc:undefined}/>
      <MetricCard label="Runouts" value={ro} color={CB} sub={mro>0?"missed "+mro:undefined}/>
      <MetricCard label="Stumpings" value={st} color={CP} sub={mst>0?"missed "+mst:undefined}/>
      <MetricCard label="Sport. pts" value={tsp} color={CA}/>
      <MetricCard label="Net" value={(net>=0?"+":"")+net} color={net>=0?CG:CR} sub="taken−missed"/>
      <MetricCard label="Success%" value={pct+"%"} color={pct>=80?CG:pct>=60?CA:CR}/>
    </div>

    {/* 1. Catches */}
    <ChartSection title="Catches per match" sub="Left = missed (red) · Right = taken (green)">
      {fm.map((m,i)=><HBarNeg key={i} label={lbl(m)} pos={m.fielding.catches||0} neg={m.fielding.missedCatch||0} posColor={CG} negColor={CR} posLabel="caught" negLabel="missed"/>)}
    </ChartSection>

    {/* 2. Runouts */}
    <ChartSection title="Runouts per match" sub="Left = missed · Right = effected">
      {fm.map((m,i)=><HBarNeg key={i} label={lbl(m)} pos={m.fielding.runouts||0} neg={m.fielding.missedRunout||0} posColor={CB} negColor={"#85B7EB"} posLabel="effected" negLabel="missed"/>)}
    </ChartSection>

    {/* 3. Stumpings */}
    <ChartSection title="Stumpings per match" sub="Left = missed · Right = effected">
      {fm.map((m,i)=><HBarNeg key={i} label={lbl(m)} pos={m.fielding.stumpings||0} neg={m.fielding.missedStumping||0} posColor={CP} negColor={"#F4C0D1"} posLabel="effected" negLabel="missed"/>)}
    </ChartSection>

    {/* 4. WK wides saved / byes given */}
    <ChartSection title="Wicketkeeping — wides saved vs byes given" sub="Left = byes given (red) · Right = wides saved (green)">
      {fm.map((m,i)=><HBarNeg key={i} label={lbl(m)} pos={m.fielding.widesSaved||0} neg={m.fielding.byesGiven||0} posColor={CG} negColor={CR} posLabel="saved" negLabel="byes"/>)}
      {ws===0&&bg===0&&<div style={{fontSize:11,color:"#9ca3af",marginTop:4}}>No wicketkeeping data recorded yet — available in the Fielding tab.</div>}
    </ChartSection>

    {/* 5. Runs saved / misfields */}
    <ChartSection title="Runs saved vs misfields per match" sub="Left = misfields (red) · Right = runs saved (green)">
      {fm.map((m,i)=><HBarNeg key={i} label={lbl(m)} pos={m.fielding.runsSaved||0} neg={m.fielding.misfields||0} posColor={CG} negColor={CR} posLabel="saved" negLabel="misfield"/>)}
      {rs===0&&mf===0&&<div style={{fontSize:11,color:"#9ca3af",marginTop:4}}>No runs saved/misfield data recorded yet — available in the Fielding tab.</div>}
    </ChartSection>
  </>;
}

// ── Tournament comparison charts for one player ───────────────────────────────
function TournamentComparison({pid,pdata,tournaments}){
  // Build per-tournament aggregates
  const tourData={};
  pdata.matches.forEach(m=>{
    const t=m.tournament||"Unknown";
    if(!tourData[t]) tourData[t]={t,batBalls:0,batRuns:0,batDots:0,batMatches:0,bowlOvers:0,bowlRuns:0,bowlWkts:0,bowlMatches:0,fldTaken:0,fldMissed:0,fldSP:0};
    if(m.batting){
      tourData[t].batBalls+=m.batting.balls||0;
      tourData[t].batRuns+=m.batting.runs||0;
      tourData[t].batDots+=m.batting.dots||0;
      tourData[t].batMatches++;
    }
    if(m.bowling&&m.bowling.overs>0){
      tourData[t].bowlOvers+=m.bowling.overs||0;
      tourData[t].bowlRuns+=m.bowling.runs||0;
      tourData[t].bowlWkts+=m.bowling.wickets||0;
      tourData[t].bowlMatches++;
    }
    if(m.fielding){
      tourData[t].fldTaken+=(m.fielding.catches||0)+(m.fielding.runouts||0)+(m.fielding.stumpings||0);
      tourData[t].fldMissed+=(m.fielding.missedCatch||0)+(m.fielding.missedRunout||0)+(m.fielding.missedStumping||0);
      tourData[t].fldSP+=m.fielding.sports||0;
    }
  });

  const tList=Object.values(tourData);
  if(tList.length<2) return(
    <div style={{...{background:"#f8f9f7",borderRadius:8,padding:"12px 16px"},fontSize:13,color:"#6b7280"}}>
      Tournament comparison requires data from at least 2 tournaments. Load "All tournaments" and ensure this player has appeared in multiple tournaments.
    </div>
  );

  const labels=tList.map(t=>t.t.length>18?t.t.slice(0,16)+"…":t.t);
  const avgSR=tList.map(t=>t.batBalls>0?Math.round(t.batRuns/t.batBalls*100):0);
  const dotPct=tList.map(t=>t.batBalls>0?Math.round(t.batDots/t.batBalls*100):0);
  const avgEcon=tList.map(t=>t.bowlOvers>0?parseFloat((t.bowlRuns/t.bowlOvers).toFixed(1)):null);
  const wktsPerMatch=tList.map(t=>t.bowlMatches>0?parseFloat((t.bowlWkts/t.bowlMatches).toFixed(1)):null);
  const fldSucc=tList.map(t=>{const tot=t.fldTaken+t.fldMissed;return tot>0?Math.round(t.fldTaken/tot*100):null;});

  const srColors=avgSR.map(v=>v>=100?CG:v>=60?CA:CR);
  const econColors=avgEcon.map(v=>v===null?"#d3d1c7":v<=5?CG:v<=8?CA:CR);

  const id1=`tc-bat-${pid}`,id2=`tc-bowl-${pid}`,id3=`tc-fld-${pid}`;

  useChart(id1,{
    data:{labels,datasets:[
      {type:"bar",label:"Avg SR",data:avgSR,backgroundColor:srColors,yAxisID:"y",order:2},
      {type:"line",label:"Dot%",data:dotPct,borderColor:CA,pointBackgroundColor:CA,pointRadius:5,backgroundColor:"transparent",yAxisID:"y2",order:1,tension:0.2},
    ]},
    options:{...cbase,scales:{
      x:{ticks:{...ctk,maxRotation:30},grid:cgrid},
      y:{ticks:{...ctk,callback:v=>v+" SR"},grid:cgrid,position:"left"},
      y2:{ticks:{...ctk,callback:v=>v+"%"},grid:{display:false},position:"right",min:0,max:100},
    }}
  },[pid]);

  useChart(id2,{
    data:{labels,datasets:[
      {type:"bar",label:"Avg economy",data:avgEcon,backgroundColor:econColors,yAxisID:"y",order:2},
      {type:"line",label:"Wkts/match",data:wktsPerMatch,borderColor:CP,pointBackgroundColor:CP,pointRadius:5,backgroundColor:"transparent",yAxisID:"y2",order:1,tension:0.2},
    ]},
    options:{...cbase,scales:{
      x:{ticks:{...ctk,maxRotation:30},grid:cgrid},
      y:{ticks:{...ctk,callback:v=>v+" er"},grid:cgrid,position:"left"},
      y2:{ticks:{...ctk,callback:v=>v+" w"},grid:{display:false},position:"right",min:0},
    }}
  },[pid]);

  useChart(id3,{
    type:"bar",
    data:{labels,datasets:[
      {label:"Fielding success%",data:fldSucc,backgroundColor:fldSucc.map(v=>v===null?"#d3d1c7":v>=80?CG:v>=60?CA:CR)},
    ]},
    options:{...cbase,scales:{
      x:{ticks:{...ctk,maxRotation:30},grid:cgrid},
      y:{ticks:{...ctk,callback:v=>v+"%"},grid:cgrid,min:0,max:100},
    }}
  },[pid]);

  return <div>
    <div style={{background:"#e6f1fb",borderRadius:8,padding:"8px 14px",fontSize:12,color:"#185FA5",marginBottom:12}}>
      Comparing {tList.length} tournaments · each bar = one tournament · colour = performance level
    </div>

    <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>Batting — avg strike rate &amp; dot ball% by tournament</div>
      <div style={{fontSize:11,color:"#6b7280",marginBottom:10}}>Green SR ≥100 · amber 60–99 · red &lt;60 · line = dot ball%</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:10,fontSize:11,color:"#6b7280",marginBottom:8}}>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CG,marginRight:4,verticalAlign:"middle"}}/>SR ≥100</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CA,marginRight:4,verticalAlign:"middle"}}/>SR 60–99</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CR,marginRight:4,verticalAlign:"middle"}}/>SR &lt;60</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:50,background:CA,marginRight:4,verticalAlign:"middle"}}/>Dot ball%</span>
      </div>
      <div style={{position:"relative",height:180}}><canvas id={id1} role="img" aria-label="Batting comparison by tournament">Batting strike rate and dot ball percentage per tournament.</canvas></div>
    </div>

    <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>Bowling — avg economy &amp; wickets per match by tournament</div>
      <div style={{fontSize:11,color:"#6b7280",marginBottom:10}}>Green economy ≤5 · amber 5–8 · red &gt;8 · line = wickets per match</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:10,fontSize:11,color:"#6b7280",marginBottom:8}}>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CG,marginRight:4,verticalAlign:"middle"}}/>Econ ≤5</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CA,marginRight:4,verticalAlign:"middle"}}/>Econ 5–8</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:2,background:CR,marginRight:4,verticalAlign:"middle"}}/>Econ &gt;8</span>
        <span><span style={{display:"inline-block",width:10,height:10,borderRadius:50,background:CP,marginRight:4,verticalAlign:"middle"}}/>Wkts/match</span>
      </div>
      <div style={{position:"relative",height:180}}><canvas id={id2} role="img" aria-label="Bowling comparison by tournament">Bowling economy and wickets per match per tournament.</canvas></div>
    </div>

    <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>Fielding — success rate by tournament</div>
      <div style={{fontSize:11,color:"#6b7280",marginBottom:10}}>Green ≥80% · amber 60–79% · red &lt;60% · grey = no data</div>
      <div style={{position:"relative",height:140}}><canvas id={id3} role="img" aria-label="Fielding success rate by tournament">Fielding success percentage per tournament.</canvas></div>
    </div>

    {/* Summary comparison table */}
    <div style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"14px 16px",marginBottom:10}}>
      <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:10}}>Head-to-head tournament comparison</div>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr>
            {["Tournament","Bat M","Runs","Avg SR","Dot%","Bowl M","Overs","Wkts","Avg Econ","Fld%"].map(h=>(
              <th key={h} style={{textAlign:"left",padding:"6px 8px",fontSize:11,fontWeight:700,color:"#1a1a1a",background:"#f0f4f2",whiteSpace:"nowrap"}}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {tList.map((t,i)=>{
              const sr=t.batBalls>0?Math.round(t.batRuns/t.batBalls*100):"-";
              const dp=t.batBalls>0?Math.round(t.batDots/t.batBalls*100):"-";
              const er=t.bowlOvers>0?(t.bowlRuns/t.bowlOvers).toFixed(1):"-";
              const fs=t.fldTaken+t.fldMissed>0?Math.round(t.fldTaken/(t.fldTaken+t.fldMissed)*100)+"%":"-";
              return <tr key={i}>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.t}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{t.batMatches}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:t.batRuns>50?CG:"#1a1a1a"}}>{t.batRuns}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:typeof sr==="number"?(sr>=100?CG:sr<60?CR:CA):"#9ca3af"}}>{sr}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:typeof dp==="number"?(dp<35?CG:dp<=50?CA:CR):"#9ca3af"}}>{typeof dp==="number"?dp+"%":dp}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{t.bowlMatches}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{t.bowlOvers}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:t.bowlWkts>3?CG:"#1a1a1a"}}>{t.bowlWkts}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:er==="-"?"#9ca3af":parseFloat(er)<=5?CG:parseFloat(er)<=8?CA:CR}}>{er}</td>
                <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:fs==="-"?"#9ca3af":parseInt(fs)>=80?CG:parseInt(fs)>=60?CA:CR}}>{fs}</td>
              </tr>;
            })}
          </tbody>
        </table>
      </div>
    </div>
  </div>;
}

function SeasonAnalytics({user,matches,orgPlan,apiFetch}){
  const [selectedPlayer,setSelectedPlayer]=useState("ALL");
  const [exporting,setExporting]=useState(false);
  const [exportingSeason,setExportingSeason]=useState(false);
  const isPro=!["TRIAL","trial","SUSPENDED","suspended"].includes(orgPlan);
  const [season,setSeason]=useState("");
  const [loading,setLoading]=useState(false);
  const [stats,setStats]=useState(null);
  const tournaments=[...new Set(matches.filter(m=>m.tournament).map(m=>m.tournament))];
  // Player career view state
  const [analyticsTab,setAnalyticsTab]=useState("season"); // "season" | "career"
  const [careerCode,setCareerCode]=useState("");
  const [careerLoading,setCareerLoading]=useState(false);
  const [careerData,setCareerData]=useState(null);
  const [careerErr,setCareerErr]=useState("");

  async function loadSeasonStats(){
    if(!season) return;
    setLoading(true);
    const seasonMatches=season==="ALL"
      ? [...matches].sort((a,b)=>a.date<b.date?-1:1)
      : matches.filter(m=>m.tournament===season).sort((a,b)=>a.date<b.date?-1:1);
    const playerStats={};
    // nameToId: maps normalised player name → canonical first-seen id
    // so same person with different IDs across matches merges into one record
    const nameToId={};
    await Promise.all(seasonMatches.map(async m=>{
      const [log,ts]=await Promise.all([
        apiFetch(`/crickithub/matches/${m.matchId}/log`),
        apiFetch(`/crickithub/matches/${m.matchId}/teamsheet`),
      ]);
      if(!log||!ts) return;
      (ts.players||[]).forEach(p=>{
        const normName=(p.name||"").toLowerCase().trim();
        // Use canonical ID if this name was seen before under a different ID
        const canonId=nameToId[normName]||p.id;
        if(!nameToId[normName]) nameToId[normName]=p.id;
        if(!playerStats[canonId]) playerStats[canonId]={id:canonId,name:p.name,role:p.role,cat:p.cat,matches:[]};
        // If this match's player ID differs from canonical, still look up their log data
        const logId=p.id;
        playerStats[canonId].matches.push({
          matchId:m.matchId,date:m.date,opponent:m.opponent,
          tournament:m.tournament||"Unknown",
          batting:log.batting?.[logId]||null,
          bowling:log.bowling?.[logId]||null,
          fielding:log.fielding?.[logId]||null,
        });
      });
    }));
    setStats(playerStats);
    setLoading(false);
  }

  async function loadCareer(){
    const c=careerCode.toUpperCase().trim();
    if(!c){setCareerErr("Enter a player code.");return;}
    setCareerLoading(true);setCareerErr("");setCareerData(null);
    const r=await apiFetch(`/crickithub/player/career?code=${c}`);
    setCareerLoading(false);
    if(!r){setCareerErr("Failed to load career data.");return;}
    if(!r.matches||r.matches.length===0){setCareerErr(`No match data found for code ${c}.`);return;}
    setCareerData(r);
  }

  if(!isPro) return(
    <div>
      <SectionHdr title="Season Analytics" sub="Aggregated player performance across all matches in a tournament."/>
      <div style={{...cs.card,background:"#1A7A4A",color:"#fff",textAlign:"center",padding:"32px 24px"}}>
        <div style={{fontSize:18,fontWeight:700,marginBottom:8}}>Season Analytics — Pro Feature</div>
        <div style={{fontSize:13,opacity:.9,marginBottom:20,lineHeight:1.6}}>Unlock aggregated match-by-match stats, trend charts, and season PDF reports. Available on Paid and Discounted plans.</div>
        {["Batting trends, dot ball%, quota utilisation","Bowling economy, length control, wicket rates","Fielding contribution with positive/negative charts","Season PDF for players, parents & selectors"].map(f=><div key={f} style={{background:"rgba(255,255,255,0.15)",borderRadius:20,padding:"4px 14px",fontSize:12,marginBottom:6}}>{f}</div>)}
        <div style={{fontSize:12,opacity:.7,marginTop:12}}>Contact your CrickitMatch administrator to upgrade.</div>
      </div>
    </div>
  );

  const statEntries=stats?Object.entries(stats).filter(([id])=>selectedPlayer==="ALL"||id===selectedPlayer):[];
  const allPlayers=stats?Object.values(stats):[];

  return(
    <div>
      <SectionHdr title="Season Analytics" sub="Per-player performance across matches, tournaments or full career."/>

      {/* Tab switcher */}
      <div style={{display:"flex",gap:6,marginBottom:12}}>
        {[["season","Season / Tournament"],["career","Player Career (cross-school)"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>{setAnalyticsTab(id);}} style={{padding:"6px 14px",borderRadius:20,border:`1.5px solid ${analyticsTab===id?"#185FA5":"rgba(0,0,0,0.12)"}`,background:analyticsTab===id?"#185FA5":"#fff",color:analyticsTab===id?"#fff":"#6b7280",fontSize:12,fontWeight:analyticsTab===id?700:400,cursor:"pointer",fontFamily:"inherit"}}>{lbl}</button>
        ))}
      </div>

      {/* ── PLAYER CAREER VIEW ── */}
      {analyticsTab==="career"&&<>
        <div style={cs.card}>
          <div style={{fontSize:13,fontWeight:700,color:"#185FA5",marginBottom:6}}>Player Career — Cross-school Stats</div>
          <div style={{fontSize:12,color:"#6b7280",marginBottom:10}}>Enter any player's access code to see their unified match stats across all schools and tournaments.</div>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            <input style={{...cs.input,flex:1,textTransform:"uppercase",fontFamily:"monospace",letterSpacing:"0.08em"}} value={careerCode} onChange={e=>{setCareerCode(e.target.value.toUpperCase());setCareerData(null);setCareerErr("");}} placeholder="CM-XXXXXX"/>
            <button style={{...cs.btnP,whiteSpace:"nowrap",opacity:careerLoading?.5:1}} disabled={careerLoading||!careerCode.trim()} onClick={loadCareer}>{careerLoading?"Loading…":"Load career"}</button>
          </div>
          {careerErr&&<div style={{fontSize:12,color:"#A32D2D",marginTop:6}}>{careerErr}</div>}
        </div>

        {careerData&&<>
          <div style={{...cs.card,background:"#eef4fb",borderColor:"#185FA5"}}>
            <div style={{fontSize:15,fontWeight:700,color:"#185FA5"}}>{careerData.name}</div>
            <div style={{fontSize:12,color:"#6b7280",marginTop:2}}>Code: <span style={{fontFamily:"monospace",fontWeight:700}}>{careerData.code}</span>{careerData.isAlias&&<span style={{marginLeft:6,background:"#f0faf4",color:"#1A7A4A",borderRadius:10,padding:"1px 8px",fontSize:11,fontWeight:600}}>Alias resolved</span>}</div>
            <div style={{fontSize:12,color:"#6b7280",marginTop:2}}>{careerData.matches.length} match{careerData.matches.length!==1?"es":""} across {[...new Set(careerData.matches.map(m=>m.orgName))].join(", ")}</div>
          </div>

          {/* Career batting summary */}
          {careerData.matches.some(m=>m.batting)&&<div style={cs.card}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:8}}>Batting career</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Date","vs","Tournament","School","Runs","Balls","4s","6s","Dots"].map(h=><th key={h} style={{textAlign:"left",padding:"4px 6px",color:"#6b7280",fontWeight:500,borderBottom:"1px solid rgba(0,0,0,0.08)",fontSize:11}}>{h}</th>)}</tr></thead>
              <tbody>{careerData.matches.filter(m=>m.batting).map((m,i)=>{
                const b=m.batting;
                return <tr key={i} style={{background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.date}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.opponent||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.tournament||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.orgName}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:"#1A7A4A"}}>{b.runs??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.balls??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.fours??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.sixes??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.dots??"-"}</td>
                </tr>;
              })}</tbody>
            </table>
          </div>}

          {/* Career bowling summary */}
          {careerData.matches.some(m=>m.bowling)&&<div style={cs.card}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:8}}>Bowling career</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Date","vs","Tournament","School","Overs","Runs","Wkts","Wides","No balls"].map(h=><th key={h} style={{textAlign:"left",padding:"4px 6px",color:"#6b7280",fontWeight:500,borderBottom:"1px solid rgba(0,0,0,0.08)",fontSize:11}}>{h}</th>)}</tr></thead>
              <tbody>{careerData.matches.filter(m=>m.bowling).map((m,i)=>{
                const b=m.bowling;
                return <tr key={i} style={{background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.date}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.opponent||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.tournament||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.orgName}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.overs??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.runs??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:"#1A7A4A"}}>{b.wickets??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.wides??"-"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{b.noBalls??"-"}</td>
                </tr>;
              })}</tbody>
            </table>
          </div>}

          {/* Career fielding summary */}
          {careerData.matches.some(m=>m.fielding)&&<div style={cs.card}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:8}}>Fielding career</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Date","vs","Tournament","School","C","RO","St","SP","Net"].map(h=><th key={h} style={{textAlign:"left",padding:"4px 6px",color:"#6b7280",fontWeight:500,borderBottom:"1px solid rgba(0,0,0,0.08)",fontSize:11}}>{h}</th>)}</tr></thead>
              <tbody>{careerData.matches.filter(m=>m.fielding).map((m,i)=>{
                const f=m.fielding;
                const pos=(f.catches||0)+(f.runOuts||0)+(f.stumpings||0)+(f.sportsmanship||0);
                const neg=(f.missedCatches||0)+(f.missedRunOuts||0)+(f.missedStumpings||0);
                const net=pos-neg;
                return <tr key={i} style={{background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.date}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{m.opponent||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.tournament||"—"}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{m.orgName}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{f.catches||0}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{f.runOuts||0}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{f.stumpings||0}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{f.sportsmanship||0}</td>
                  <td style={{padding:"4px 6px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:net>=0?"#1A7A4A":"#A32D2D"}}>{net>0?"+":""}{net}</td>
                </tr>;
              })}</tbody>
            </table>
          </div>}
        </>}
      </>}

      {/* ── SEASON / TOURNAMENT VIEW ── */}
      {analyticsTab==="season"&&<>
        {/* Controls */}
        <div style={{...cs.card,display:"flex",flexWrap:"wrap",gap:10,alignItems:"flex-end"}}>
          <div style={{flex:1,minWidth:160}}>
          <label style={cs.label}>Tournament</label>
          <select style={cs.select} value={season} onChange={e=>{setSeason(e.target.value);setStats(null);}}>
            <option value="">— choose —</option>
            <option value="ALL">All tournaments (career view)</option>
            {tournaments.map(t=><option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <button style={{...cs.btnP,opacity:(!season||loading)?.5:1}} onClick={loadSeasonStats} disabled={!season||loading}>{loading?"Loading…":"Load stats"}</button>
        {stats&&<button style={{...cs.btnS,opacity:exportingSeason?.5:1,cursor:exportingSeason?"wait":"pointer"}} disabled={exportingSeason} onClick={()=>exportSeasonPDF(stats,selectedPlayer,season,matches,statEntries,setExportingSeason)}>{exportingSeason?"Generating…":"Save PDF"}</button>}
        {stats&&selectedPlayer!=="ALL"&&stats[selectedPlayer]&&<button style={{...cs.btnP,opacity:exporting?.5:1,cursor:exporting?"wait":"pointer"}} disabled={exporting} onClick={()=>exportPlayerPDF(stats[selectedPlayer],season,season==="ALL",setExporting)}>{exporting?"Generating PDF…":"⬇ Save Player PDF"}</button>}
      </div>

      {stats&&<>
        {/* Player filter */}
        <div style={{...cs.card}}>
          <label style={cs.label}>View player</label>
          <select style={cs.select} value={selectedPlayer} onChange={e=>setSelectedPlayer(e.target.value)}>
            <option value="ALL">All players — summary tables</option>
            {Object.entries(stats).map(([id,p])=><option key={id} value={id}>{p.name} ({ROLES[p.role]?.label||p.role})</option>)}
          </select>
        </div>

        {/* Summary cards — always shown */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(90px,1fr))",gap:8,marginBottom:12}}>
          {[
            ["Matches",season==="ALL"?matches.length:matches.filter(m=>m.tournament===season).length,null,null],
            ["Team runs",allPlayers.flatMap(p=>p.matches.map(m=>m.batting?.runs||0)).reduce((a,b)=>a+b,0),null,null],
            ["Total wkts",allPlayers.flatMap(p=>p.matches.map(m=>m.bowling?.wickets||0)).reduce((a,b)=>a+b,0),null,null],
          ].map(([l,v])=><MetricCard key={l} label={l} value={v}/>)}
        </div>

        {/* ALL players — aggregate tables */}
        {selectedPlayer==="ALL"&&<>
          <SecHdr title="Batting — season aggregates"/>
          <div style={{...cs.card,overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Player","Role","M","Balls","Runs","Avg SR","Dot%","Quota","Out","Retired"].map(h=><th key={h} style={{textAlign:"left",padding:"6px 8px",fontSize:11,fontWeight:700,color:"#1a1a1a",background:"#f0f4f2",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
              <tbody>{Object.values(stats).filter(p=>p.matches.some(m=>m.batting)).sort((a,b)=>{const ra=a.matches.reduce((s,m)=>s+(m.batting?.runs||0),0),rb=b.matches.reduce((s,m)=>s+(m.batting?.runs||0),0);return rb-ra;}).map(p=>{
                const bm=p.matches.filter(m=>m.batting);
                const tb=bm.reduce((a,m)=>a+(m.batting?.balls||0),0),tr=bm.reduce((a,m)=>a+(m.batting?.runs||0),0),td=bm.reduce((a,m)=>a+(m.batting?.dots||0),0);
                const asr=tb>0?Math.round(tr/tb*100):0,dp=tb>0?Math.round(td/tb*100):0;
                const qm=bm.filter(m=>["met","retired"].includes(m.batting?.status)).length;
                const out=bm.filter(m=>m.batting?.status==="out").length,ret=bm.filter(m=>m.batting?.status==="retired").length;
                return <tr key={p.id}>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700}}>{p.name}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{ROLES[p.role]?.label||p.role}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{bm.length}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{tb}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:tr>50?CG:"#1a1a1a"}}>{tr}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:asr>100?CG:asr<50?CR:"#1a1a1a"}}>{asr}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:dp>50?CR:dp<35?CG:CA}}>{dp}%</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{qm}/{bm.length}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:out>2?CR:"#1a1a1a"}}>{out}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:ret>0?CG:"#9ca3af"}}>{ret}</td>
                </tr>;
              })}</tbody>
            </table>
          </div>

          <SecHdr title="Bowling — season aggregates"/>
          <div style={{...cs.card,overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Player","Role","M","Overs","Runs","Wkts","Avg ER","Wkt SR","GD%","Loss%","Wd","Nb"].map(h=><th key={h} style={{textAlign:"left",padding:"6px 8px",fontSize:11,fontWeight:700,color:"#1a1a1a",background:"#f0f4f2",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
              <tbody>{Object.values(stats).filter(p=>p.matches.some(m=>m.bowling&&m.bowling.overs>0)).sort((a,b)=>{const wa=a.matches.reduce((s,m)=>s+(m.bowling?.wickets||0),0),wb=b.matches.reduce((s,m)=>s+(m.bowling?.wickets||0),0),ra=a.matches.reduce((s,m)=>s+(m.bowling?.runs||0),0),rb=b.matches.reduce((s,m)=>s+(m.bowling?.runs||0),0);return wb-wa||ra-rb;}).map(p=>{
                const bm=p.matches.filter(m=>m.bowling&&m.bowling.overs>0);
                const to=bm.reduce((a,m)=>a+(m.bowling?.overs||0),0),tr=bm.reduce((a,m)=>a+(m.bowling?.runs||0),0),tw=bm.reduce((a,m)=>a+(m.bowling?.wickets||0),0);
                const twd=bm.reduce((a,m)=>a+(m.bowling?.wides||0),0),tnb=bm.reduce((a,m)=>a+(m.bowling?.noBalls||0),0);
                const tgd=bm.reduce((a,m)=>a+(m.bowling?.good||0),0),tft=bm.reduce((a,m)=>a+(m.bowling?.fullToss||0),0),tsh=bm.reduce((a,m)=>a+(m.bowling?.short||0),0);
                const tbl=to*6+twd+tnb,ae=to>0?(tr/to).toFixed(1):"-",wsr=tw>0?Math.round(to*6/tw):"-";
                const gdp=tbl>0?Math.round(tgd/tbl*100):0,lossp=tbl>0?Math.round((tft+tsh)/tbl*100):0;
                return <tr key={p.id}>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700}}>{p.name}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:"#6b7280"}}>{ROLES[p.role]?.label||p.role}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{bm.length}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{to}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{tr}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:tw>5?CG:"#1a1a1a"}}>{tw}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:parseFloat(ae)>8?CR:parseFloat(ae)<5?CG:CA}}>{ae}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}>{wsr}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:gdp>60?CG:gdp<40?CR:CA}}>{gdp}%</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:lossp>25?CR:CG}}>{lossp}%</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:twd>5?CR:"#1a1a1a"}}>{twd}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:tnb>3?CR:"#1a1a1a"}}>{tnb}</td>
                </tr>;
              })}</tbody>
            </table>
          </div>

          <SecHdr title="Fielding — season totals"/>
          <div style={{...cs.card,overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead><tr>{["Player","C","MC","RO","MRO","ST","MST","SP","Net","Success%"].map(h=><th key={h} style={{textAlign:"left",padding:"6px 8px",fontSize:11,fontWeight:700,color:"#1a1a1a",background:"#f0f4f2",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
              <tbody>{Object.values(stats).map(p=>{
                const fm=p.matches.filter(m=>m.fielding);if(!fm.length)return null;
                const s=k=>fm.reduce((a,m)=>a+(m.fielding?.[k]||0),0);
                const tc=s("catches"),mc=s("missedCatch"),ro=s("runouts"),mro=s("missedRunout"),st=s("stumpings"),mst=s("missedStumping"),sp=s("sports");
                const tot=tc+ro+st,miss=mc+mro+mst,net=tot-miss,pct=tot+miss>0?Math.round(tot/(tot+miss)*100):0;
                return{id:p.id,name:p.name,tc,mc,ro,mro,st,mst,sp,net,pct};
              }).filter(Boolean).sort((a,b)=>b.net-a.net||b.tc-a.tc).map(r=><tr key={r.id}>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700}}>{r.name}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CG}}>{r.tc}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CR}}>{r.mc}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CB}}>{r.ro}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CR}}>{r.mro}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CP}}>{r.st}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CR}}>{r.mst}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",color:CA}}>{r.sp}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontWeight:700,color:r.net>=0?CG:CR}}>{(r.net>=0?"+":"")+r.net}</td>
                  <td style={{padding:"6px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)"}}><span style={{background:r.pct>=80?"#e6f4ec":r.pct>=60?"#faeeda":"#fcebeb",color:r.pct>=80?"#0F6E56":r.pct>=60?"#854F0B":"#A32D2D",borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700}}>{r.pct}%</span></td>
                </tr>)}</tbody>
            </table>
          </div>
        </>}

        {/* Single player — full charts */}
        {selectedPlayer!=="ALL"&&stats[selectedPlayer]&&<>
          {/* Tournament comparison — only shown when All tournaments loaded */}
          {season==="ALL"&&<>
            <SecHdr title={`Tournament comparison — ${stats[selectedPlayer].name}`}/>
            <TournamentComparison pid={selectedPlayer} pdata={stats[selectedPlayer]} tournaments={tournaments}/>
          </>}
          <SecHdr title={`Batting — ${stats[selectedPlayer].name}`}/>
          <BattingCharts pid={selectedPlayer} pdata={stats[selectedPlayer]} matches={matches} careerView={season==="ALL"}/>
          <SecHdr title={`Bowling — ${stats[selectedPlayer].name}`}/>
          <BowlingCharts pid={selectedPlayer} pdata={stats[selectedPlayer]} careerView={season==="ALL"}/>
          <SecHdr title={`Fielding — ${stats[selectedPlayer].name}`}/>
          <FieldingCharts pid={selectedPlayer} pdata={stats[selectedPlayer]} careerView={season==="ALL"}/>
        </>}
      </>}
      </>}
    </div>
  );
}
// ═══════════════════════════════════════════════════════════════════════════════
function BattingTracker({user,teamSheet,batting,setBatting,onSave,saveMsg,matchFrozen,hubRules,matchType,activeBatter,setActiveBatter}){
  const isOpen=(matchType||"hub")==="open";
  const [alert,setAlert]=useState({msg:"",type:"red"});
  const canEdit=user.role==="COACH"&&!matchFrozen;
  // activeBatter and setActiveBatter come from app-level props — persist across tab switches
  const [editPip,setEditPip]=useState(null);
  const [lastBall,setLastBall]=useState(null); // {id, idx} — for post-ball quality tagging
  const [tagQuality,setTagQuality]=useState(null); // "GD"|"FT"|"SH"|"OP" — pending quality tag
  const [tagTimer,setTagTimer]=useState(null); // auto-dismiss timer

  // Ball entries can be strings (legacy: ".", "1", "W") or objects {v, q, dt}
  // v = outcome string, q = ball quality, dt = dot type
  function pipVal(b){ return typeof b==="object"?b.v:b; }
  function pipQ(b){ return typeof b==="object"?b.q:null; }
  function pipDt(b){ return typeof b==="object"?b.dt:null; }

  function dismissTag(){ setLastBall(null);setTagQuality(null);if(tagTimer){clearTimeout(tagTimer);setTagTimer(null);} }

  function applyQuality(id,idx,q){
    // Set quality on a ball entry, or update it
    setTagQuality(q);
    const p=getP(id);
    const entry=p.ballLog[idx];
    const v=pipVal(entry);
    const dt=v==="."?pipDt(entry):null; // keep dotType if dot, clear if not
    const newEntry=q?{v,q,...(dt&&{dt})}:{v}; // if quality cleared, simplify back
    const newLog=[...p.ballLog];
    newLog[idx]=newEntry;
    upd(id,{ballLog:newLog});
  }

  function applyDotType(id,idx,dt){
    const p=getP(id);
    const entry=p.ballLog[idx];
    const v=pipVal(entry);
    const q=pipQ(entry);
    if(!q) return; // only apply if quality is set
    const newEntry={v,q,dt};
    const newLog=[...p.ballLog];
    newLog[idx]=newEntry;
    upd(id,{ballLog:newLog});
  }

  if(!teamSheet.length)return(<div><SectionHdr title="Batting tracker"/><div style={cs.muted}>Confirm the team sheet first.</div></div>);
  function getQ(role,cat){if(isOpen)return[0,9999];if(hubRules){const rr=hubRules[role];if(rr){const c=(cat||"").toLowerCase();return[rr[c+"Min"]||rr.min||0,rr[c+"Max"]||rr.max||30];}}return ROLES[role]?.[( cat||"u13").toLowerCase()]||[20,30];}
  function getP(id){return batting[id]||{...teamSheet.find(t=>t.id===id),balls:0,runs:0,dots:0,status:"pending",ballLog:[]};}
  function upd(id,patch){setBatting(b=>({...b,[id]:{...getP(id),...patch}}));}
  function rebuildStats(log,role,cat){
    let balls=0,r=0,dots=0,status="pending";
    const q=getQ(role,cat);
    for(const b of log){
      const v=pipVal(b);
      balls++;
      if(v==="W"){status="out";}
      else{const rv=v==="."?0:parseInt(v)||0;r+=rv;if(rv===0)dots++;}
      if(status!=="out"){if(balls>=q[1])status="retired";else if(balls>=q[0])status="met";}
    }
    return{balls,runs:r,dots,status};
  }
  function correctPip(id,idx,newVal){
    const p=getP(id);
    const newLog=[...p.ballLog];
    if(newVal===null){newLog.splice(idx,1);}
    else{
      // Preserve quality/dotType if outcome is compatible
      const old=newLog[idx];
      const oldQ=pipQ(old);
      const isDot=newVal===".";
      newLog[idx]=oldQ?{v:newVal,q:oldQ,...(isDot&&pipDt(old)?{dt:pipDt(old)}:{})}:newVal;
    }
    upd(id,{...rebuildStats(newLog,p.role,p.cat),ballLog:newLog});
    setEditPip(null);
  }
  function ball(id,runs,pip){
    const p=getP(id);if(p.status!=="pending"&&p.status!=="met")return;
    setActiveBatter(id);
    dismissTag();
    const q=getQ(p.role,p.cat);
    let {balls,runs:r,dots,status,ballLog}=p;
    if(runs==="W"){balls++;status="out";ballLog=[...ballLog,"W"];}
    else{balls++;r+=runs;ballLog=[...ballLog,pip];if(runs===0)dots++;}
    if(status!=="out"){
      if(balls>=q[1]){status="retired";setActiveBatter("");setAlert({msg:`${p.name} reached ${q[1]} balls — auto-retired.`,type:"red"});}
      else if(balls>=q[0]&&status==="pending"){status="met";setAlert({msg:`${p.name} reached ${q[0]} balls — quota met.`,type:"green"});}
    }
    if(status==="out"||status==="retired") setActiveBatter("");
    upd(id,{balls,runs:r,dots,status,ballLog});
    // Show quality tag strip for 10 seconds
    const newIdx=ballLog.length-1; // index of ball just added (last element)
    setLastBall({id,idx:newIdx});
    setTagQuality(null);
    const t=setTimeout(()=>dismissTag(),10000);
    setTagTimer(t);
  }
  const players=teamSheet.map(p=>getP(p.id));
  const tb=players.reduce((a,p)=>a+p.balls,0),tr=players.reduce((a,p)=>a+p.runs,0),met=players.filter(p=>["met","retired","ret-early"].includes(p.status)).length;
  return(
    <div>
      <SectionHdr title="Batting tracker" sub={isOpen?"Open match — no quotas. Track freely until out or retired.":"Green = quota met (20 balls). Red = auto-retired (30 balls)"}/>{onSave&&<div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><button style={cs.btnP} onClick={onSave}>Save match data</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>}
      <div style={{display:"grid",gridTemplateColumns:`repeat(${isOpen?3:4},1fr)`,gap:8,marginBottom:14}}>
        <div style={cs.card}>
          <div style={cs.muted}>Balls · Overs</div>
          <div style={{display:"flex",alignItems:"baseline",gap:8,marginTop:3}}>
            <span style={{fontSize:20,fontWeight:500}}>{tb}</span>
            <span style={{fontSize:16,fontWeight:500,color:G}}>{Math.floor(tb/6)}.{tb%6}</span>
          </div>
        </div>
        {!isOpen&&<div style={cs.card}><div style={cs.muted}>Quotas met</div><div style={{fontSize:20,fontWeight:500,marginTop:3}}>{met}/{players.length}</div></div>}
        {isOpen&&<div style={cs.card}><div style={cs.muted}>Team SR</div><div style={{fontSize:20,fontWeight:500,marginTop:3}}>{tb>0?Math.round(tr/tb*100):0}</div></div>}
        <div style={cs.card}><div style={cs.muted}>Runs</div><div style={{fontSize:20,fontWeight:500,color:G,marginTop:3}}>{tr}</div></div>
        {!isOpen&&<div style={cs.card}><div style={cs.muted}>Team SR</div><div style={{fontSize:20,fontWeight:500,marginTop:3}}>{tb>0?Math.round(tr/tb*100):0}</div></div>}
      </div>
      <AlertBox type={alert.type} msg={alert.msg} onClose={()=>setAlert({msg:""})}/>
      {players.map(p=>{
        const q=getQ(p.role,p.cat);
        const pct=Math.min(p.balls/q[1]*100,100);
        const bc=p.balls>=q[1]?"red":p.balls>=q[0]?"green":"amber";
        const sr=p.balls>0?Math.round(p.runs/p.balls*100):0;
        const dp=p.balls>0?Math.round(p.dots/p.balls*100):0;
        const active=p.status==="pending"||p.status==="met";
        let sb=null;
        if(p.status==="out")       sb=<Badge color="red">Out</Badge>;
        if(p.status==="retired")   sb=isOpen?<Badge color="gray">Retired</Badge>:<Badge color="red">Retired (30)</Badge>;
        if(p.status==="ret-early") sb=<Badge color="amber">Retired early</Badge>;
        if(p.status==="met")       sb=isOpen?null:<Badge color="green">Quota met</Badge>;
        const pips=(p.ballLog||[]).map((b,i)=>{
          const v=pipVal(b);
          const q=pipQ(b);
          const dt=pipDt(b);
          let bg="#f1efe8",col="#1a1a1a",txt="•",fw=900,fs=13;
          if(v===".")  {bg="#f1efe8";col="#1a1a1a";txt="•";fw=900;fs=13;}
          if(v==="4")  {bg="#e6f4ec";col=G;txt="4";fw=800;fs=10;}
          if(v==="6")  {bg="#faeeda";col="#854F0B";txt="6";fw=800;fs=10;}
          if(v==="W")  {bg="#A32D2D";col="#fff";txt="W";fw=800;fs=10;}
          if(["1","2","3"].includes(v)){bg="#e6f1fb";col="#185FA5";txt=v;fw=800;fs=10;}
          if(v==="Wd") {bg="transparent";col="#854F0B";txt="Wd";fw=700;fs=9;}
          if(v==="Nb") {bg="transparent";col="#854F0B";txt="N";fw=700;fs=9;}
          const isEdit=editPip?.id===p.id&&editPip?.idx===i;
          const isLastTagged=lastBall?.id===p.id&&lastBall?.idx===i;
          const pipBg=isEdit?"#FFD700":isLastTagged?"#fff":bg;
          const pipCol=isEdit?"#1a1a1a":isLastTagged?"#1a1a1a":col;
          const pipFw=isLastTagged?900:fw;
          const pipFs=isLastTagged?13:fs;
          const pipOutline=isEdit?"2.5px solid #B8860B":isLastTagged?"2.5px solid #7C3AED":"none";
          // Quality label row
          const qClr=q==="GD"?G:q==="FT"?"#A32D2D":q==="SH"?"#185FA5":"#854F0B";
          const qLbl=q?<div style={{fontSize:7,fontWeight:700,color:qClr,textAlign:"center",height:9,lineHeight:"9px",width:22}}>{q}</div>:<div style={{height:9,width:22}}/>;
          // Dot type label row
          const dtClr=dt==="beat"?"#A32D2D":dt==="fielded"?G:"#854F0B";
          const dtTxt=dt==="beat"?"●":dt==="fielded"?"◆":dt==="defended"?"▪":null;
          const dtLbl=dtTxt?<div style={{fontSize:7,fontWeight:700,color:dtClr,textAlign:"center",height:9,lineHeight:"9px",width:22}}>{dtTxt}</div>:<div style={{height:9,width:22}}/>;
          return <div key={i} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,minWidth:22,cursor:canEdit?"pointer":"default"}} onClick={canEdit?()=>{dismissTag();setEditPip(isEdit?null:{id:p.id,idx:i});}:undefined}>
            <div title="Tap to correct" style={{width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:pipFs,fontWeight:pipFw,background:pipBg,color:pipCol,border:pipOutline,flexShrink:0}}>{txt}</div>
            {qLbl}
            {dtLbl}
          </div>;
        });
        return(
          <div key={p.id} onClick={()=>setActiveBatter(v=>v===p.id?"":p.id)} style={{...cs.card,borderColor:activeBatter===p.id?"#7C3AED":(!isOpen&&(p.balls>=q[1]?"#E24B4A":p.balls>=q[0]?G:"rgba(0,0,0,0.10)")),borderWidth:activeBatter===p.id?3.5:(!isOpen&&(p.balls>=q[1]||p.balls>=q[0]))?2:.5,boxShadow:"none",background:"#fff",cursor:"pointer"}}>
            <div style={{...cs.rowWrap,marginBottom:8}}>
              <span style={{flex:1,fontSize:13,fontWeight:500}}>{p.name}</span>{sb}
              <span style={cs.muted}>{ROLES[p.role]?.label}{!isOpen&&` · quota ${q[0]}–${q[1]}`}</span>
              <span style={cs.muted}>{p.runs}r · SR {sr} · Dots {dp}%</span>
            </div>
            {!isOpen&&<div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <div style={{flex:1,height:7,background:"#f1efe8",borderRadius:4,overflow:"hidden"}}><div style={cs.qBar(pct,bc)}/></div>
              <span style={cs.muted}>{p.balls}/{q[1]} balls</span>
            </div>}
            {isOpen&&<div style={{fontSize:11,color:"#9ca3af",marginBottom:6}}>{p.balls} balls · {p.runs}r</div>}
            <div style={{display:"flex",gap:3,flexWrap:"nowrap",overflowX:"auto",marginBottom:4,paddingBottom:2}}>{pips}</div>
            {editPip?.id===p.id&&canEdit&&(()=>{
              const editEntry=p.ballLog[editPip.idx];
              const editV=pipVal(editEntry);
              const editQ=pipQ(editEntry);
              const editDt=pipDt(editEntry);
              const isDot=editV===".";
              return <div style={{background:"#FFF9E6",border:"1px solid #F0C040",borderRadius:8,padding:"8px 10px",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:700,color:"#7A5C00",marginBottom:6}}>Correct ball {editPip.idx+1}:</div>
                <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:8}}>
                  {[["dot",".","."],["1","1","1"],["2","2","2"],["3","3","3"],["4","4","4"],["6","6","6"],["W","W","W"],["Wd","Wd","Wd"],["Nb","Nb","Nb"]].map(([lbl,val,pip])=>(
                    <button key={lbl} onClick={()=>correctPip(p.id,editPip.idx,pip)} style={{minWidth:34,height:30,padding:"0 7px",border:`0.5px solid ${editV===pip?"#1A7A4A":"rgba(0,0,0,0.15)"}`,borderRadius:6,background:editV===pip?"#e6f4ec":"#fff",cursor:"pointer",fontSize:12,fontWeight:700,color:lbl==="W"?"#A32D2D":lbl==="4"?G:lbl==="6"?"#854F0B":"#185FA5",fontFamily:"inherit"}}>{lbl}</button>
                  ))}
                  <button onClick={()=>correctPip(p.id,editPip.idx,null)} style={{minWidth:46,height:30,padding:"0 9px",border:"1px solid #A32D2D",borderRadius:6,background:"#fcebeb",cursor:"pointer",fontSize:12,fontWeight:700,color:"#A32D2D",fontFamily:"inherit"}}>Delete</button>
                  <button onClick={()=>setEditPip(null)} style={{minWidth:46,height:30,padding:"0 9px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:12,color:"#6b7280",fontFamily:"inherit"}}>Cancel</button>
                </div>
                {/* Ball quality selector in correction panel */}
                <div style={{borderTop:"0.5px solid #F0C040",paddingTop:8,marginTop:4}}>
                  <div style={{fontSize:11,fontWeight:600,color:"#7A5C00",marginBottom:5}}>Ball quality (optional):</div>
                  <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                    {[["GD","Good length",G],["FT","Full toss","#A32D2D"],["SH","Short","#185FA5"],["OP","Overpitch","#854F0B"]].map(([q,lbl,c])=>(
                      <button key={q} onClick={()=>{const entry=p.ballLog[editPip.idx];const v=pipVal(entry);const dt=pipDt(entry);const newEntry=editQ===q?{v}:{v,q,...(isDot&&dt?{dt}:{})};const newLog=[...p.ballLog];newLog[editPip.idx]=newEntry;upd(p.id,{ballLog:newLog});}} style={{padding:"3px 10px",border:`1.5px solid ${editQ===q?c:"rgba(0,0,0,0.15)"}`,borderRadius:6,background:editQ===q?c+"22":"#fff",color:editQ===q?c:"#6b7280",fontSize:11,fontWeight:editQ===q?700:400,cursor:"pointer",fontFamily:"inherit"}}>{q} <span style={{opacity:.7}}>{lbl}</span></button>
                    ))}
                    {editQ&&<button onClick={()=>{const v=pipVal(p.ballLog[editPip.idx]);const newLog=[...p.ballLog];newLog[editPip.idx]=v;upd(p.id,{ballLog:newLog});}} style={{padding:"3px 10px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",color:"#6b7280",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>Clear</button>}
                  </div>
                </div>
                {/* Dot type selector — only when dot + quality set */}
                {isDot&&editQ&&<div style={{borderTop:"0.5px solid #F0C040",paddingTop:8,marginTop:6}}>
                  <div style={{fontSize:11,fontWeight:600,color:"#7A5C00",marginBottom:5}}>Dot type (optional):</div>
                  <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                    {[["beat","Beaten","#A32D2D","●"],["defended","Defended","#854F0B","▪"],["fielded","Fielded","#1A7A4A","◆"]].map(([dt,lbl,c,ico])=>(
                      <button key={dt} onClick={()=>applyDotType(p.id,editPip.idx,editDt===dt?null:dt)} style={{padding:"3px 10px",border:`1.5px solid ${editDt===dt?c:"rgba(0,0,0,0.15)"}`,borderRadius:6,background:editDt===dt?c+"22":"#fff",color:editDt===dt?c:"#6b7280",fontSize:11,fontWeight:editDt===dt?700:400,cursor:"pointer",fontFamily:"inherit"}}>{ico} {lbl}</button>
                    ))}
                  </div>
                </div>}
              </div>;
            })()}
            {/* Post-ball quality tag strip — appears for 10s after recording */}
            {lastBall?.id===p.id&&canEdit&&active&&<div style={{background:"#f5eeff",border:"1px solid #9B59C4",borderRadius:8,padding:"8px 10px",marginTop:4,marginBottom:6}}>
              <div style={{fontSize:10,fontWeight:700,color:"#6B21A8",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.06em"}}>🏷 Tag ball quality (optional)</div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:6}}>
                {[["GD","Good length",G],["FT","Full toss","#A32D2D"],["SH","Short","#185FA5"],["OP","Overpitch","#854F0B"]].map(([q,lbl,c])=>(
                  <button key={q} onClick={()=>applyQuality(p.id,lastBall.idx,tagQuality===q?null:q)} style={{padding:"4px 10px",border:`1.5px solid ${tagQuality===q?c:"rgba(0,0,0,0.20)"}`,borderRadius:6,background:tagQuality===q?c+"22":"#fff",color:tagQuality===q?c:"#4a4a4a",fontSize:11,fontWeight:tagQuality===q?700:500,cursor:"pointer",fontFamily:"inherit"}}>{q} <span style={{opacity:.75}}>{lbl}</span></button>
                ))}
                <button onClick={dismissTag} style={{padding:"4px 10px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:6,background:"rgba(255,255,255,0.7)",color:"#6b7280",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>Skip</button>
              </div>
              {/* Dot type — only if quality tagged and ball was a dot */}
              {tagQuality&&pipVal(getP(p.id).ballLog[lastBall.idx])==="."&&<div>
                <div style={{fontSize:10,fontWeight:700,color:"#6B21A8",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.06em"}}>Dot type (optional)</div>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                  {[["beat","Beaten","#A32D2D","●"],["defended","Defended","#854F0B","▪"],["fielded","Fielded","#1A7A4A","◆"]].map(([dt,lbl,c,ico])=>{
                    const liveDt=pipDt(getP(p.id).ballLog[lastBall.idx]);
                    return <button key={dt} onClick={()=>applyDotType(p.id,lastBall.idx,liveDt===dt?null:dt)} style={{padding:"4px 10px",border:`1.5px solid ${liveDt===dt?c:"rgba(0,0,0,0.15)"}`,borderRadius:6,background:liveDt===dt?c+"22":"#fff",color:liveDt===dt?c:"#4a4a4a",fontSize:11,fontWeight:liveDt===dt?700:500,cursor:"pointer",fontFamily:"inherit"}}><span style={{fontWeight:700}}>{ico}</span> {lbl}</button>;
                  })}
                </div>
              </div>}
            </div>}
            {active&&canEdit&&<div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              {[["dot","0","."],["1","1","1"],["2","2","2"],["3","3","3"],["4","4","4"],["6","6","6"]].map(([l,r,pp])=>(
                <button key={l} onClick={()=>ball(p.id,parseInt(r)||0,pp)} style={{minWidth:34,height:30,padding:"0 7px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:12,fontWeight:500,color:l==="4"?G:l==="6"?"#854F0B":l==="dot"?"#6b7280":"#185FA5",fontFamily:"inherit"}}>{l}</button>
              ))}
              <button onClick={()=>ball(p.id,"W","W")} style={{minWidth:34,height:30,padding:"0 7px",border:"0.5px solid #F09595",borderRadius:6,background:"#fcebeb",cursor:"pointer",fontSize:12,fontWeight:600,color:"#A32D2D",fontFamily:"inherit"}}>W</button>
              <button onClick={()=>upd(p.id,{status:"ret-early"})} style={{minWidth:46,height:30,padding:"0 9px",border:"0.5px solid #FAC775",borderRadius:6,background:"#faeeda",cursor:"pointer",fontSize:12,color:"#854F0B",fontFamily:"inherit"}}>Retire</button>
            </div>}
          </div>
        );
      })}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// BOWLING TRACKER
// ═══════════════════════════════════════════════════════════════════════════════
function BowlingTracker({user,teamSheet,bowling,setBowling,onSave,saveMsg,matchFrozen,hubRules,matchType,activeBowler,setActiveBowler}){
  const isOpen=(matchType||"hub")==="open";
  // activeBowler and setActiveBowler come from app-level props — persist across tab switches
  const [pendLen,setPendLen]=useState({});
  const [lenErr,setLenErr]=useState({});
  const [alert,setAlert]=useState({msg:"",type:"red"});
  const [corrBowl,setCorrBowl]=useState(null); // {bowlerId,overIdx,ballIdx,isCurrent,outcome,length}
  const [corrLen,setCorrLen]=useState("");
  const canEdit=user.role==="COACH"&&!matchFrozen;
  const [editBowlPip,setEditBowlPip]=useState(null);
  if(!teamSheet.length)return(<div><SectionHdr title="Bowling tracker"/><div style={cs.muted}>Confirm the team sheet first.</div></div>);
  function setLen(id,len){setPendLen(pl=>({...pl,[id]:pl[id]===len?"":len}));setLenErr(le=>({...le,[id]:false}));}
  function getP(id){return bowling[id]||{...teamSheet.find(t=>t.id===id),overs:0,legalInOver:0,runs:0,wides:0,noBalls:0,fullToss:0,overpitch:0,short:0,good:0,wickets:0,spellRuns:0,spellOvers:0,overLog:[],currentOver:[]};}
  function updP(id,patch){setBowling(b=>({...b,[id]:{...getP(id),...patch}}));}
  function getBowlQ(role,cat){
    if(isOpen)return[0,9999];
    if(hubRules){
      const rr=hubRules[role];
      if(rr){
        const c=(cat||"u13").toLowerCase();
        const C=c.charAt(0).toUpperCase()+c.slice(1);
        const mn=rr["bowl"+C+"Min"]!==undefined?rr["bowl"+C+"Min"]:rr.bowlMin;
        const mx=rr["bowl"+C+"Max"]!==undefined?rr["bowl"+C+"Max"]:rr.bowlMax;
        if(mn!==undefined&&mx!==undefined)return[mn,mx];
      }
    }
    return BOWL_QUOTA[role]?.[(cat||"u13").toLowerCase()]||[0,3];
  }
  function saveBowlCorrection(bowlerId,overIdx,ballIdx,isCurrent,newOutcome,newLen){
    if(!newLen||!newOutcome)return;
    const p=getP(bowlerId);
    let newOverLog=p.overLog.map(ov=>[...ov]);
    let newCurrentOver=[...p.currentOver];
    if(isCurrent){
      newCurrentOver=newCurrentOver.map((b,i)=>i===ballIdx?{...b,outcome:newOutcome,length:newLen,legal:isLegal(newOutcome)}:b);
    } else {
      // Apply correction to the completed over
      newOverLog=newOverLog.map((ov,oi)=>oi===overIdx?ov.map((b,bi)=>bi===ballIdx?{...b,outcome:newOutcome,length:newLen,legal:isLegal(newOutcome)}:b):ov);
      // Auto-fix: completed over must have exactly 6 legal deliveries
      const correctedOver=newOverLog[overIdx];
      const legalCount=correctedOver.filter(b=>isLegal(b.outcome)).length;
      if(legalCount<6){
        // Changed legal→illegal: append dot ball placeholders to make up 6 legal
        const needed=6-legalCount;
        const extras=Array.from({length:needed},()=>({outcome:".",length:"GD",legal:true}));
        newOverLog[overIdx]=[...correctedOver,...extras];
      } else if(legalCount>6){
        // Changed illegal→legal: remove excess legal balls from the end
        let excess=legalCount-6;
        const fixed=[...correctedOver];
        for(let i=fixed.length-1;i>=0&&excess>0;i--){
          if(isLegal(fixed[i].outcome)){fixed.splice(i,1);excess--;}
        }
        newOverLog[overIdx]=fixed;
      }
    }
    // Recalculate all totals from scratch
    let runs=0,wides=0,noBalls=0,fullToss=0,overpitch=0,short=0,good=0,wickets=0;
    [...newOverLog.flat(),...newCurrentOver].forEach(b=>{
      if(b.outcome==="Wd"){wides++;runs++;}
      else if(b.outcome==="Nb"){noBalls++;runs++;}
      else{const r=parseInt(b.outcome)||0;runs+=r;if(b.outcome==="W")wickets++;}
      if(b.length==="FT")fullToss++;else if(b.length==="OP")overpitch++;else if(b.length==="SH")short++;else if(b.length==="GD")good++;
    });
    // Recalculate legalInOver correctly from corrected currentOver
    const legalInOver=newCurrentOver.filter(b=>b.legal!==undefined?b.legal:isLegal(b.outcome)).length;
    const overs=newOverLog.length;
    updP(bowlerId,{runs,wides,noBalls,fullToss,overpitch,short,good,wickets,overs,legalInOver,overLog:newOverLog,currentOver:newCurrentOver});
    setCorrBowl(null);setCorrLen("");
  }
  function deleteBowlBall(bowlerId,overIdx,ballIdx,isCurrent){
    const p=getP(bowlerId);
    let newOverLog=p.overLog.map(ov=>[...ov]);
    let newCurrentOver=[...p.currentOver];
    if(isCurrent){
      newCurrentOver=newCurrentOver.filter((_,i)=>i!==ballIdx);
    } else {
      // Remove the ball from the completed over
      newOverLog=newOverLog.map((ov,oi)=>oi===overIdx?ov.filter((_,bi)=>bi!==ballIdx):ov);
      // If the over now has fewer than 6 legal balls it is no longer a complete over —
      // move it back into currentOver (only if it was the last over, otherwise leave as-is
      // with a note that the over is now short — coach can re-record the missing ball)
      const editedOver=newOverLog[overIdx];
      const legalLeft=editedOver.filter(b=>isLegal(b.outcome)).length;
      if(legalLeft<6&&overIdx===newOverLog.length-1){
        // Promote last over back to currentOver so the remaining balls are live
        newCurrentOver=[...editedOver,...newCurrentOver];
        newOverLog=newOverLog.filter((_,oi)=>oi!==overIdx);
      }
    }
    // Recalculate all totals from scratch
    let runs=0,wides=0,noBalls=0,fullToss=0,overpitch=0,short=0,good=0,wickets=0;
    [...newOverLog.flat(),...newCurrentOver].forEach(b=>{
      if(b.outcome==="Wd"){wides++;runs++;}
      else if(b.outcome==="Nb"){noBalls++;runs++;}
      else{const r=parseInt(b.outcome)||0;runs+=r;if(b.outcome==="W")wickets++;}
      if(b.length==="FT")fullToss++;else if(b.length==="OP")overpitch++;else if(b.length==="SH")short++;else if(b.length==="GD")good++;
    });
    const legalInOver=newCurrentOver.filter(b=>b.legal!==undefined?b.legal:isLegal(b.outcome)).length;
    const overs=newOverLog.length;
    const spellRuns=runs; // recalc from total (spell tracking resets on over boundary anyway)
    const spellOvers=overs;
    updP(bowlerId,{runs,wides,noBalls,fullToss,overpitch,short,good,wickets,overs,legalInOver,overLog:newOverLog,currentOver:newCurrentOver,spellRuns,spellOvers});
    setCorrBowl(null);setCorrLen("");
  }
  function bowlBall(outcome){
    if(!activeBowler)return;
    const p=getP(activeBowler),q=getBowlQ(p.role,p.cat);
    if(!isOpen&&p.overs>=q[1]){setAlert({msg:`${p.name} has bowled max ${q[1]} overs.`,type:"red"});return;}
    const len=pendLen[activeBowler]||"";
    if(!len){setLenErr(le=>({...le,[activeBowler]:true}));return;}
    const legal=isLegal(outcome);
    let {overs,legalInOver,runs,wides,noBalls,fullToss,overpitch,short,good,wickets,spellRuns,spellOvers,overLog,currentOver}=p;
    currentOver=[...currentOver,{outcome,length:len,legal}];
    if(outcome==="Wd"){wides++;runs++;spellRuns++;}
    else if(outcome==="Nb"){noBalls++;runs++;spellRuns++;}
    else{const r=parseInt(outcome)||0;runs+=r;spellRuns+=r;if(outcome==="W")wickets++;}
    if(len==="FT")fullToss++;else if(len==="OP")overpitch++;else if(len==="SH")short++;else if(len==="GD")good++;
    if(legal)legalInOver++;
    setPendLen(pl=>({...pl,[activeBowler]:""}));setLenErr(le=>({...le,[activeBowler]:false}));
    if(legalInOver>=6){
      overs++;spellOvers++;overLog=[...overLog,currentOver];currentOver=[];legalInOver=0;
      setActiveBowler("");  // over complete — deselect so coach must tap next bowler
      if(!isOpen&&overs>=q[1])setAlert({msg:`${p.name} — MAX quota ${q[1]} overs reached.`,type:"red"});
      else if(!isOpen&&overs>=q[0])setAlert({msg:`${p.name} — minimum quota met (${overs} overs).`,type:"green"});
      if(spellOvers>=2&&spellRuns>=30)setAlert({msg:`SPELL ALERT: ${p.name} conceded ${spellRuns}R in ${spellOvers} overs — remove from attack.`,type:"red"});
    }
    updP(activeBowler,{overs,legalInOver,runs,wides,noBalls,fullToss,overpitch,short,good,wickets,spellRuns,spellOvers,overLog,currentOver});
  }
  function PipCell({outcome,length,onClick,isCorr}){
    let bg="#f1efe8",col="#888",border="1.5px solid transparent",txt="·",fs=9;
    if(outcome==="Wd"){bg="transparent";col="#854F0B";border="1.5px solid #EF9F27";txt="Wd";fs=7;}
    else if(outcome==="Nb"){bg="transparent";col="#854F0B";border="1.5px solid #EF9F27";txt="N";}
    else if(outcome==="W"){bg="#A32D2D";col="#fff";txt="W";}
    else if(outcome==="4"){bg="#e6f4ec";col=G;txt="4";}
    else if(outcome==="6"){bg="#faeeda";col="#854F0B";txt="6";}
    else if(parseInt(outcome)>0){bg="#e6f1fb";col="#185FA5";txt=outcome;}
    const lc=length==="GD"?G:length==="FT"?"#A32D2D":length==="OP"?"#854F0B":"#185FA5";
    if(isCorr)border="2px solid #185FA5";
    return(<div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,cursor:onClick?"pointer":"default"}} onClick={onClick}>
      <div style={{width:24,height:24,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:fs+1,fontWeight:800,background:bg,color:col,border}}>{txt}</div>
      {length&&<span style={{fontSize:8,fontWeight:600,color:lc,lineHeight:1}}>{length}</span>}
    </div>);
  }
  // Sort teamSheet by bowling role order
  const BOWL_SORT={"BOWLING":0,"BOWLING_AR":1,"BATTING_AR":2,"BATTING":3,"WK":4};
  const sortedSheet=[...teamSheet].sort((a,b)=>(BOWL_SORT[a.role]??5)-(BOWL_SORT[b.role]??5));

  return(
    <div>
      <SectionHdr title="Bowling tracker" sub="Tap a bowler name to select. Then choose length and log each ball. Over auto-completes at 6 legal deliveries."/>{onSave&&<div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><button style={cs.btnP} onClick={onSave}>Save match data</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>}
      {(()=>{
        const allP=sortedSheet.map(p=>getP(p.id));
        const totalLegalBalls=allP.reduce((a,p)=>a+(p.overs||0)*6+(p.legalInOver||0),0);
        const totalRuns=allP.reduce((a,p)=>a+(p.runs||0),0);
        const totalWkts=allP.reduce((a,p)=>a+(p.wickets||0),0);
        const totalOvers=allP.reduce((a,p)=>a+(p.overs||0),0);
        const ovStr=`${Math.floor(totalLegalBalls/6)}.${totalLegalBalls%6}`;
        const teamER=totalOvers>0?(totalRuns/totalOvers).toFixed(1):"-";
        const erClr=parseFloat(teamER)<5?G:parseFloat(teamER)<8?"#EF9F27":"#E24B4A";
        return(<div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14,background:"#f4f6f4",padding:8,borderRadius:8}}>
          <div style={cs.card}>
            <div style={cs.muted}>Overs · Balls</div>
            <div style={{display:"flex",alignItems:"baseline",gap:8,marginTop:3}}>
              <span style={{fontSize:20,fontWeight:500,color:"#185FA5"}}>{ovStr}</span>
              <span style={{fontSize:14,fontWeight:400,color:"#6b7280"}}>{totalLegalBalls}</span>
            </div>
          </div>
          <div style={cs.card}><div style={cs.muted}>Runs conceded</div><div style={{fontSize:20,fontWeight:500,color:"#185FA5",marginTop:3}}>{totalRuns}</div></div>
          <div style={cs.card}><div style={cs.muted}>Wickets</div><div style={{fontSize:20,fontWeight:500,color:G,marginTop:3}}>{totalWkts}</div></div>
          <div style={cs.card}><div style={cs.muted}>Team ER</div><div style={{fontSize:20,fontWeight:500,color:erClr,marginTop:3}}>{teamER}</div></div>
        </div>);
      })()}
      <AlertBox type={alert.type} msg={alert.msg} onClose={()=>setAlert({msg:""})}/>
      {canEdit&&<div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
        {sortedSheet.map(p=>{
          const isAct=activeBowler===p.id;
          const q=getBowlQ(p.role,p.cat);
          const bp=getP(p.id);
          const qDone=!isOpen&&bp.overs>=q[1];
          return(
            <button key={p.id} onClick={()=>setActiveBowler(v=>v===p.id?"":p.id)}
              style={{padding:"7px 14px",borderRadius:8,border:`1.5px solid ${isAct?"#7C3AED":qDone?"#E24B4A":"rgba(0,0,0,0.15)"}`,background:isAct?"#F5F3FF":qDone?"#fcebeb":"#fff",color:isAct?"#7C3AED":qDone?"#A32D2D":"#1a1a1a",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit",boxShadow:isAct?"0 0 0 2px rgba(196,181,253,0.6)":"none"}}>
              {p.name}
              <span style={{fontSize:11,opacity:.7,marginLeft:6}}>{bp.overs}{isOpen?"":"/"+q[1]}ov</span>
            </button>
          );
        })}
      </div>}
      {sortedSheet.map(raw=>{
        const p=getP(raw.id),q=getBowlQ(p.role,p.cat);
        const isAct=activeBowler===p.id&&canEdit,qDone=!isOpen&&p.overs>=q[1],spell=p.spellOvers>=2&&p.spellRuns>=30; // lavender if active
        const pct=Math.min(p.overs/Math.max(q[1],1)*100,100);
        const bc=qDone?"red":p.overs>=q[0]?"green":"amber";
        const lt=p.fullToss+p.overpitch+p.short+p.good;
        const pf=n=>lt>0?Math.round(n/lt*100)+"%":"-";
        const curLen=pendLen[p.id]||"",hasErr=lenErr[p.id]||false;
        return(
          <div key={p.id} style={{...cs.card,borderColor:isAct?"#7C3AED":qDone||spell?"#E24B4A":"rgba(0,0,0,0.10)",borderWidth:isAct?3.5:qDone||spell?1.5:.5,background:"#fff",boxShadow:"none",cursor:canEdit&&!isAct?"pointer":"default"}} onClick={canEdit&&!isAct?()=>setActiveBowler(p.id):undefined}>
            <div style={{...cs.rowWrap,marginBottom:8}}>
              {spell&&<span style={{display:"inline-block",width:7,height:7,borderRadius:"50%",background:"#E24B4A",marginRight:4}}/>}
              <span style={{flex:1,fontSize:14,fontWeight:700,color:"#1a1a1a"}}>{p.name}</span>
              {spell&&<Badge color="red">Spell alert</Badge>}
              {!isOpen&&(qDone?<Badge color="red">Max quota</Badge>:p.overs>=q[0]?<Badge color="green">Min quota met</Badge>:null)}
              <span style={cs.muted}>{BOWL_QUOTA[p.role]?.label}{!isOpen&&` · ${q[0]}–${q[1]} ov`}</span>
            </div>
            {!isOpen&&<div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
              <div style={{flex:1,height:7,background:"#f1efe8",borderRadius:4,overflow:"hidden"}}><div style={cs.qBar(pct,bc)}/></div>
              <span style={cs.muted}>{p.overs}/{q[1]} ov · {p.runs}R · {p.wickets}W</span>
            </div>}
            {isOpen&&<div style={{fontSize:11,color:"#9ca3af",marginBottom:6}}>{p.overs} ov · {p.runs}R · {p.wickets}W</div>}
            <div style={{fontSize:11,color:"#6b7280",marginBottom:6}}>GD:{pf(p.good)} FT:{pf(p.fullToss)} OP:{pf(p.overpitch)} SH:{pf(p.short)} · Wd:{p.wides} Nb:{p.noBalls}</div>
            <div style={{display:"flex",gap:3,flexWrap:"wrap",minHeight:38,alignItems:"flex-start",marginBottom:4}}>
              {(p.overLog||[]).map((ov,oi)=>(
                <div key={oi} style={{display:"flex",gap:3,alignItems:"flex-start"}}>
                  {ov.map((b,bi)=>{
                    const isC=corrBowl&&corrBowl.bowlerId===p.id&&!corrBowl.isCurrent&&corrBowl.overIdx===oi&&corrBowl.ballIdx===bi;
                    return <PipCell key={bi} outcome={b.outcome} length={b.length} isCorr={isC}
                      onClick={canEdit?()=>{setCorrBowl({bowlerId:p.id,overIdx:oi,ballIdx:bi,isCurrent:false,outcome:b.outcome,length:b.length});setCorrLen(b.length);}:undefined}/>;
                  })}
                  <div style={{width:2,height:38,background:"rgba(0,0,0,0.12)",borderRadius:1,margin:"0 3px"}}/>
                </div>
              ))}
              {(p.currentOver||[]).map((b,bi)=>{
                const isC=corrBowl&&corrBowl.bowlerId===p.id&&corrBowl.isCurrent&&corrBowl.ballIdx===bi;
                return <PipCell key={"c"+bi} outcome={b.outcome} length={b.length} isCorr={isC}
                  onClick={canEdit?()=>{setCorrBowl({bowlerId:p.id,overIdx:-1,ballIdx:bi,isCurrent:true,outcome:b.outcome,length:b.length});setCorrLen(b.length);}:undefined}/>;
              })}
            </div>
            {canEdit&&p.overLog?.length===0&&p.currentOver?.length===0&&<div style={{fontSize:11,color:"#9ca3af",marginBottom:4}}>No balls recorded yet.</div>}
            {/* ── Correction panel ── */}
            {corrBowl&&corrBowl.bowlerId===p.id&&<div style={{background:"#e6f1fb",border:"1.5px solid #185FA5",borderRadius:8,padding:"10px 12px",marginBottom:8}}>
              <div style={{fontSize:12,fontWeight:700,color:"#185FA5",marginBottom:8}}>
                Correct ball — {corrBowl.isCurrent?"current over":"over "+(corrBowl.overIdx+1)} · ball {corrBowl.ballIdx+1}
                <span style={{fontSize:11,fontWeight:400,color:"#6b7280",marginLeft:8}}>was: {corrBowl.length} / {corrBowl.outcome}</span>
              </div>
              <div style={{marginBottom:8}}>
                <div style={{fontSize:11,color:"#374151",fontWeight:600,marginBottom:4}}>Length:</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {["GD","FT","OP","SH"].map(len=>(
                    <button key={len} onClick={()=>setCorrLen(len)} style={{minWidth:44,height:28,padding:"0 8px",border:"0.5px solid",borderColor:corrLen===len?G:"rgba(0,0,0,0.18)",borderRadius:6,background:corrLen===len?G:"#fff",color:corrLen===len?"#fff":"#6b7280",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit"}}>{len}</button>
                  ))}
                </div>
              </div>
              <div style={{marginBottom:10}}>
                <div style={{fontSize:11,color:"#374151",fontWeight:600,marginBottom:4}}>Outcome:</div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                  {[["dot","0"],["1","1"],["2","2"],["3","3"],["4","4"],["6","6"],["Wd","Wd"],["Nb","Nb"],["W","W"]].map(([lbl,val])=>{
                    const sel=corrBowl.outcome===val;
                    const iW=val==="W",isWN=val==="Wd"||val==="Nb";
                    return(<button key={val} onClick={()=>setCorrBowl(c=>({...c,outcome:val}))}
                      style={{minWidth:38,height:30,padding:"0 8px",border:`1px solid ${sel?"#185FA5":"rgba(0,0,0,0.15)"}`,borderRadius:6,
                        background:sel?"#185FA5":iW?"#fcebeb":isWN?"#faeeda":"#fff",
                        color:sel?"#fff":iW?"#A32D2D":isWN?"#854F0B":val==="4"?G:val==="6"?"#854F0B":val==="0"?"#6b7280":"#185FA5",
                        cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>{lbl}</button>);
                  })}
                </div>
              </div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <button onClick={()=>saveBowlCorrection(corrBowl.bowlerId,corrBowl.overIdx,corrBowl.ballIdx,corrBowl.isCurrent,corrBowl.outcome,corrLen)}
                  style={{...cs.btnP,padding:"6px 14px",fontSize:12}} disabled={!corrLen||!corrBowl.outcome}>Save correction</button>
                <button onClick={()=>deleteBowlBall(corrBowl.bowlerId,corrBowl.overIdx,corrBowl.ballIdx,corrBowl.isCurrent)}
                  style={{padding:"6px 14px",fontSize:12,fontWeight:700,border:"1.5px solid #A32D2D",borderRadius:8,background:"#fcebeb",color:"#A32D2D",cursor:"pointer",fontFamily:"inherit"}}>Delete ball</button>
                <button onClick={()=>{setCorrBowl(null);setCorrLen("");}} style={{...cs.btnG,padding:"6px 14px",fontSize:12}}>Cancel</button>
              </div>
            </div>}
            {p.currentOver?.length>0&&<div style={{...cs.muted,marginBottom:6}}>{p.legalInOver}/6 legal this over</div>}
            {isAct&&!qDone&&<>
              <Divider/>
              <div style={{...cs.rowWrap,marginBottom:8}}>
                <span style={{fontSize:12,fontWeight:500}}>Length:</span>
                {["GD","FT","OP","SH"].map(len=>(
                  <button key={len} onClick={()=>setLen(p.id,len)} style={{minWidth:44,height:28,padding:"0 8px",border:"0.5px solid",borderColor:curLen===len?G:"rgba(0,0,0,0.18)",borderRadius:6,background:curLen===len?G:"#fff",color:curLen===len?"#fff":"#6b7280",cursor:"pointer",fontSize:12,fontWeight:500,fontFamily:"inherit"}}>{len}</button>
                ))}
                {hasErr&&<span style={{fontSize:11,color:"#A32D2D"}}>Select length first</span>}
              </div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:6}}>
                {[["dot","0"],["1","1"],["2","2"],["3","3"],["4","4"],["6","6"]].map(([lbl,val])=>{
                  const is4=lbl==="4",is6=lbl==="6";
                  return(<button key={lbl} onClick={()=>bowlBall(val)} disabled={!curLen}
                    style={{minWidth:38,height:34,padding:"0 7px",border:"0.5px solid rgba(0,0,0,0.15)",borderRadius:6,background:"#fff",color:is4?G:is6?"#854F0B":lbl==="dot"?"#6b7280":"#185FA5",cursor:curLen?"pointer":"not-allowed",opacity:curLen?1:.35,fontSize:13,fontWeight:700,fontFamily:"inherit"}}>{lbl}
                  </button>);
                })}
              </div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {[["Wd","Wd"],["Nb","Nb"],["W","W"]].map(([lbl,val])=>{
                  const iW=lbl==="W",isWN=lbl==="Wd"||lbl==="Nb";
                  return(<button key={lbl} onClick={()=>bowlBall(val)} disabled={!curLen}
                    style={{minWidth:44,height:34,padding:"0 9px",border:`1px solid ${iW?"#F09595":isWN?"#FAC775":"rgba(0,0,0,0.15)"}`,borderRadius:6,background:iW?"#fcebeb":isWN?"#faeeda":"#fff",color:iW?"#A32D2D":"#854F0B",cursor:curLen?"pointer":"not-allowed",opacity:curLen?1:.35,fontSize:13,fontWeight:700,fontFamily:"inherit"}}>{lbl}
                  </button>);
                })}
              </div>
            </>}
          </div>
        );
      })}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// FIELDING LOG
// ═══════════════════════════════════════════════════════════════════════════════
const FLD_EVENTS=[{k:"catches",l:"Catches"},{k:"missedCatch",l:"Missed catch"},{k:"runouts",l:"Run outs"},{k:"missedRunout",l:"Missed RO"},{k:"stumpings",l:"Stumpings"},{k:"missedStumping",l:"Missed stump"},{k:"widesSaved",l:"WK wides saved"},{k:"byesGiven",l:"WK byes given"},{k:"runsSaved",l:"Runs saved"},{k:"misfields",l:"Misfields"},{k:"sports",l:"Sportsmanship"}];
function FieldingLog({user,teamSheet,fielding,setFielding,onSave,saveMsg,matchFrozen}){
  const canEdit=user.role==="COACH"&&!matchFrozen;
  if(!teamSheet.length)return(<div><SectionHdr title="Fielding log"/><div style={cs.muted}>Confirm the team sheet first.</div></div>);
  function adj(id,key,v){setFielding(f=>{const cur=f[id]||{...teamSheet.find(p=>p.id===id),...Object.fromEntries(FLD_EVENTS.map(e=>[e.k,0]))};return{...f,[id]:{...cur,[key]:Math.max(0,(cur[key]||0)+v)}};});}
  function get(id){return fielding[id]||Object.fromEntries(FLD_EVENTS.map(e=>[e.k,0]));}
  return(
    <div>
      <SectionHdr title="Fielding log" sub="Record fielding events per player."/>{onSave&&<div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><button style={cs.btnP} onClick={onSave}>Save match data</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(0,1fr))",gap:10}}>
        {teamSheet.map(p=>{const d=get(p.id);return(
          <div key={p.id} style={{background:"#fff",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:10,padding:"10px 12px"}}>
            <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:8}}>{p.name}</div>
            {FLD_EVENTS.map(ev=>(
              <div key={ev.k} style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:11,color:"#6b7280",padding:"3px 0"}}>
                <span style={{fontWeight:600,color:"#1a1a1a"}}>{ev.l}</span>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  {canEdit&&<button onClick={()=>adj(p.id,ev.k,-1)} style={{width:26,height:26,border:"1.5px solid rgba(0,0,0,0.25)",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:16,fontWeight:700,color:"#1a1a1a",fontFamily:"inherit"}}>−</button>}
                  <span style={{fontSize:14,fontWeight:700,minWidth:20,textAlign:"center",color:"#1a1a1a"}}>{d[ev.k]||0}</span>
                  {canEdit&&<button onClick={()=>adj(p.id,ev.k,1)} style={{width:26,height:26,border:"1.5px solid rgba(0,0,0,0.25)",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:16,fontWeight:700,color:"#1a1a1a",fontFamily:"inherit"}}>+</button>}
                </div>
              </div>
            ))}
          </div>
        );})}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// COACH NOTES
// ═══════════════════════════════════════════════════════════════════════════════
function CoachNotes({user,teamSheet,notes,setNotes}){
  const [gText,setGText]=useState("");
  const [err,setErr]=useState("");
  const isCoach=user.role==="COACH"||user.role==="MANAGER";
  const isPlayer=user.role==="PLAYER";
  function addGroup(){if(!gText.trim()){setErr("Note cannot be empty.");return;}setNotes([{noteId:"N"+Date.now(),scope:"GROUP",text:gText.trim(),author:user.name,createdAt:new Date().toISOString()},...notes]);setGText("");setErr("");}
  const fmt=iso=>new Date(iso).toLocaleString("en-US",{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"});
  const groupNotes=notes.filter(n=>n.scope==="GROUP");
  return(
    <div>
      <SectionHdr title="Coach notes" sub={isPlayer?"Notes from your coach and manager.":"Group notes are shared with the team and included in Match Report."}/>
      <AlertBox type="red" msg={err} onClose={()=>setErr("")}/>
      {isCoach&&<div style={cs.card}>
        <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:6}}>New group note</div>
        <div style={{...cs.muted,marginBottom:8}}>Posted to the whole team. Included in Match Report PDF shared with players and parents.</div>
        <textarea style={{...cs.textarea,marginBottom:10}} value={gText} onChange={e=>setGText(e.target.value)} placeholder="e.g. Batting order: Arjun opens, Dev #2. Kiran opens bowling. All batters must face minimum quota balls…" rows={4}/>
        <button style={cs.btnP} onClick={addGroup}>Post note</button>
      </div>}
      {groupNotes.length===0&&<div style={{...cs.muted,padding:"8px 0"}}>No group notes yet{isCoach?" — post one above":"."}.</div>}
      {groupNotes.map(n=>(
        <div key={n.noteId} style={{...cs.card,marginBottom:8}}>
          <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}}>
            <div style={{flex:1}}>
              <div style={{...cs.row,marginBottom:6,flexWrap:"wrap"}}>
                <Badge color="green">Group</Badge>
                <span style={cs.muted}>{fmt(n.createdAt)} · {n.author}</span>
              </div>
              <div style={{fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{n.text}</div>
            </div>
            {isCoach&&<button onClick={()=>setNotes(ns=>ns.filter(x=>x.noteId!==n.noteId))} style={{background:"none",border:"none",cursor:"pointer",color:"#9ca3af",fontSize:16,padding:"0 4px"}}>×</button>}
          </div>
        </div>
      ))}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// LOGISTICS
// ═══════════════════════════════════════════════════════════════════════════════
function Logistics({user,logistics,setLogistics,onSave,saveMsg}){
  const canEdit=user.role==="MANAGER"||user.role==="COACH";
  const d={transport:"",carpool:"",food:"",drinks:"",kits:"",jerseys:"",meetupTime:"",meetupPlace:"",other:"",...logistics};
  const up=(k,v)=>setLogistics(l=>({...d,[k]:v}));
  const F=({label,k,type="textarea",ph=""})=>(
    <div><label style={cs.label}>{label}</label>
      {type==="time"?<input type="time" style={cs.input} value={d[k]} onChange={e=>up(k,e.target.value)} disabled={!canEdit}/>
      :type==="text"?<input style={cs.input} value={d[k]} onChange={e=>up(k,e.target.value)} placeholder={ph} disabled={!canEdit}/>
      :<textarea style={{...cs.textarea,minHeight:60}} value={d[k]} onChange={e=>up(k,e.target.value)} placeholder={ph} disabled={!canEdit} rows={2}/>}
    </div>
  );
  return(
    <div>
      <SectionHdr title="Match day logistics" sub={canEdit?"Record all logistics for this match.":"Match day logistics for your team."}/>
      <div style={cs.card}><div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Meeting point</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <F label="Meet-up time" k="meetupTime" type="time"/>
          <F label="Meet-up location" k="meetupPlace" type="text" ph="Hansen Dam car park, Gate B"/>
        </div>
      </div>
      <div style={cs.card}><div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Transport & carpooling</div>
        <div style={{display:"grid",gap:10}}>
          <F label="Driving / transport coordinator" k="transport" ph="e.g. Ravi driving white Toyota (seats 5)…"/>
          <F label="Carpool assignments" k="carpool" ph="e.g. Arjun, Dev, Rohan → Ravi's car…"/>
        </div>
      </div>
      <div style={cs.card}><div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Food & drinks</div>
        <div style={{display:"grid",gap:10}}>
          <F label="Food arrangements" k="food" ph="e.g. Lunch boxes provided. Players to bring snacks."/>
          <F label="Drinks & hydration" k="drinks" ph="e.g. Water bottles and electrolyte sachets provided."/>
        </div>
      </div>
      <div style={cs.card}><div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Kits, jerseys & dress</div>
        <div style={{display:"grid",gap:10}}>
          <F label="Cricket kit (pads, helmets, gloves, bats)" k="kits" ph="e.g. Shared helmets in kit bag. Players bring own gloves/pads."/>
          <F label="Jerseys & playing dress" k="jerseys" ph="e.g. White shirt with blue LA Hub logo. White trousers. White shoes."/>
        </div>
      </div>
      <div style={cs.card}><div style={{fontSize:13,fontWeight:500,marginBottom:10}}>Additional notes</div>
        <F label="" k="other" ph="Any other logistics, parent instructions, medical notes…"/>
      </div>
      {canEdit&&<div style={cs.row}><button style={cs.btnP} onClick={onSave}>Save logistics</button>{saveMsg&&<span style={{fontSize:12,color:G}}>{saveMsg}</span>}</div>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// PLAYER PORTAL (Phase 2 placeholder)
// ═══════════════════════════════════════════════════════════════════════════════
function PlayerPortal({user,teamSheet,matches,notes,orgPlan,apiFetch}){
  const isPlayer=user.role==="PLAYER";
  const [tab,setTab]=useState("stats");
  const [stats,setStats]=useState(null);
  const [loading,setLoading]=useState(false);
  const myNotes=notes.filter(n=>n.scope==="GROUP");
  const isPro=!["TRIAL","trial","SUSPENDED","suspended"].includes(orgPlan);

  useEffect(()=>{
    if(!isPlayer||!apiFetch) return;
    setLoading(true);
    apiFetch("/crickithub/player/stats").then(async d=>{
      if(!d){setLoading(false);return;}
      // Also load teamsheets so player can see confirmed team for each match
      const enriched=await Promise.all((d.matches||[]).map(async m=>{
        const ts=await apiFetch(`/crickithub/matches/${m.matchId}/teamsheet`).catch(()=>null);
        return{...m,teamSheet:ts?.players?.length>0?ts.players:[]};
      }));
      setStats({...d,matches:enriched});
      setLoading(false);
    });
  },[isPlayer]);

  if(!isPlayer) return(
    <div>
      <SectionHdr title="Player portal" sub="Players and parents access their own stats via their personal access code."/>
      <div style={{...cs.card,background:"#e6f1fb",border:"1px solid #B5D4F4"}}>
        <div style={{fontSize:14,fontWeight:700,color:"#185FA5",marginBottom:8}}>How players get access</div>
        <div style={{fontSize:13,color:"#185FA5",lineHeight:1.7,marginBottom:12}}>
          1. Go to <strong>Team Assembly → Squad manager</strong> and add a player's email address.<br/>
          2. An access code is generated automatically (e.g. <span style={{fontFamily:"monospace",fontWeight:700}}>CM-4X9K2</span>).<br/>
          3. Share the code with the player or parent — they go to the login screen and tap <strong>"I have an access code"</strong>.<br/>
          4. They create a password and can immediately view their own stats and match history.
        </div>
        <div style={{fontSize:13,color:"#185FA5"}}>Access codes are visible next to each player's name in Squad Manager.</div>
      </div>
    </div>
  );

  return(
    <div>
      <SectionHdr title="My portal" sub={`Welcome, ${user.name}`}/>
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
        {["stats","schedule","team","notes"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{padding:"7px 16px",border:"0.5px solid",borderColor:tab===t?G:"rgba(0,0,0,0.15)",borderRadius:8,background:tab===t?G:"#fff",color:tab===t?"#fff":"#1a1a1a",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>
            {t==="stats"?"My stats":t==="schedule"?"Schedule":t==="team"?"My team":"Notes"}
          </button>
        ))}
      </div>

      {tab==="stats"&&<>
        {loading&&<div style={cs.muted}>Loading your stats…</div>}
        {!loading&&!stats&&<div style={cs.muted}>No match data found yet. Your coach needs to confirm a team sheet with you in it.</div>}
        {stats&&<>
          <div style={{...cs.card,background:"#f0faf4",marginBottom:12}}>
            <div style={{fontSize:14,fontWeight:700,color:G,marginBottom:2}}>{stats.playerName}</div>
            <div style={{fontSize:12,color:"#6b7280"}}>{stats.matches?.length||0} matches recorded</div>
          </div>
          {/* My batting stats */}
          {stats.matches?.some(m=>m.batting)&&<>
            <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:8,paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Batting</div>
            {(()=>{
              const bm=stats.matches.filter(m=>m.batting).sort((a,b)=>a.date<b.date?-1:1);
              const tb=bm.reduce((a,m)=>a+(m.batting.balls||0),0);
              const tr=bm.reduce((a,m)=>a+(m.batting.runs||0),0);
              const td=bm.reduce((a,m)=>a+(m.batting.dots||0),0);
              const avgSR=tb>0?Math.round(tr/tb*100):0;
              const qm=bm.filter(m=>["met","retired"].includes(m.batting.status)).length;
              const out=bm.filter(m=>m.batting.status==="out").length;
              const ret=bm.filter(m=>m.batting.status==="retired").length;
              return <>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(80px,1fr))",gap:8,marginBottom:12}}>
                  <MetricCard label="Total runs" value={tr} color={tr>50?CG:"#1a1a1a"}/>
                  <MetricCard label="Total balls" value={tb}/>
                  <MetricCard label="Avg SR" value={avgSR} color={avgSR>100?CG:avgSR<50?CR:"#1a1a1a"}/>
                  <MetricCard label="Quota met" value={`${qm}/${bm.length}`}/>
                  <MetricCard label="Retired" value={ret} color={ret>0?CG:"#9ca3af"}/>
                </div>
                {isPro&&<BattingCharts pid={"player-bat"} pdata={{role:stats.matches[0]?.role||"BATTING",matches:stats.matches}} matches={[]} careerView={true}/>}
                {!isPro&&<div style={{...cs.card,background:"#f0faf4",fontSize:13,color:G}}>Detailed batting charts available with Pro Analytics — contact your coach to unlock.</div>}
              </>;
            })()}
          </>}
          {/* My bowling stats */}
          {stats.matches?.some(m=>m.bowling&&m.bowling.overs>0)&&<>
            <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",margin:"14px 0 8px",paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Bowling</div>
            {(()=>{
              const bm=stats.matches.filter(m=>m.bowling&&m.bowling.overs>0);
              const to=bm.reduce((a,m)=>a+(m.bowling.overs||0),0);
              const tw=bm.reduce((a,m)=>a+(m.bowling.wickets||0),0);
              const tr=bm.reduce((a,m)=>a+(m.bowling.runs||0),0);
              const ae=to>0?(tr/to).toFixed(1):"-";
              return <>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(80px,1fr))",gap:8,marginBottom:12}}>
                  <MetricCard label="Wickets" value={tw} color={tw>5?CG:"#1a1a1a"}/>
                  <MetricCard label="Overs" value={to}/>
                  <MetricCard label="Avg economy" value={ae} color={parseFloat(ae)>8?CR:parseFloat(ae)<5?CG:"#1a1a1a"}/>
                </div>
                {isPro&&<BowlingCharts pid={"player-bowl"} pdata={{role:stats.matches[0]?.role||"BOWLING",matches:stats.matches}} careerView={true}/>}
                {!isPro&&<div style={{...cs.card,background:"#f0faf4",fontSize:13,color:G}}>Detailed bowling charts available with Pro Analytics.</div>}
              </>;
            })()}
          </>}
          {/* My fielding */}
          {stats.matches?.some(m=>m.fielding)&&<>
            <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",margin:"14px 0 8px",paddingBottom:4,borderBottom:"0.5px solid rgba(0,0,0,0.08)"}}>Fielding</div>
            {isPro&&<FieldingCharts pid={"player-fld"} pdata={{matches:stats.matches}} careerView={true}/>}
            {!isPro&&<div style={{...cs.card,background:"#f0faf4",fontSize:13,color:G}}>Detailed fielding charts available with Pro Analytics.</div>}
          </>}
        </>}
      </>}

      {tab==="schedule"&&<>
        {[...matches].filter(m=>!m.inactive).sort((a,b)=>a.date<b.date?-1:1).length===0
          ?<div style={cs.muted}>No matches scheduled yet.</div>
          :[...matches].filter(m=>!m.inactive).sort((a,b)=>a.date<b.date?-1:1).map(m=>{
            const [y,mo,d]=(m.date||"").split("-");
            const dateStr=m.date?new Date(+y,+mo-1,+d).toLocaleDateString("en-US",{weekday:"long",day:"numeric",month:"long"}):"Date TBC";
            return(
              <div key={m.matchId} style={{...cs.card,marginBottom:8}}>
                <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:15,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>vs {m.opponent||"TBC"}</div>
                    <div style={{fontSize:13,color:"#6b7280",marginBottom:2}}>{dateStr}{m.time?" at "+m.time:""}</div>
                    {m.venue&&<div style={{fontSize:13,color:"#6b7280",marginBottom:2}}>📍 {m.venue}</div>}
                    {m.tournament&&<div style={{fontSize:12,color:"#9ca3af"}}>{m.tournament}</div>}
                  </div>
                  {m.frozen?<Badge color="gray">Played</Badge>:<Badge color="green">Upcoming</Badge>}
                </div>
              </div>
            );
          })}
      </>}

      {tab==="team"&&<>
        {!stats?.matches?.length?<div style={cs.muted}>No match data yet.</div>
        :[...stats.matches].filter(m=>m.teamSheet||true).sort((a,b)=>b.date<a.date?-1:1).map(m=>(
          <div key={m.matchId} style={{...cs.card,marginBottom:8}}>
            <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>vs {m.opponent||"TBC"}</div>
            <div style={{fontSize:12,color:"#6b7280",marginBottom:6}}>{m.date||""}{m.tournament?" · "+m.tournament:""}</div>
            {m.teamSheet?.length>0
              ?<div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                {m.teamSheet.map((p,i)=>(
                  <span key={p.id||i} style={{display:"inline-flex",alignItems:"center",gap:4,background:"#f8f9f7",border:"0.5px solid rgba(0,0,0,0.10)",padding:"3px 10px",borderRadius:20,fontSize:12,fontWeight:p.id===user.playerId?700:400,color:p.id===user.playerId?G:"#1a1a1a"}}>
                    {i+1}. {p.name}
                  </span>
                ))}
              </div>
              :<div style={cs.muted}>Team sheet not yet confirmed for this match.</div>}
          </div>
        ))}
      </>}

      {tab==="notes"&&<>
        {!myNotes.length?<div style={cs.muted}>No group notes from your coach yet.</div>
        :myNotes.map(n=>(
          <div key={n.noteId} style={{...cs.card,marginBottom:8}}>
            <div style={{...cs.row,marginBottom:6,flexWrap:"wrap"}}>
              <Badge color="green">Group note</Badge>
              <span style={cs.muted}>{new Date(n.createdAt).toLocaleDateString()} · {n.author}</span>
            </div>
            <div style={{fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{n.text}</div>
          </div>
        ))}
      </>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MATCH REPORT + PDF
// ═══════════════════════════════════════════════════════════════════════════════
function MatchReport({user,teamMeta,batting,bowling,fielding,teamSheet,activeMatch,notes,matchFrozen,onFreeze,onUnfreeze,reportData,onReportChange,matchType,reportLocked,onToggleReportLock,hubRules}){
  const isOpen=(matchType||activeMatch?.matchType||"hub")==="open";
  const [preview,setPreview]=useState("");
  const [err,setErr]=useState("");
  const [unfreezeCode,setUnfreezeCode]=useState("");
  const [unfreezeErr,setUnfreezeErr]=useState("");
  const [unfreezeBusy,setUnfreezeBusy]=useState(false);
  const [showUnfreeze,setShowUnfreeze]=useState(false);
  async function doUnfreeze(){
    if(!unfreezeCode.trim()){setUnfreezeErr("Enter your admin code.");return;}
    setUnfreezeBusy(true);setUnfreezeErr("");
    const r=await onUnfreeze(unfreezeCode);
    setUnfreezeBusy(false);
    if(r?.error){setUnfreezeErr(r.error);}
    else{setShowUnfreeze(false);setUnfreezeCode("");setUnfreezeErr("");}
  }
  const hiOwn=reportData?.hiOwn||"";
  const hiOpp=reportData?.hiOpp||"";
  const top3=new Set(reportData?.top3||[]);
  const opp1=reportData?.opp1||"";
  const opp2=reportData?.opp2||"";
  const opp3=reportData?.opp3||"";
  function setHiOwn(v){onReportChange({...reportData,hiOwn:v});}
  function setHiOpp(v){onReportChange({...reportData,hiOpp:v});}
  function setOpp1(v){onReportChange({...reportData,opp1:v});}
  function setOpp2(v){onReportChange({...reportData,opp2:v});}
  function setOpp3(v){onReportChange({...reportData,opp3:v});}
  const bats=Object.values(batting).sort((a,b)=>b.runs-a.runs);
  const bowls=Object.values(bowling).sort((a,b)=>b.wickets-a.wickets||a.runs-b.runs);
  const fields=Object.values(fielding).sort((a,b)=>b.catches-a.catches);
  const allP={...Object.fromEntries(teamSheet.map(p=>[p.id,p])),...Object.fromEntries(bats.map(p=>[p.id,p]))};
  const top3Names=Array.from(top3).map(id=>allP[id]?.name||id);
  function toggleTop3(id){const arr=reportData?.top3||[];const has=arr.includes(id);if(!has&&arr.length>=3){setErr("Max 3 performers.");return;}const newArr=has?arr.filter(x=>x!==id):[...arr,id];onReportChange({...reportData,top3:newArr});setErr("");}
  const meta={team1:teamMeta.teamName||"Team A",team2:activeMatch?.opponent||"Opponent",date:activeMatch?.date?(()=>{const [y,mo,d]=activeMatch.date.split("-");return new Date(+y,+mo-1,+d).toLocaleDateString("en-US",{day:"numeric",month:"long",year:"numeric"});})():new Date().toLocaleDateString("en-US",{day:"numeric",month:"long",year:"numeric"}),category:teamMeta.ageCategory||"U13",coachName:teamMeta.coachName||""};

  function getBatQ(role,cat){if(hubRules){const rr=hubRules[role];if(rr){const c=(cat||"").toLowerCase();const mn=rr[c+"Min"]!==undefined?rr[c+"Min"]:rr.min;const mx=rr[c+"Max"]!==undefined?rr[c+"Max"]:rr.max;if(mn!==undefined&&mx!==undefined)return[mn,mx];}}return ROLES[role]?.[(cat||"u13").toLowerCase()]||[20,30];}
  function buildText(type){
    const fld=fields.map(p=>{const t=p.catches+p.missedCatch+p.runouts+p.missedRunout+p.stumpings+p.missedStumping+p.sports;if(!t)return null;return `  ${(p.name||"").padEnd(22)} C:${p.catches} MC:${p.missedCatch} RO:${p.runouts} MRO:${p.missedRunout} ST:${p.stumpings} MST:${p.missedStumping} SP:${p.sports}`;}).filter(Boolean).join("\n")||"  No fielding data.";
    if(type==="match"){
      const bl=bats.map(p=>{const sr=p.balls>0?Math.round(p.runs/p.balls*100):0,dp=p.balls>0?Math.round(p.dots/p.balls*100):0;return `  ${(p.name||"").padEnd(22)} ${String(p.runs).padStart(3)}r ${String(p.balls).padStart(3)}b SR:${String(sr).padStart(3)} Dots:${dp}%`;}).join("\n")||"  No data.";
      const bwl=bowls.map(p=>{const e=p.overs>0?(p.runs/p.overs).toFixed(1):"-",lt=p.fullToss+p.overpitch+p.short+p.good,pf=n=>lt>0?Math.round(n/lt*100)+"%":"-";return `  ${(p.name||"").padEnd(22)} ${p.overs}ov ${p.runs}R ${p.wickets}W Econ:${e} GD:${pf(p.good)} SH:${pf(p.short)} FT:${pf(p.fullToss)} OP:${pf(p.overpitch)} Wd:${p.wides} Nb:${p.noBalls}`;}).join("\n")||"  No data.";
      const notesText=groupNotes.length?groupNotes.map(n=>`  [${new Date(n.createdAt).toLocaleDateString()}] ${n.text}`).join("\n"):"  No group notes.";
      return `MATCH REPORT (INTERNAL)\n${meta.team1}  vs  ${meta.team2}\nDate: ${meta.date}  |  ${meta.category}  |  Coach: ${meta.coachName||"—"}\n${"─".repeat(54)}\n\nHIGHLIGHTS — ${meta.team1}:\n${hiOwn||"No highlights."}\n\n${"─".repeat(54)}\nCOACH NOTES:\n${notesText}\n\n${"─".repeat(54)}\nFIELDING TALLY\n${fld}\n  Key: C=Catch  RO=RunOut  ST=Stump  MC=Missed Catch  MRO=Missed RunOut  MST=Missed Stump  SP=Sportsmanship\n\n${"─".repeat(54)}\nTOP 3 PERFORMERS:\n${top3Names.length?top3Names.map((n,i)=>`  ${i+1}. ${n}`).join("\n"):"  Not selected."}\n\n${"─".repeat(54)}\nBATTING (full details):\n${bl}\n\n${"─".repeat(54)}\nBOWLING (full details):\n${bwl}\n\nGenerated: ${new Date().toLocaleString()}`;
    }
    const bq=bats.map(p=>{const q=getBatQ(p.role,p.cat),sr=p.balls>0?Math.round(p.runs/p.balls*100):0;return `  ${(p.name||"").padEnd(22)} ${String(p.balls).padStart(3)}b ${String(p.runs).padStart(3)}r SR:${sr} Q${q[0]}-${q[1]}: ${p.balls>=q[0]?"MET":"PENDING"}`;}).join("\n")||"  No data.";
    const bwq=bowls.map(p=>{const q=(()=>{if(hubRules){const rr=hubRules[p.role];if(rr){const c=(p.cat||"u13").toLowerCase();const C=c.charAt(0).toUpperCase()+c.slice(1);const mn=rr["bowl"+C+"Min"]!==undefined?rr["bowl"+C+"Min"]:rr.bowlMin;const mx=rr["bowl"+C+"Max"]!==undefined?rr["bowl"+C+"Max"]:rr.bowlMax;if(mn!==undefined&&mx!==undefined)return[mn,mx];}}return BOWL_QUOTA[p.role]?.[(p.cat||"u13").toLowerCase()]||[0,3];})(),e=p.overs>0?(p.runs/p.overs).toFixed(1):"-",lt=p.fullToss+p.overpitch+p.short+p.good,pf=n=>lt>0?Math.round(n/lt*100)+"%":"-";return `  ${(p.name||"").padEnd(22)} ${p.overs}ov ${p.runs}R ${p.wickets}W Econ:${e} GD:${pf(p.good)} Q${q[0]}-${q[1]}: ${p.overs>=q[0]?"MET":"PENDING"}`;}).join("\n")||"  No data.";
    return `HUB REPORT — OFFICIAL SUBMISSION\nLA Hub Selection Cycle\n${"═".repeat(54)}\nDate: ${meta.date} | ${meta.category} | Coach: ${meta.coachName||"—"}\nTeam 1: ${meta.team1} | Team 2: ${meta.team2}\n\n${"─".repeat(54)}\nHIGHLIGHTS — ${meta.team1}:\n${hiOwn||"No highlights."}\n\nHIGHLIGHTS — ${meta.team2}:\n${hiOpp||"No highlights."}\n\n${"─".repeat(54)}\nFIELDING TALLY\n${fld}\n  Key: C=Catch  RO=RunOut  ST=Stump  MC=Missed Catch  MRO=Missed RunOut  MST=Missed Stump  SP=Sportsmanship\n\n${"─".repeat(54)}\nTOP 3 — OWN TEAM:\n${top3Names.length?top3Names.map((n,i)=>`  ${i+1}. ${n}`).join("\n"):"  Not selected."}\n\nTOP 3 — OPPONENT:\n  1. ${opp1||"—"}\n  2. ${opp2||"—"}\n  3. ${opp3||"—"}\n\n${"─".repeat(54)}\nBATTING QUOTA COMPLIANCE\n${bq}\n\n${"─".repeat(54)}\nBOWLING QUOTA COMPLIANCE\n${bwq}\n\n${"─".repeat(54)}\nSubmitted within 24 hrs: YES\nGenerated: ${new Date().toLocaleString()}\n${"═".repeat(54)}`;
  }

  function savePDF(type){
    const doc=new jsPDF({unit:"pt",format:"a4"});
    const margin=40,pageW=doc.internal.pageSize.getWidth(),pageH=doc.internal.pageSize.getHeight(),maxW=pageW-margin*2;
    doc.setFillColor(26,122,74);doc.rect(0,0,pageW,52,"F");
    doc.setFont("Courier","bold");doc.setFontSize(type==="match"?16:14);doc.setTextColor(255,255,255);
    doc.text(type==="match"?"MATCH REPORT":"HUB REPORT — OFFICIAL SUBMISSION",margin,32);
    doc.setFontSize(9);doc.text(`${meta.team1}  vs  ${meta.team2}  ·  ${meta.date}  ·  ${meta.category}`,margin,46);
    doc.setTextColor(26,26,26);let y=66;
    const section=t=>{if(y+18>pageH-margin){doc.addPage();y=margin;}doc.setFillColor(230,244,236);doc.rect(margin,y-2,maxW,16,"F");doc.setFont("Courier","bold");doc.setFontSize(8);doc.setTextColor(26,122,74);doc.text(t.toUpperCase(),margin+4,y+9);doc.setTextColor(26,26,26);y+=18;};
    const line=t=>{if(y+12>pageH-margin){doc.addPage();y=margin;}doc.setFont("Courier","normal");doc.setFontSize(8.5);doc.splitTextToSize(t,maxW-8).forEach(l=>{if(y+12>pageH-margin){doc.addPage();y=margin;}doc.text(l,margin+4,y);y+=12;});};
    section(`Highlights — ${meta.team1}`);line(hiOwn||"No highlights.");y+=4;
    if(type==="hub"){section(`Highlights — ${meta.team2}`);line(hiOpp||"No highlights.");y+=4;}
    if(type==="match"){
      const notesText=groupNotes.length?groupNotes.map(n=>`[${new Date(n.createdAt).toLocaleDateString()}] ${n.text}`).join("\n\n"):"No group notes.";
      section("Coach notes");line(notesText);y+=4;
    }
    section("Fielding tally");
    fields.forEach(p=>{const t=p.catches+p.missedCatch+p.runouts+p.missedRunout+p.stumpings+p.missedStumping+p.sports;if(!t)return;line(`${(p.name||"").padEnd(22)} C:${p.catches} MC:${p.missedCatch} RO:${p.runouts} MRO:${p.missedRunout} ST:${p.stumpings} MST:${p.missedStumping} SP:${p.sports}`);});
    line("Key: C=Catch  RO=RunOut  ST=Stump  MC=Missed Catch  MRO=Missed RunOut  MST=Missed Stump  SP=Sportsmanship");
    y+=4;
    section("Top 3 performers — own team");top3Names.forEach((n,i)=>line(`  ${i+1}. ${n}`));y+=4;
    if(type==="hub"){section("Top 3 performers — opponent");[opp1||"—",opp2||"—",opp3||"—"].forEach((n,i)=>line(`  ${i+1}. ${n}`));y+=4;}
    section(type==="match"?"Batting — sorted by runs":"Batting quota compliance");
    bats.forEach(p=>{const q=getBatQ(p.role,p.cat),sr=p.balls>0?Math.round(p.runs/p.balls*100):0,dp=p.balls>0?Math.round(p.dots/p.balls*100):0;line(type==="match"?`${(p.name||"").padEnd(22)} ${String(p.runs).padStart(3)}r ${String(p.balls).padStart(3)}b SR:${sr} Dots:${dp}%`:`${(p.name||"").padEnd(22)} ${String(p.balls).padStart(3)}b ${String(p.runs).padStart(3)}r SR:${sr} Q${q[0]}-${q[1]}: ${p.balls>=q[0]?"MET":"PENDING"}`);});y+=4;
    section(type==="match"?"Bowling — sorted by wickets":"Bowling quota compliance");
    bowls.forEach(p=>{const q=(()=>{if(hubRules){const rr=hubRules[p.role];if(rr){const c=(p.cat||"u13").toLowerCase();const C=c.charAt(0).toUpperCase()+c.slice(1);const mn=rr["bowl"+C+"Min"]!==undefined?rr["bowl"+C+"Min"]:rr.bowlMin;const mx=rr["bowl"+C+"Max"]!==undefined?rr["bowl"+C+"Max"]:rr.bowlMax;if(mn!==undefined&&mx!==undefined)return[mn,mx];}}return BOWL_QUOTA[p.role]?.[(p.cat||"u13").toLowerCase()]||[0,3];})(),e=p.overs>0?(p.runs/p.overs).toFixed(1):"-",lt=p.fullToss+p.overpitch+p.short+p.good,pf=n=>lt>0?Math.round(n/lt*100)+"%":"-";line(`${(p.name||"").padEnd(22)} ${p.overs}ov ${p.runs}R ${p.wickets}W Econ:${e} GD:${pf(p.good)} SH:${pf(p.short)} FT:${pf(p.fullToss)} OP:${pf(p.overpitch)} Wd:${p.wides} Nb:${p.noBalls}${type==="hub"?" Q"+q[0]+"-"+q[1]+": "+(p.overs>=q[0]?"MET":"PENDING"):""}`)});
    y+=8;line(`Generated: ${new Date().toLocaleString()}`);
    doc.save(`${type==="match"?"Match_Report":"HUB_Report"}_${meta.team1.replace(/\s/g,"_")}_vs_${meta.team2.replace(/\s/g,"_")}_${meta.date.replace(/[\s,]/g,"_")}.pdf`);
  }

  const groupNotes=(notes||[]).filter(n=>n.scope==="GROUP");
  if(!activeMatch) return <div style={{...cs.card,color:"#6b7280",fontSize:13}}>No active match selected.</div>;
  const th={textAlign:"left",padding:"6px 8px",fontSize:12,fontWeight:700,color:"#1a1a1a",background:"#f0f4f2",whiteSpace:"nowrap"};
  const td=sel=>({padding:"7px 8px",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontSize:13,fontWeight:600,color:"#1a1a1a",background:sel?"#e6f4ec":"transparent",whiteSpace:"nowrap"});
  return(
    <div>
      <SectionHdr title="Match report" sub="Select top 3 performers, enter highlights, then save both PDFs."/>
      <AlertBox type="red" msg={err} onClose={()=>setErr("")}/>
      <div style={cs.card}><div style={{fontSize:15,fontWeight:700,color:"#1a1a1a",marginBottom:10}}>Highlights</div>
        <label style={cs.label}>Team 1 highlights</label><textarea style={{...cs.textarea,marginBottom:10}} value={hiOwn} onChange={e=>setHiOwn(e.target.value)} placeholder="Key moments, sportsmanship…" rows={3} readOnly={reportLocked}/>
        <label style={cs.label}>Team 2 highlights</label><textarea style={cs.textarea} value={hiOpp} onChange={e=>setHiOpp(e.target.value)} placeholder="Notable moments from the opposing team…" rows={3} readOnly={reportLocked}/>
      </div>
      <div style={cs.card}>
        <div style={{fontSize:15,fontWeight:700,color:"#1a1a1a",marginBottom:4}}>Select top 3 performers</div>
        <div style={{fontSize:13,fontWeight:600,color:"#1a1a1a",marginBottom:12}}>{top3.size} of 3 selected — tick from any table below</div>
        <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:6,paddingBottom:4,borderBottom:"1px solid rgba(0,0,0,0.12)"}}>Batters — by runs</div>
        <div style={{overflowX:"auto",marginBottom:14}}><table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed",minWidth:480}}>
          <thead><tr><th style={{...th,width:28}}></th><th style={{...th,width:160}}>Player</th><th style={th}>Runs</th><th style={th}>Balls</th><th style={th}>SR</th><th style={th}>Dots%</th><th style={th}>Status</th></tr></thead>
          <tbody>{bats.length===0?<tr><td colSpan={7} style={{padding:"8px",color:"#6b7280",fontSize:12}}>No batting data yet.</td></tr>:bats.map(p=>{const sel=top3.has(p.id),sr=p.balls>0?Math.round(p.runs/p.balls*100):0,dp=p.balls>0?Math.round(p.dots/p.balls*100):0;return(<tr key={p.id} style={{cursor:reportLocked?"default":"pointer"}} onClick={()=>!reportLocked&&toggleTop3(p.id)}><td style={td(sel)}><input type="checkbox" checked={sel} onChange={()=>toggleTop3(p.id)} style={{accentColor:G,cursor:"pointer"}} onClick={e=>e.stopPropagation()} disabled={reportLocked}/></td><td style={{...td(sel),fontWeight:500}}>{p.name}</td><td style={td(sel)}>{p.runs}</td><td style={td(sel)}>{p.balls}</td><td style={td(sel)}>{sr}</td><td style={td(sel)}>{dp}%</td><td style={td(sel)}>{p.status}</td></tr>);})}</tbody>
        </table></div>
        <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:6,paddingBottom:4,borderBottom:"1px solid rgba(0,0,0,0.12)"}}>Bowlers — by wickets</div>
        <div style={{overflowX:"auto",marginBottom:14}}><table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed",minWidth:680}}>
          <thead><tr><th style={{...th,width:28}}></th><th style={{...th,width:140}}>Player</th><th style={th}>Ov</th><th style={th}>Runs</th><th style={th}>Wkts</th><th style={th}>Econ</th><th style={th}>Wd</th><th style={th}>Nb</th><th style={th}>GD%</th><th style={th}>SH%</th><th style={th}>FT%</th><th style={th}>OP%</th></tr></thead>
          <tbody>{bowls.length===0?<tr><td colSpan={12} style={{padding:"8px",color:"#6b7280",fontSize:12}}>No bowling data yet.</td></tr>:bowls.map(p=>{const sel=top3.has(p.id),e=p.overs>0?(p.runs/p.overs).toFixed(1):"-",lt=p.fullToss+p.overpitch+p.short+p.good,pf=n=>lt>0?Math.round(n/lt*100)+"%":"-";return(<tr key={p.id} style={{cursor:reportLocked?"default":"pointer"}} onClick={()=>!reportLocked&&toggleTop3(p.id)}><td style={td(sel)}><input type="checkbox" checked={sel} onChange={()=>toggleTop3(p.id)} style={{accentColor:G}} onClick={e=>e.stopPropagation()} disabled={reportLocked}/></td><td style={{...td(sel),fontWeight:500}}>{p.name}</td><td style={td(sel)}>{p.overs}</td><td style={td(sel)}>{p.runs}</td><td style={td(sel)}>{p.wickets}</td><td style={td(sel)}>{e}</td><td style={td(sel)}>{p.wides}</td><td style={td(sel)}>{p.noBalls}</td><td style={td(sel)}>{pf(p.good)}</td><td style={td(sel)}>{pf(p.short)}</td><td style={td(sel)}>{pf(p.fullToss)}</td><td style={td(sel)}>{pf(p.overpitch)}</td></tr>);})}</tbody>
        </table></div>
        <div style={{fontSize:14,fontWeight:700,color:"#1a1a1a",marginBottom:6,paddingBottom:4,borderBottom:"1px solid rgba(0,0,0,0.12)"}}>Fielders — by catches</div>
        <div style={{overflowX:"auto"}}><table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed",minWidth:560}}>
          <thead><tr><th style={{...th,width:28}}></th><th style={{...th,width:140}}>Player</th><th style={th}>C</th><th style={th}>ROs</th><th style={th}>Stump</th><th style={th}>Miss C</th><th style={th}>Miss RO</th><th style={th}>Miss St</th><th style={th}>Sports</th></tr></thead>
          <tbody>{fields.length===0?<tr><td colSpan={9} style={{padding:"8px",color:"#6b7280",fontSize:12}}>No fielding data yet.</td></tr>:fields.map(p=>{const sel=top3.has(p.id);return(<tr key={p.id} style={{cursor:reportLocked?"default":"pointer"}} onClick={()=>!reportLocked&&toggleTop3(p.id)}><td style={td(sel)}><input type="checkbox" checked={sel} onChange={()=>toggleTop3(p.id)} style={{accentColor:G}} onClick={e=>e.stopPropagation()} disabled={reportLocked}/></td><td style={{...td(sel),fontWeight:500}}>{p.name}</td><td style={td(sel)}>{p.catches}</td><td style={td(sel)}>{p.runouts}</td><td style={td(sel)}>{p.stumpings}</td><td style={td(sel)}>{p.missedCatch}</td><td style={td(sel)}>{p.missedRunout}</td><td style={td(sel)}>{p.missedStumping}</td><td style={td(sel)}>{p.sports}</td></tr>);})}</tbody>
        </table></div>
      </div>
      <div style={cs.card}><div style={{fontSize:15,fontWeight:700,color:"#1a1a1a",marginBottom:8}}>Opponent top 3</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
          <div><label style={cs.label}>1st</label><input style={cs.input} value={opp1} onChange={e=>setOpp1(e.target.value)} readOnly={reportLocked}/></div>
          <div><label style={cs.label}>2nd</label><input style={cs.input} value={opp2} onChange={e=>setOpp2(e.target.value)} readOnly={reportLocked}/></div>
          <div><label style={cs.label}>3rd</label><input style={cs.input} value={opp3} onChange={e=>setOpp3(e.target.value)} readOnly={reportLocked}/></div>
        </div>
      </div>
      {!matchFrozen&&user.role==="COACH"&&<div style={{background:"#faeeda",border:"1px solid #FAC775",borderRadius:10,padding:"14px 16px",marginBottom:12}}>
        <div style={{fontSize:14,fontWeight:700,color:"#854F0B",marginBottom:6}}>Finalise this match</div>
        <div style={{fontSize:13,color:"#854F0B",marginBottom:10}}>Once frozen, Batting, Bowling and Fielding data cannot be changed. Notes and report text remain editable.</div>
        <button style={{...cs.btnP,background:"#854F0B"}} onClick={onFreeze}>Freeze match data</button>
      </div>}
      {matchFrozen&&user.role==="COACH"&&<div style={{background:"#f0faf4",border:"1px solid #9FE1CB",borderRadius:10,padding:"10px 16px",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
          <div style={{fontSize:13,fontWeight:700,color:G}}>Match data is frozen — Batting, Bowling and Fielding are locked.</div>
          {!showUnfreeze&&<button style={{...cs.btnG,fontSize:12,color:"#854F0B",borderColor:"#FAC775"}} onClick={()=>setShowUnfreeze(true)}>Unfreeze…</button>}
        </div>
        {showUnfreeze&&<div style={{marginTop:10,borderTop:"0.5px solid #9FE1CB",paddingTop:10}}>
          <div style={{fontSize:12,color:"#854F0B",marginBottom:6}}>Enter your Admin code to unfreeze. This re-enables editing of Batting, Bowling and Fielding data.</div>
          <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
            <input style={{...cs.input,width:140,textTransform:"uppercase",letterSpacing:"0.1em",fontFamily:"monospace"}} value={unfreezeCode} onChange={e=>setUnfreezeCode(e.target.value.toUpperCase())} placeholder="ORG-XXXXXX" autoFocus/>
            <button style={{...cs.btnP,background:"#854F0B",opacity:unfreezeBusy?.5:1}} disabled={unfreezeBusy} onClick={doUnfreeze}>{unfreezeBusy?"Checking…":"Confirm unfreeze"}</button>
            <button style={cs.btnG} onClick={()=>{setShowUnfreeze(false);setUnfreezeCode("");setUnfreezeErr("");}}>Cancel</button>
          </div>
          {unfreezeErr&&<div style={{fontSize:12,color:"#A32D2D",marginTop:6}}>{unfreezeErr}</div>}
        </div>}
      </div>}
      {matchFrozen&&user.role!=="COACH"&&<div style={{background:"#f0faf4",border:"1px solid #9FE1CB",borderRadius:10,padding:"10px 16px",marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:700,color:G}}>Match data is frozen — Batting, Bowling and Fielding are locked.</div>
      </div>}
      {user.role==="COACH"&&<div style={{...cs.card,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:12}}>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a",marginBottom:2}}>Report lock</div>
          <div style={{fontSize:12,color:"#6b7280"}}>{reportLocked?"Report is locked — tap Unlock to edit fields.":"Unlocked — tap Lock to prevent accidental edits."}</div>
        </div>
        <button style={{...cs.btnS,borderColor:reportLocked?"#A32D2D":G,color:reportLocked?"#A32D2D":G,minWidth:100}} onClick={onToggleReportLock}>{reportLocked?"Unlock report":"Lock report"}</button>
      </div>}
      {reportLocked&&<div style={{background:"#f8f9f7",border:"0.5px solid rgba(0,0,0,0.10)",borderRadius:8,padding:"8px 14px",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:18}}>🔒</span>
        <span style={{fontSize:12,color:"#6b7280"}}>Report is locked. Preview and PDF export are still available. Unlock to edit.</span>
      </div>}
      <div style={cs.card}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,flexWrap:"wrap",gap:8}}>
          <div style={{fontSize:15,fontWeight:700,color:"#1a1a1a"}}>Preview &amp; export</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button style={cs.btnS} onClick={()=>setPreview(buildText("match"))}>Preview match report</button>
            <button style={{...cs.btnS,opacity:isOpen?.4:1,cursor:isOpen?"not-allowed":"pointer"}} onClick={()=>!isOpen&&setPreview(buildText("hub"))} title={isOpen?"Hub Reports are only available for Hub Matches":undefined}>Preview HUB report{isOpen?" (Hub only)":""}</button>
          </div>
        </div>
        {preview&&<pre style={{fontFamily:"'DM Mono','Courier New',monospace",fontSize:11,background:"#f8f9f7",borderRadius:8,padding:14,whiteSpace:"pre-wrap",color:"#1a1a1a",lineHeight:1.6,border:"0.5px solid rgba(0,0,0,0.08)",maxHeight:340,overflowY:"auto",marginBottom:12}}>{preview}</pre>}
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button style={cs.btnP} onClick={()=>savePDF("match")}>Save match report PDF</button>
          <button style={{...cs.btnD,opacity:isOpen?.4:1,cursor:isOpen?"not-allowed":"pointer"}} onClick={()=>!isOpen&&savePDF("hub")} title={isOpen?"Hub Reports are only available for Hub Matches":undefined}>Save HUB report PDF{isOpen?" (Hub only)":""}</button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// ROOT APP
// ═══════════════════════════════════════════════════════════════════════════════
export default function App(){
  // Restore session from sessionStorage on mount
  const [user,          setUser]          = useState(()=>{
    try{
      const s=localStorage.getItem("ck_session");
      if(s){const p=JSON.parse(s);if(p?.user?.email&&p?.user?.orgId)return p.user;}
    }catch{}
    return null;
  });
  const [activeTab,     setActiveTab]     = useState(()=>{
    try{
      const s=localStorage.getItem("ck_session");
      if(s){const p=JSON.parse(s);if(p?.user?.role){const nav={"COACH":"schedule","MANAGER":"schedule","PLAYER":"player","SUPERADMIN":"superadmin"};return nav[p.user.role]||"schedule";}}
    }catch{}
    return "schedule";
  });
  const [activeMatchId, setActiveMatchId] = useState(()=>{
    try{
      const s=localStorage.getItem("ck_session");
      if(s){const p=JSON.parse(s);return p?.activeMatchId||null;}
    }catch{}
    return null;
  });
  const [matches,       setMatches]       = useState([]);
  const [teamMeta,      setTeamMeta]      = useState({teamName:"",ageCategory:"U13",tournament:"",coachName:"",coachEmail:"",managerName:"",managerEmail:""});
  const [squad,         setSquad]         = useState([]);
  const [selected,      setSelected]      = useState(new Set());
  const [teamSheet,     setTeamSheet]     = useState([]);
  const [teamLocked,    setTeamLocked]    = useState(false);
  const [teamAssigned,  setTeamAssigned]  = useState(false);  // Step 1: squad assigned
  const [teamAssignedBy,setTeamAssignedBy]= useState(null);   // who assigned it
  const [batting,       setBatting]       = useState({});
  const [bowling,       setBowling]       = useState({});
  const [fielding,      setFielding]      = useState({});
  const [notes,         setNotes]         = useState([]);
  const [logistics,     setLogistics]     = useState({});
  const [saveMsg,       setSaveMsg]       = useState("");
  const [hubRules,      setHubRules]      = useState({});
  const [matchFrozen,   setMatchFrozen]   = useState(false);
  const [reportLocked,  setReportLocked]  = useState(false);
  const [reportData,    setReportData]    = useState({hiOwn:"",hiOpp:"",top3:[],opp1:"",opp2:"",opp3:""});
  const [activeBatter,  setActiveBatter]  = useState("");  // app-level — persists across tab switches
  const [activeBowler,  setActiveBowler]  = useState("");  // app-level — persists across tab switches
  const logTimer = useRef(null);
  // Persist session to localStorage so page reload/iOS tab kill restores coach automatically
  useEffect(()=>{
    if(!user) return;
    try{ localStorage.setItem("ck_session", JSON.stringify({user, activeMatchId})); }catch{}
  },[user, activeMatchId]);
  const [orgPlan, setOrgPlan] = useState("FREE");

  // ── API helper ───────────────────────────────────────────────────────────
  const apiFetch = useCallback(async(path,method="GET",body=null,returnError=false)=>{
    if(!API||!user){if(returnError)return{_err:"No API URL configured"};return null;}
    try{
      const opts={method,headers:{"Content-Type":"application/json","x-org-id":user.orgId,"x-user-email":user.email}};
      if(body) opts.body=JSON.stringify(body);
      const r=await fetch(API+path,opts);
      if(!r.ok){
        const errText=await r.text();
        console.error("apiFetch error:",method,path,r.status,errText);
        if(returnError)return{_err:`HTTP ${r.status}: ${errText}`};
        return null;
      }
      return r.status===204?null:r.json();
    }catch(e){
      console.error("apiFetch exception:",method,path,e.message);
      if(returnError)return{_err:e.message};
      return null;
    }
  },[user]);

  function showSave(msg="Saved ✓"){setSaveMsg(msg);setTimeout(()=>setSaveMsg(""),2500);}

  // ── load on login ─────────────────────────────────────────────────────────
  useEffect(()=>{
    if(!user||!API) return;
    Promise.all([
      apiFetch("/crickithub/matches"),
      apiFetch("/crickithub/teams/current"),
      apiFetch("/crickithub/squad"),
      apiFetch("/crickithub/hubrules"),
      apiFetch("/crickithub/myplan"),
    ]).then(([md,td,sq,hr,plan])=>{
      if(md?.matches){
        // Mark which matches have recorded data (by checking if log key was written)
        // We do a lightweight check — if the match was ever active it likely has data
        // Full check happens in deleteMatch. For display we use a heuristic:
        // matches that are frozen definitely have data
        setMatches(md.matches.map(m=>({...m,_hasData:!!m.frozen||!!m._hasData})));
      }
      if(td?.teamMeta) setTeamMeta(td.teamMeta);
      if(sq?.squad) setSquad(sq.squad);
      if(hr?.rules) setHubRules(hr.rules);
      if(plan) setOrgPlan(plan.analyticsUnlocked&&plan.plan!=="SUSPENDED"?"PAID":(plan.plan||"FREE"));
      if(plan?.canSeeAdminCode) setCanSeeAdminCode(true);
    });
  },[user]);

  // ── load per-match data ───────────────────────────────────────────────────
  useEffect(()=>{
    if(!user||!activeMatchId||!API) return;
    Promise.all([
      apiFetch(`/crickithub/matches/${activeMatchId}/teamsheet`),
      apiFetch(`/crickithub/matches/${activeMatchId}/log`),
      apiFetch(`/crickithub/matches/${activeMatchId}/notes`),
      apiFetch(`/crickithub/matches/${activeMatchId}/logistics`),
      apiFetch(`/crickithub/matches/${activeMatchId}/report`),
    ]).then(([ts,log,n,logi,rep])=>{
      if(ts)  {
        setTeamSheet(ts.players||[]);setTeamLocked(!!ts.locked);setTeamAssigned(!!ts.assigned);setTeamAssignedBy(ts.assignedBy||null);setMatchFrozen(!!ts.frozen);
        if(ts.players?.length)setSelected(new Set(ts.players.map(p=>p.id)));
        // If teamsheet is frozen but match record doesn't have frozen:true yet (pre-v3.65 data),
        // write it back to the match record now and update local state
        if(ts.frozen){
          const mRec=matches.find(m=>m.matchId===activeMatchId);
          if(mRec&&!mRec.frozen){
            apiFetch(`/crickithub/matches/${activeMatchId}`,"PUT",{...mRec,frozen:true});
            setMatches(ms=>ms.map(m=>m.matchId===activeMatchId?{...m,frozen:true,_hasData:true}:m));
          }
        }
      }
      const matchRec=matches.find(m=>m.matchId===activeMatchId);
      setReportLocked(!!matchRec?.reportLocked);
      if(log) {setBatting(log.batting||{});setBowling(log.bowling||{});setFielding(log.fielding||{});}
      if(n)   {setNotes(n.notes||[]);}
      if(logi){setLogistics(logi);}
      if(rep) {setReportData({hiOwn:rep.hiOwn||"",hiOpp:rep.hiOpp||"",top3:rep.top3||[],opp1:rep.opp1||"",opp2:rep.opp2||"",opp3:rep.opp3||""});}
    });
  },[user,activeMatchId]);

  // ── auto-save report data after 1s idle ─────────────────────────────────────
  const reportTimer = useRef(null);
  useEffect(()=>{
    if(!user||!activeMatchId) return;
    if(!reportData.hiOwn&&!reportData.hiOpp&&!reportData.top3?.length&&!reportData.opp1) return;
    clearTimeout(reportTimer.current);
    reportTimer.current=setTimeout(()=>apiFetch(`/crickithub/matches/${activeMatchId}/report`,"PUT",reportData),1500);
    return()=>clearTimeout(reportTimer.current);
  },[reportData]);

  // ── auto-save batting/bowling/fielding after 2s idle ──────────────────────
  useEffect(()=>{
    if(!user||!activeMatchId) return;
    const hasData=Object.keys(batting).length||Object.keys(bowling).length||Object.keys(fielding).length;
    if(!hasData) return;
    clearTimeout(logTimer.current);
    logTimer.current=setTimeout(()=>apiFetch(`/crickithub/matches/${activeMatchId}/log`,"PUT",{batting,bowling,fielding}),2000);
    return()=>clearTimeout(logTimer.current);
  },[batting,bowling,fielding]);

  const [showProfile,setShowProfile]=useState(false);
  const [showAdminModal,setShowAdminModal]=useState(false);
  const [showMenu,setShowMenu]=useState(false);
  const menuRef=useRef(null);
  useEffect(()=>{
    if(!showMenu)return;
    function handleClickOutside(e){if(menuRef.current&&!menuRef.current.contains(e.target))setShowMenu(false);}
    document.addEventListener("mousedown",handleClickOutside);
    document.addEventListener("touchstart",handleClickOutside);
    return()=>{document.removeEventListener("mousedown",handleClickOutside);document.removeEventListener("touchstart",handleClickOutside);};
  },[showMenu]);
  const [canSeeAdminCode,setCanSeeAdminCode]=useState(false);
  const [cpOld,setCpOld]=useState("");
  const [cpNew,setCpNew]=useState("");
  const [cpConfirm,setCpConfirm]=useState("");
  const [cpMsg,setCpMsg]=useState({msg:"",type:"green"});
  const [cpBusy,setCpBusy]=useState(false);

  function login(u) {
    setUser(u);
    setActiveTab(NAV[u.role]?.[0]?.id||"schedule");
    // Persist to localStorage so coach is restored after tab close/reload
    try{ localStorage.setItem("ck_session", JSON.stringify({user:u, activeMatchId:null})); }catch{}
  }
  function logout(){
    clearTimeout(logTimer.current);
    clearTimeout(reportTimer.current);
    try{ localStorage.removeItem("ck_session"); }catch{}
    setUser(null);setMatches([]);setSquad([]);setTeamMeta({teamName:"",ageCategory:"U13",tournament:"",coachName:"",coachEmail:"",managerName:"",managerEmail:""});
    setBatting({});setBowling({});setFielding({});setTeamSheet([]);setTeamLocked(false);setTeamAssigned(false);setTeamAssignedBy(null);
    setSelected(new Set());setNotes([]);setLogistics({});setActiveMatchId(null);
    setMatchFrozen(false);setReportLocked(false);setReportData({hiOwn:"",hiOpp:"",top3:[],opp1:"",opp2:"",opp3:""});
    setHubRules({});setOrgPlan("FREE");setSaveMsg("");setShowProfile(false);setShowMenu(false);setShowAdminModal(false);
    setCanSeeAdminCode(false);
  }

  async function changePassword(){
    if(!cpOld||!cpNew||!cpConfirm){setCpMsg({msg:"All fields required.",type:"red"});return;}
    if(cpNew!==cpConfirm){setCpMsg({msg:"New passwords do not match.",type:"red"});return;}
    if(cpNew.length<6){setCpMsg({msg:"New password must be at least 6 characters.",type:"red"});return;}
    setCpBusy(true);setCpMsg({msg:"",type:"green"});
    const r=await apiFetch("/crickithub/auth/change-password","POST",{email:user.email,oldPassword:cpOld,newPassword:cpNew,orgId:user.orgId},true);
    setCpBusy(false);
    if(r&&!r._err){setCpMsg({msg:"Password changed successfully.",type:"green"});setCpOld("");setCpNew("");setCpConfirm("");}
    else{setCpMsg({msg:"Failed: "+(r?._err||"Current password may be incorrect."),type:"red"});}
  }
  function selectMatch(id){setActiveMatchId(id);setBatting({});setBowling({});setFielding({});setTeamSheet([]);setTeamLocked(false);setMatchFrozen(false);setReportLocked(false);setSelected(new Set());setNotes([]);setLogistics({});setReportData({hiOwn:"",hiOpp:"",top3:[],opp1:"",opp2:"",opp3:""});setActiveBatter("");setActiveBowler("");}

  async function saveLog(){
    if(!activeMatchId){showSave("No active match");return;}
    const r=await apiFetch(`/crickithub/matches/${activeMatchId}/log`,"PUT",{batting,bowling,fielding},true);
    if(r&&!r._err) showSave("Match data saved ✓");
    else showSave("Save failed — check connection");
  }
  async function saveTeamMeta(data){const d=data||teamMeta;setTeamMeta(d);await apiFetch("/crickithub/teams/current","PUT",d);showSave();}
  async function saveSquad(sq){
    const r=await apiFetch("/crickithub/squad","PUT",{squad:sq});
    // Lambda returns squad with generated access codes — sync back to state
    if(r?.squad) setSquad(r.squad);
    showSave("Squad saved ✓");
  }
  async function saveHubRules(rules){setHubRules(rules);await apiFetch("/crickithub/hubrules","PUT",{rules});showSave("Hub rules saved ✓");}
  async function freezeMatch(){
    if(!activeMatchId)return;
    if(!window.confirm("Freeze this match? Batting, Bowling and Fielding data will be locked and cannot be changed. Notes and Match Report can still be edited."))return;
    await apiFetch(`/crickithub/matches/${activeMatchId}/teamsheet`,"PUT",{players:teamSheet,locked:true,frozen:true});
    await apiFetch(`/crickithub/matches/${activeMatchId}`,"PUT",{...matches.find(m=>m.matchId===activeMatchId),frozen:true});
    setMatchFrozen(true);
    setMatches(ms=>ms.map(m=>m.matchId===activeMatchId?{...m,frozen:true,_hasData:true}:m));
    showSave("Match frozen ✓");
  }
  async function unfreezeMatch(adminCode){
    if(!activeMatchId) return {error:"No active match."};
    const r=await apiFetch(`/crickithub/matches/${activeMatchId}/unfreeze`,"POST",{adminCode:adminCode.trim().toUpperCase()});
    if(!r?.ok) return {error:r?.message||"Incorrect admin code."};
    setMatchFrozen(false);
    setReportLocked(false);
    setMatches(ms=>ms.map(m=>m.matchId===activeMatchId?{...m,frozen:false,reportLocked:false}:m));
    showSave("Match unfrozen ✓");
    return {ok:true};
  }
  async function toggleReportLock(){
    if(!activeMatchId)return;
    const next=!reportLocked;
    await apiFetch(`/crickithub/matches/${activeMatchId}`,"PUT",{reportLocked:next});
    setReportLocked(next);
    setMatches(ms=>ms.map(m=>m.matchId===activeMatchId?{...m,reportLocked:next}:m));
    showSave(next?"Report locked":"Report unlocked");
  }
  async function saveTeamSheet(players,mode="confirm",assignedBy=null){
    if(!activeMatchId) return;
    if(mode==="assign"){
      await apiFetch(`/crickithub/matches/${activeMatchId}/teamsheet`,"PUT",{players,locked:false,assigned:true,assignedBy});
      setTeamAssigned(true);setTeamAssignedBy(assignedBy);setTeamSheet(players);
    } else {
      await apiFetch(`/crickithub/matches/${activeMatchId}/teamsheet`,"PUT",{players,locked:true,assigned:true,assignedBy});
      setTeamAssigned(true);setTeamLocked(true);setTeamSheet(players);
    }
    showSave(mode==="assign"?"Team assigned ✓":"Team confirmed ✓");
  }
  async function saveLogistics(){if(!activeMatchId)return;await apiFetch(`/crickithub/matches/${activeMatchId}/logistics`,"PUT",logistics);showSave();}
  async function handleNotes(ns){setNotes(ns);if(activeMatchId)await apiFetch(`/crickithub/matches/${activeMatchId}/notes`,"PUT",{notes:ns});}
  async function saveMatch(m){await apiFetch("/crickithub/matches","POST",m);showSave();}
  async function updateMatch(m){await apiFetch(`/crickithub/matches/${m.matchId}`,"PUT",m);setMatches(ms=>ms.map(x=>x.matchId===m.matchId?m:x));showSave();}
  async function deleteMatch(matchId,mode="inactivate"){
    if(mode==="inactivate"){
      // Check if match has any data before inactivating
      const log=await apiFetch(`/crickithub/matches/${matchId}/log`);
      const hasAnyData=log&&(Object.keys(log.batting||{}).length||Object.keys(log.bowling||{}).length||Object.keys(log.fielding||{}).length);
      if(hasAnyData){
        alert("Data has been recorded for this match. Use Freeze in the Match Report tab to lock it instead of inactivating.");
        return;
      }
      await apiFetch(`/crickithub/matches/${matchId}`,"PUT",{inactive:true});
      setMatches(ms=>ms.map(x=>x.matchId===matchId?{...x,inactive:true}:x));
    } else {
      await apiFetch(`/crickithub/matches/${matchId}`,"DELETE");
      setMatches(ms=>ms.filter(x=>x.matchId!==matchId));
    }
    if(activeMatchId===matchId)setActiveMatchId(null);
  }

  if(!user) return <Login onLogin={login}/>;

  const tabs=NAV[user.role]||[];
  const activeMatch=matches.find(m=>m.matchId===activeMatchId);

  const page=()=>{
    switch(activeTab){
      case "admin":     return <SuperAdmin apiFetch={apiFetch}/>;
      case "schedule":  return <Schedule user={user} matches={matches} setMatches={setMatches} selectedMatchId={activeMatchId} onSelectMatch={selectMatch} onSaveMatch={saveMatch} onUpdateMatch={updateMatch} onDeleteMatch={deleteMatch} teamMeta={teamMeta} setTeamMeta={setTeamMeta} onSaveTeamMeta={saveTeamMeta} matchFrozen={matchFrozen} apiFetch={apiFetch}/>;
      case "squad":     return <TeamAssembly user={user} squad={squad} setSquad={setSquad} selected={selected} setSelected={setSelected} teamSheet={teamSheet} setTeamSheet={setTeamSheet} teamLocked={teamLocked} setTeamLocked={setTeamLocked} teamAssigned={teamAssigned} setTeamAssigned={setTeamAssigned} teamAssignedBy={teamAssignedBy} onConfirm={saveTeamSheet} onSaveSquad={saveSquad} matchFrozen={matchFrozen} matches={matches} activeMatchId={activeMatchId} onSelectMatch={selectMatch} apiFetch={apiFetch}/>;
      case "hubrules":  return <HubRules user={user} hubRules={hubRules} setHubRules={setHubRules} onSave={saveHubRules} saveMsg={saveMsg} matches={matches}/>;
      case "batting":   return <BattingTracker user={user} teamSheet={teamSheet} batting={batting} setBatting={setBatting} onSave={saveLog} saveMsg={saveMsg} matchFrozen={matchFrozen} hubRules={hubRules} matchType={activeMatch?.matchType} activeBatter={activeBatter} setActiveBatter={setActiveBatter}/>;
      case "bowling":   return <BowlingTracker user={user} teamSheet={teamSheet} bowling={bowling} setBowling={setBowling} onSave={saveLog} saveMsg={saveMsg} matchFrozen={matchFrozen} hubRules={hubRules} matchType={activeMatch?.matchType} activeBowler={activeBowler} setActiveBowler={setActiveBowler}/>;
      case "fielding":  return <FieldingLog user={user} teamSheet={teamSheet} fielding={fielding} setFielding={setFielding} onSave={saveLog} saveMsg={saveMsg} matchFrozen={matchFrozen}/>;
      case "orgadmin":  return <OrgAdmin user={user} teamMeta={teamMeta} setTeamMeta={setTeamMeta} onSaveTeamMeta={saveTeamMeta} saveMsg={saveMsg} apiFetch={apiFetch} canSeeAdminCode={canSeeAdminCode}/>;
      case "notes":     return <CoachNotes user={user} teamSheet={teamSheet} notes={notes} setNotes={handleNotes}/>;
      case "logistics": return <Logistics user={user} logistics={logistics} setLogistics={setLogistics} onSave={saveLogistics} saveMsg={saveMsg}/>;
      case "players":   return <PlayerPortal user={user} teamSheet={teamSheet} matches={matches} notes={notes}/>;
      case "portal":    return <PlayerPortal user={user} teamSheet={teamSheet} matches={matches} notes={notes} orgPlan={orgPlan} apiFetch={apiFetch}/>;
      case "report":    return <MatchReport user={user} teamMeta={teamMeta} batting={batting} bowling={bowling} fielding={fielding} teamSheet={teamSheet} activeMatch={activeMatch} notes={notes} matchFrozen={matchFrozen} onFreeze={freezeMatch} onUnfreeze={unfreezeMatch} reportData={reportData} onReportChange={setReportData} matchType={activeMatch?.matchType} reportLocked={reportLocked} onToggleReportLock={toggleReportLock} hubRules={hubRules}/>;
      case "season":    return <SeasonAnalytics user={user} matches={matches} orgPlan={orgPlan} apiFetch={apiFetch}/>;
      case "profile":   return <ProfilePage/>;
      default:          return null;
    }
  };

  function ProfilePage(){
    const [phone,setPhone]=useState(user.phone||"");
    const [phoneSaved,setPhoneSaved]=useState(false);
    const [subStatus,setSubStatus]=useState(null);
    const [portalBusy,setPortalBusy]=useState(false);
    const [ceStep,setCeStep]=useState(0);
    const [ceNew,setCeNew]=useState("");
    const [cePass,setCePass]=useState("");
    const [ceCode,setCeCode]=useState("");
    const [ceBusy,setCeBusy]=useState(false);
    const [ceMsgErr,setCeMsgErr]=useState("");
    useEffect(()=>{
      if(user.role==="COACH"||user.role==="MANAGER"){
        apiFetch("/crickithub/stripe/status")
          .then(d=>{if(d)setSubStatus(d);})
          .catch(()=>setSubStatus({status:"no_stripe",trialActive:false}));
      }
    },[]);
    async function openPortal(){
      setPortalBusy(true);
      const r=await apiFetch("/crickithub/stripe/portal","POST",{returnUrl:window.location.href});
      setPortalBusy(false);
      if(r?.url)window.open(r.url,"_blank");
      else alert("No active subscription found.");
    }
    async function savePhone(){
      if(!user.orgId) return;
      await apiFetch(`/crickithub/org/admin/staff/${encodeURIComponent(user.email)}/phone`,"PUT",{phone:phone.trim()});
      setPhoneSaved(true);setTimeout(()=>setPhoneSaved(false),2500);
    }
    return(
      <div>
        <SectionHdr title="My profile" sub="Your account details and password management."/>
        <div style={{...cs.card,maxWidth:440}}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:4}}>Account details</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:12}}>{user.role==="MANAGER"?"Manager account.":user.role==="COACH"?"Coach account.":"Player account."}</div>
          {[["Name",user.name],["Email",user.email],["Role",user.role==="COACH"?"Coach":user.role==="MANAGER"?"Manager":user.role],["Org ID",user.orgId]].map(([l,v])=>(
            <div key={l} style={{display:"flex",gap:16,padding:"6px 0",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontSize:13}}>
              <span style={{...cs.muted,minWidth:80}}>{l}</span><span style={{fontWeight:500}}>{v}</span>
            </div>
          ))}
        </div>

        {/* ── Subscription card — Coach and Manager only ── */}
        {(user.role==="COACH"||user.role==="MANAGER")&&<div style={{...cs.card,maxWidth:440}}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:8}}>Subscription</div>
          {!subStatus
            ?<div style={cs.muted}>Checking subscription…</div>
            :subStatus.status==="no_subscription"||subStatus.status==="no_stripe"
              ?<div style={{fontSize:13,color:"#6b7280"}}>No active subscription — Free plan.</div>
              :<div>
                {[
                  ["Status",    <span style={{fontWeight:700,color:subStatus.trialActive?G:subStatus.status==="active"?G:"#E24B4A",textTransform:"capitalize"}}>{subStatus.trialActive?"Free trial active":subStatus.status}</span>],
                  subStatus.daysLeft!=null&&["Days remaining", subStatus.daysLeft+" days"],
                  subStatus.trialEnd&&["Trial ends",    new Date(subStatus.trialEnd).toLocaleDateString()],
                  !subStatus.trialActive&&subStatus.currentPeriodEnd&&["Next billing",  new Date(subStatus.currentPeriodEnd).toLocaleDateString()],
                ].filter(Boolean).map(([l,v])=>(
                  <div key={l} style={{display:"flex",gap:12,padding:"6px 0",borderBottom:"0.5px solid rgba(0,0,0,0.06)",fontSize:13}}>
                    <span style={{...cs.muted,minWidth:120}}>{l}</span>
                    <span style={{fontWeight:500}}>{v}</span>
                  </div>
                ))}
                <button style={{...cs.btnS,marginTop:12,opacity:portalBusy?.6:1}} onClick={openPortal} disabled={portalBusy}>
                  {portalBusy?"Opening…":"Manage subscription →"}
                </button>
                <div style={{fontSize:11,color:"#9ca3af",marginTop:6}}>Update payment method, view invoices or cancel</div>
              </div>}
        </div>}

        <div style={{...cs.card,maxWidth:440}}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:4}}>Phone number</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:10}}>Optional. Used for match notifications when enabled. You can update this at any time.</div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <input type="tel" style={{...cs.input,flex:1}} value={phone} onChange={e=>setPhone(e.target.value)} placeholder="+1 (555) 000-0000"/>
            <button style={{...cs.btnP,opacity:phone===user.phone?.4:1}} onClick={savePhone}>Save</button>
            {phoneSaved&&<span style={{fontSize:12,color:G}}>Saved ✓</span>}
          </div>
        </div>
        <div style={{...cs.card,maxWidth:440}}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:4}}>Change password</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:12}}>You can change your own password here at any time. You will need your current password.</div>
          {cpMsg.msg&&<AlertBox type={cpMsg.type} msg={cpMsg.msg} onClose={()=>setCpMsg({msg:"",type:"green"})}/>}
          <div style={{marginBottom:10}}><label style={cs.label}>Current password</label><input type="password" style={cs.input} value={cpOld} onChange={e=>setCpOld(e.target.value)} placeholder="Enter current password"/></div>
          <div style={{marginBottom:10}}><label style={cs.label}>New password</label><input type="password" style={cs.input} value={cpNew} onChange={e=>setCpNew(e.target.value)} placeholder="Min 6 characters"/></div>
          <div style={{marginBottom:14}}><label style={cs.label}>Confirm new password</label><input type="password" style={cs.input} value={cpConfirm} onChange={e=>setCpConfirm(e.target.value)} placeholder="Repeat password"/></div>
          <button style={{...cs.btnP,opacity:cpBusy?.6:1}} onClick={changePassword} disabled={cpBusy}>{cpBusy?"Updating…":"Change password"}</button>
        </div>

        {/* ── Change email ── */}
        {(user.role==="COACH"||user.role==="MANAGER")&&<div style={{...cs.card,maxWidth:440}}>
          <div style={{fontSize:13,fontWeight:500,marginBottom:4}}>Change login email</div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:12}}>A verification code will be sent to your new email address. You will need to confirm it before the change takes effect.</div>
          {ceStep===0&&<div>
            {ceMsgErr&&<AlertBox type="red" msg={ceMsgErr} onClose={()=>setCeMsgErr("")}/>}
            <div style={{marginBottom:10}}><label style={cs.label}>New email address</label><input type="email" style={cs.input} value={ceNew} onChange={e=>setCeNew(e.target.value)} placeholder="new@email.com"/></div>
            <div style={{marginBottom:14}}><label style={cs.label}>Current password (to confirm)</label><input type="password" style={cs.input} value={cePass} onChange={e=>setCePass(e.target.value)} placeholder="Your current password"/></div>
            <button style={{...cs.btnP,opacity:ceBusy?.6:1}} disabled={ceBusy} onClick={async()=>{
              if(!ceNew.trim()||!cePass){setCeMsgErr("All fields required.");return;}
              if(!ceNew.includes("@")||!ceNew.includes(".")){setCeMsgErr("Enter a valid email address.");return;}
              if(ceNew.trim().toLowerCase()===user.email.toLowerCase()){setCeMsgErr("New email must be different from your current email.");return;}
              setCeBusy(true);setCeMsgErr("");
              const r=await apiFetch("/crickithub/auth/change-email-request","POST",{currentEmail:user.email,newEmail:ceNew.trim().toLowerCase(),password:cePass,orgId:user.orgId},true);
              setCeBusy(false);
              if(r&&!r._err){setCeStep(1);}
              else{let msg=r?._err||"Request failed.";try{const j=JSON.parse(msg.replace(/^HTTP \d+: /,""));msg=j.message||msg;}catch{}setCeMsgErr(msg);}
            }}>{ceBusy?"Sending…":"Send verification code"}</button>
          </div>}
          {ceStep===1&&<div>
            {ceMsgErr&&<AlertBox type="red" msg={ceMsgErr} onClose={()=>setCeMsgErr("")}/>}
            <div style={{background:"#e6f4ec",borderRadius:8,padding:"10px 12px",fontSize:12,color:G,marginBottom:12}}>Verification code sent to <strong>{ceNew}</strong>. Check your inbox.</div>
            <div style={{marginBottom:14}}><label style={cs.label}>6-digit code</label><input type="text" style={{...cs.input,letterSpacing:"0.15em",fontFamily:"monospace"}} value={ceCode} onChange={e=>setCeCode(e.target.value)} placeholder="123456" maxLength={6}/></div>
            <button style={{...cs.btnP,opacity:ceBusy?.6:1}} disabled={ceBusy} onClick={async()=>{
              if(!ceCode.trim()){setCeMsgErr("Enter the verification code.");return;}
              setCeBusy(true);setCeMsgErr("");
              const r=await apiFetch("/crickithub/auth/change-email-confirm","POST",{currentEmail:user.email,code:ceCode.trim(),orgId:user.orgId},true);
              setCeBusy(false);
              if(r&&!r._err){alert("Email updated. Please log in with your new email address.");logout();}
              else{let msg=r?._err||"Invalid or expired code.";try{const j=JSON.parse(msg.replace(/^HTTP \d+: /,""));msg=j.message||msg;}catch{}setCeMsgErr(msg);}
            }}>{ceBusy?"Verifying…":"Confirm new email"}</button>
            <button style={{...cs.btnG,marginTop:8}} onClick={()=>{setCeStep(0);setCeCode("");setCePass("");setCeMsgErr("");}}>Start over</button>
          </div>}
        </div>}
      </div>
    );
  }

  return(
    <div style={{maxWidth:980,margin:"0 auto",paddingBottom:60,fontFamily:"'DM Sans',-apple-system,sans-serif"}}>
      {/* ── header ── */}
      <div ref={menuRef} style={{background:"linear-gradient(135deg,#0f4a2c 0%,#1A7A4A 100%)",color:"#fff",padding:"11px 14px",display:"flex",alignItems:"center",gap:10,position:"relative",boxShadow:"0 2px 8px rgba(0,0,0,0.18)"}}>
        <div style={{width:34,height:34,background:"rgba(255,255,255,0.13)",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,border:"1px solid rgba(255,255,255,0.15)"}}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="white" strokeWidth="1.5"/><path d="M6 10 Q10 6 14 10 Q10 14 6 10Z" fill="white" opacity="0.85"/></svg>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:15,fontWeight:700,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{teamMeta?.teamName||"CrickitMatch"}</div>
          <div style={{fontSize:12,fontWeight:activeMatch?700:400,color:activeMatch?"#fff":"rgba(255,255,255,0.55)",marginTop:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{activeMatch?`vs ${activeMatch.opponent||"Opponent"} · ${activeMatch.date||""}`:"Select a match from Schedule"}</div>
        </div>
        {saveMsg&&<span style={{fontSize:11,background:"rgba(255,255,255,0.2)",padding:"3px 10px",borderRadius:20,whiteSpace:"nowrap"}}>{saveMsg}</span>}
        <button onClick={()=>setShowMenu(m=>!m)} style={{background:showMenu?"rgba(255,255,255,0.3)":"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.25)",color:"#fff",padding:"7px 11px",borderRadius:7,cursor:"pointer",fontSize:16,lineHeight:1,fontFamily:"inherit",flexShrink:0}}>☰</button>

        {/* ── Hamburger dropdown ── */}
        {showMenu&&<div style={{position:"absolute",top:"100%",right:0,width:340,background:"#fff",borderRadius:"0 0 12px 12px",boxShadow:"0 8px 32px rgba(0,0,0,0.18)",zIndex:999,overflow:"hidden"}}>
          {/* menu header */}
          <div style={{background:"#f8faf9",padding:"14px 16px",borderBottom:"0.5px solid #e2e8e0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:15,fontWeight:700,color:G}}>{teamMeta?.teamName||"My org"}</div>
              <div style={{fontSize:11,color:"#6b7280",marginTop:2}}>{user.name} · {user.role==="COACH"?"Coach":user.role==="MANAGER"?"Manager":user.role} · {user.plan||"FREE"} plan</div>
            </div>
            <button onClick={()=>setShowMenu(false)} style={{width:32,height:32,background:"#f1efe8",border:"none",borderRadius:"50%",cursor:"pointer",fontSize:16,fontWeight:700,color:"#374151",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>
          {/* menu items */}
          <div style={{padding:"6px 0"}}>
            {(user.role==="COACH"||user.role==="MANAGER")&&<button onClick={()=>{setShowAdminModal(true);setShowMenu(false);}} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"11px 16px",borderBottom:"0.5px solid #f1f5f1",borderTop:"none",borderLeft:"none",borderRight:"none",background:"none",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <div style={{width:32,height:32,background:"#e6f4ec",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0}}>⚙️</div>
              <div><div style={{fontSize:13,fontWeight:600,color:"#1a1a1a"}}>Org Admin</div><div style={{fontSize:11,color:"#9ca3af"}}>Manage coaches, staff & settings</div></div>
            </button>}
            <button onClick={()=>{setActiveTab("profile");setShowMenu(false);}} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"11px 16px",borderBottom:"0.5px solid #f1f5f1",borderTop:"none",borderLeft:"none",borderRight:"none",background:"none",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <div style={{width:32,height:32,background:"#e6f4ec",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0}}>👤</div>
              <div><div style={{fontSize:13,fontWeight:600,color:"#1a1a1a"}}>My profile</div><div style={{fontSize:11,color:"#9ca3af"}}>{user.name} · {user.email}</div></div>
            </button>
            <a href="https://crickithub.com/guide.html" target="_blank" rel="noopener noreferrer" onClick={()=>setShowMenu(false)} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"11px 16px",borderBottom:"0.5px solid #f1f5f1",background:"none",textDecoration:"none",cursor:"pointer",fontFamily:"inherit"}}>
              <div style={{width:32,height:32,background:"#e6f4ec",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0}}>📖</div>
              <div><div style={{fontSize:13,fontWeight:600,color:"#1a1a1a"}}>User Guide</div><div style={{fontSize:11,color:"#9ca3af"}}>How it works — help & support</div></div>
            </a>
            <button onClick={()=>{logout();setShowMenu(false);}} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"11px 16px",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <div style={{width:32,height:32,background:"#fcebeb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0}}>🚪</div>
              <div><div style={{fontSize:13,fontWeight:600,color:"#A32D2D"}}>Sign out</div><div style={{fontSize:11,color:"#9ca3af"}}>{user.email}</div></div>
            </button>
          </div>
          {/* CrickitMatch branding */}
          <div style={{padding:"12px 16px 16px",borderTop:"0.5px solid #f1f5f1",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
            <div style={{fontSize:22,fontWeight:700,letterSpacing:"-0.5px",lineHeight:1}}>
              <span style={{color:G}}>Crickit</span><span style={{color:"#EF9F27"}}>Match</span>
            </div>
            <div style={{fontSize:9,color:"#9ca3af",letterSpacing:"0.1em",textTransform:"uppercase"}}>by ArcGain LLC</div>
          </div>
        </div>}
      </div>
      {/* no-match hint */}
      {!activeMatchId&&user.role!=="SUPERADMIN"&&user.role!=="PLAYER"&&activeTab!=="orgadmin"&&(
        <div style={{background:"#f0faf4",borderBottom:"0.5px solid #c8e6d6",padding:"7px 16px",fontSize:12,color:"#4a7a5e",display:"flex",alignItems:"center",gap:6}}>
          <span style={{opacity:.7}}>📅</span>
          <span>No match selected — go to <strong>Schedule</strong> to activate one.</span>
        </div>
      )}
      {/* nav */}
      <div style={{display:"flex",gap:2,padding:"8px 12px 0",flexWrap:"wrap",borderBottom:"2px solid rgba(0,0,0,0.08)",background:"#fff",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
        {tabs.map(t=>{
          const isActive=activeTab===t.id;
          const isScoring=["batting","bowling","fielding"].includes(t.id);
          return(
            <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{
              padding:"7px 11px",border:"none",borderBottom:isActive?`2.5px solid ${isScoring?"#6B21A8":G}`:"2.5px solid transparent",
              borderRadius:"6px 6px 0 0",background:isActive?(isScoring?"#fbf8fe":"#f0faf4"):"transparent",
              color:isActive?(isScoring?"#6B21A8":G):"#6b7280",cursor:"pointer",
              fontSize:12,fontWeight:isActive?700:500,fontFamily:"inherit",
              display:"flex",flexDirection:"column",alignItems:"center",gap:2,minWidth:44,
              transition:"all .12s",marginBottom:-2,
            }}>
              <span style={{fontSize:15,lineHeight:1}}>{t.icon}</span>
              <span style={{whiteSpace:"nowrap"}}>{t.id==="report"&&reportLocked&&user.role==="COACH"?t.label+" 🔒":t.label}</span>
            </button>
          );
        })}
      </div>
      {/* content */}
      <div style={{padding:"14px 14px 0"}}>
        {/* Match context banner — shown on scoring tabs when a match is active */}
        {activeMatch&&["batting","bowling","fielding","report","notes"].includes(activeTab)&&(
          <div style={{background:"linear-gradient(135deg,#0f4a2c 0%,#1A7A4A 100%)",borderRadius:12,padding:"11px 14px",marginBottom:12,display:"flex",alignItems:"center",gap:12,boxShadow:"0 2px 12px rgba(26,122,74,0.25)"}}>
            <div style={{width:38,height:38,background:"rgba(255,255,255,0.12)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <circle cx="11" cy="11" r="8.5" stroke="white" strokeWidth="1.5"/>
                <path d="M6.5 11 Q11 6.5 15.5 11 Q11 15.5 6.5 11Z" fill="white" opacity="0.9"/>
              </svg>
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:14,fontWeight:700,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>vs {activeMatch.opponent||"Opponent"}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginTop:1}}>{activeMatch.date||""}{activeMatch.tournament?` · ${activeMatch.tournament}`:""}{matchFrozen?" · 🔒 Frozen":""}</div>
            </div>
            {saveMsg&&<span style={{fontSize:11,background:"rgba(255,255,255,0.18)",padding:"3px 10px",borderRadius:20,color:"#fff",whiteSpace:"nowrap",flexShrink:0}}>{saveMsg}</span>}
          </div>
        )}
        {page()}
      </div>

      {/* ── Admin modal overlay ── */}
      {showAdminModal&&(user.role==="COACH"||user.role==="MANAGER")&&<div
        style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:998,display:"flex",alignItems:"flex-end",justifyContent:"center"}}
        onClick={e=>{if(e.target===e.currentTarget)setShowAdminModal(false);}}>
        <div style={{background:"#fff",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:980,maxHeight:"88vh",overflowY:"auto",boxShadow:"0 -4px 32px rgba(0,0,0,0.18)"}}>
          <div style={{position:"sticky",top:0,background:"#fff",borderBottom:"0.5px solid rgba(0,0,0,0.08)",padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderRadius:"16px 16px 0 0",zIndex:1}}>
            <div style={{fontSize:15,fontWeight:700,color:"#1a1a1a"}}>Org Admin</div>
            <button onClick={()=>setShowAdminModal(false)} style={{background:"rgba(0,0,0,0.08)",border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:18,color:"#6b7280",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"inherit"}}>×</button>
          </div>
          <div style={{padding:"16px"}}>
            <OrgAdmin user={user} teamMeta={teamMeta} setTeamMeta={setTeamMeta} onSaveTeamMeta={saveTeamMeta} saveMsg={saveMsg} apiFetch={apiFetch} canSeeAdminCode={canSeeAdminCode}/>
          </div>
        </div>
      </div>}
    </div>
  );
}
